import { StringsType } from "./StringsKeys";

const fr: StringsType = {
  open: "Ouvrir",
  import: "Importer",
  french: "Français",
  english: "Anglais",
  hello: "Bonjour",
  dashboard: "Tableau de bord",
  createAccount: "Créer un compte",
  createClient: "Créer un client",
  clientName: "Nom du Client",
  clientEmail: "Email du Client",
  clientPhone: "Téléphone du Client",
  customerSince: "Client Depuis",
  clientStatus: "Statut du Client",
  riskLevel: "Niveau de Risque",
  risk: "Risque",
  profileRating: "Évaluation du Profil",
  consolidatedBalance: "Solde Consolidé",
  folderStatus: "Statut du Dossier",
  completionPercentage: "Pourcentage de Complétion",
  lastUpdated: "Dernière Mise à Jour",
  actions: "Actions",
  viewDetails: "Voir les Détails",
  details: "Détails",
  compare: "Comparer",
  edit: "Modifier",
  delete: "Supprimer",
  assignAdvisor: "Assigner un Conseiller",
  updateRiskLevel: "Mettre à Jour le Niveau de Risque",
  searchClients: "Rechercher des clients...",
  filterByAgency: "Filtrer par Agence",
  filterByStatus: "Filtrer par Statut",
  filterByRiskLevel: "Filtrer par Niveau de Risque",
  filterByAdvisor: "Filtrer par Conseiller",
  allAgencies: "Toutes les Agences",
  allStatuses: "Tous les Statuts",
  allRiskLevels: "Tous les Niveaux de Risque",
  allAdvisors: "Tous les Conseillers",
  active: "Actif",
  inactive: "Inactif",
  dormant: "Dormant",
  moderate: "Modéré",
  high: "Élevé",
  veryHigh: "Très Élevé",
  low: "Faible",
  assigned: "Assigné",
  unassigned: "Non Assigné",
  totalClients: "Total des Clients",
  activeClients: "Clients Actifs",
  highRiskClients: "Clients à Risque Élevé",
  unassignedClients: "Clients Non Assignés",
  totalPortfolioValue: "Valeur Totale du Portefeuille",
  averageProfileRating: "Évaluation Moyenne du Profil",
  loadingClients: "Chargement des clients...",
  noClientsFound: "Aucun client trouvé",
  clientDetails: "Détails du Client",
  accountInformation: "Information sur le compte",
  clientInformation: "Information sur le Client",
  applicantContactDetails: "Coordonnées du demandeur",
  incomeInformation: "Information sur les revenus",
  accountType: "Type de compte",
  fullName: "Nom complet",
  businessKey: "Business Key",
  dateOfBirth: "Date de naissance",
  phone: "Téléphone",
  incomeSource: "Source de revenus",
  requiredDocuments: "Documents requis",
  documentsPending: "Documents en attente",
  uploadAllDocuments: "Importer tous les documents",
  documentRequired: "Document requis",
  documentOptional: "Document optionnel",
  upload: "Importer",
  documentsProcessed: "Documents traités",
  progress: "Progression",
  loadingDocuments: "Chargement des documents...",
  documentLoadingError: "Erreur lors du chargement des documents requis",
  retryLoadingDocuments: "Réessayer",
  addNewClient: "Ajouter un Nouveau Client",
  exportData: "Exporter les Données",
  refreshData: "Actualiser les Données",
  percent: "%",
  documents: "Documents",

  // Form Steps
  personalInformation: "Informations personnelles",
  contactAddressDetails: "Coordonnées et adresse",
  professionalFamilyInformation: "Informations professionnelles et familiales",
  professionalInformation: "Informations professionnelles",
  familyInformation: "Informations familiales",
  summary: "Résumé",

  // Personal Information Fields
  name: "Nom",
  lastName: "Nom de famille",
  firstName: "Prénom(s)",
  motherFullName: "Nom complet de la mère",
  nationality: "Nationalité",
  spokenLanguage: "Langue parlée",
  gender: "Genre",
  male: "Masculin",
  female: "Féminin",
  documentType: "Type de document",

  // Contact Details Fields
  mobilePhone: "Téléphone mobile",
  email: "Email",
  homePhone: "Téléphone fixe",
  countryOfResidence: "Pays de résidence",
  cityMunicipality: "Ville/Commune",
  address: "Adresse",
  postalAddressBP: "Adresse postale (BP)",
  geographicalLandmark: "Point de repère géographique",
  postalBox: "Boîte postale",
  postalCode: "Code postal",

  // Professional Information Fields
  isOwner: "Êtes-vous propriétaire ?",
  monthlyIncome: "Revenu mensuel",
  hasOtherIncome: "Autres revenus ?",
  otherIncomeAmount: "Montant des autres revenus",
  professionalCategory: "Catégorie professionnelle",
  profession: "Profession",
  employer: "Employeur",
  officePhone: "Téléphone du bureau",
  educationLevel: "Niveau d'éducation",
  maritalStatus: "Situation matrimoniale",
  numberOfChildren: "Nombre d'enfants",
  partnerFirstName: "Prénom du conjoint(e)",
  partnerLastName: "Nom du conjoint(e)",
  fatherLastName: "Nom du père",
  fatherFirstName: "Prénom du père",
  motherMaidenName: "Nom de jeune fille de la mère",
  motherFirstName: "Prénom de la mère",
  countryOfBirth: "Pays de naissance",
  dependents: "Personnes à charge",

  // Form Validation Messages
  fieldRequired: "Ce champ est requis",
  fieldLimited: "Ce champ est limité à 50 caractères",
  validName: "Ce champ doit contenir au moins 3 caractères",
  phoneNumberInvalid: "Numéro de téléphone invalide",
  phoneNumberTenDigits: "Le numéro doit comporter exactement 10 chiffres",
  invalidEmailFormat: "Format d'email invalide",
  mustBeGreaterThanZero: "Doit être supérieur à 0",
  otherIncomeRequired:
    "Le montant des autres revenus est requis quand d'autres revenus sont sélectionnés",

  // Form Status Messages
  formCompleteReady: "Formulaire complet et prêt à être soumis",
  formIncompleteReview: "Formulaire incomplet - Veuillez vérifier",
  formCompleteMessage:
    "Tous les champs requis ont été remplis. Vous pouvez maintenant soumettre le formulaire.",
  formIncompleteMessage:
    "Certains champs requis sont manquants ou incomplets. Veuillez revenir en arrière et compléter tous les champs requis avant de soumettre.",

  // Navigation
  previous: "Précédent",
  next: "Suivant",
  paginationPageSize: "par page",
  paginationPageInfo: "Page {current} / {total}",
  submit: "Soumettre",
  submitting: "Soumission en cours...",
  back: "Retour",

  // Form Steps Description
  personalInfoDescription: "Nom, Prénom(s), genre, nationalité...",
  contactInfoDescription: "Adresse, Téléphone, Email",
  professionalInfoDescription: "Revenus, actifs, état civil",
  summaryDescription: "Vérifiez toutes les informations avant soumission",

  // Currency
  currency: "F CFA",

  // Placeholders
  placeholderLastName: "Ex: KOUASSI",
  placeholderFirstName: "Ex: Bernard",
  placeholderMotherName: "Ex: Bernardette KOUASSI",
  placeholderEmail: "Ex: mail@gmail.com",
  placeholderAddress: "Ex: Côte d'Ivoire, Abidjan, Cocody, Cité Verdoyante",
  placeholderLandmark: "Ex: Riviera 2, Anono, Près de, En face de...",
  placeholderProfession: "Ex: Testeur",
  placeholderEmployer: "Ex: BOX AFRICA",

  // Cities
  abidjan: "Abidjan",
  yamoussoukro: "Yamoussoukro",
  bouake: "Bouaké",
  sanPedro: "San-Pédro",
  korhogo: "Korhogo",
  man: "Man",
  gagnoa: "Gagnoa",
  daloa: "Daloa",

  // Other
  other: "Autre",
  notProvided: "Non fourni",
  yes: "Oui",
  no: "Non",
  administration: "Administration",
  rolesAndPermissions: "Rôles & Permissions",
  users: "Utilisateurs",
  attestations: "Attestations",
  offboarding: "Offboarding",
  jitAccess: "Accès JIT",
  settings: "Paramètres",
  sodRules: "Règles SoD",
  adMapping: "Mappages AD",
  runtimeDecisions: "Décisions Runtime",
  enterprise: "Enterprise",
  expired: "Expiré",
  newRole: "Nouveau rôle",
  role: "Rôle",
  newRequest: "Nouvelle demande",
  publishRole: "Publier un rôle",
  publishRoleAttestation:
    "J’atteste que ce rôle est conforme aux politiques de sécurité et de conformité",
  publishingRole: "Publication du rôle...",
  rolePublishedSuccess: "Le rôle a été publié avec succès.",
  rolePublishedError: "La publication du rôle a échoué.",
  confirmPublishRoleTitle: "Confirmer la publication du rôle",
  confirmPublishRoleDescription:
    "Cette action publiera définitivement ce rôle et le rendra disponible en production.",
  simulateUser: "Simuler utilisateur",
  mapAD: "Mapper AD",
  save: "Enregistrer",
  search: "Recherche",
  selectValue: "Sélectionner une valeur...",
  searchValue: "Rechercher une valeur...",
  noValueFound: "Aucune valeur trouvée.",
  prospectsSearch: "Nom, email, téléphone, ...",
  prospectsSearchSection: "Rechercher un prospect",
  prospectsSearchFilters: "Affiner le pipeline",
  prospectsShowFilters: "Afficher la recherche",
  prospectsHideFilters: "Masquer la recherche",
  statusProspect: "Prospect",
  statusPendingScreening: "En revue conformité (L1/EDD)",
  statusRefused: "Refusé",
  statusFilterHelp: "Ce que chaque statut signifie",
  statusProspectHint:
    "Dossier en cours de constitution, pas encore enregistré comme client. Affiché avec les deux autres statuts quand aucun filtre n'est choisi.",
  statusPendingScreeningHint:
    "Client déjà screené et enregistré au référentiel mais sans compte bancaire, en attente d'une décision de revue conformité (L1 ou EDD 4-yeux). Le compte est créé à l'approbation de la revue.",
  statusRefusedHint:
    "Revue défavorable : le client reste enregistré, aucun compte n'est créé. La conformité peut remettre le dossier à l'étude, il repasse alors en attente de screening.",
  typeFilterHelp: "Ce que chaque segment recouvre",
  physicalPersonHint:
    "Particulier. C'est le segment de la très grande majorité des dossiers, affiché « PP » dans la liste.",
  legalPersonHint:
    "Entreprise ou organisation, affichée « PM ». Son dossier porte en plus une identité légale (forme juridique, RCCM) et ses personnes liées.",
  channelFilterHelp: "Par quelle voie le dossier est entré en relation",
  channelDigitalHint:
    "Ouvert à distance par le parcours self-onboarding, sans passage en agence ni vérification biométrique. Le scoring en tient compte.",
  channelAgencyHint:
    "Créé en agence par un conseiller, avec vérification biométrique du client.",
  channelCbsImportHint:
    "Client déjà connu du core banking, repris dans le référentiel par synchronisation et non créé ici.",
  periodCreated: "Période de création",
  periodFilterHelp: "Comment la période est appliquée",
  periodFilterHint:
    "Filtre sur la date de création du dossier. Les deux bornes sont incluses : du 1er au 1er rend bien les dossiers créés ce jour-là. La liste n'est filtrée qu'une fois les deux dates choisies.",
  channelDigital: "Digital",
  channelAgency: "Agence",
  channelCbsImport: "Repris du core banking",
  prospectsSearchFiltersHint:
    "Filtrez les prospects par type, statut et canal de création.",
  reset: "Réinitialiser",
  results: "Résultats",
  status: "Statut",
  criticality: "Criticité",
  frequency: "Cadence",
  sod: "SoD",
  help: "Aide",
  views: "Vues",
  generalInformation: "Informations générales",
  prefilledFromCreationStep:
    "Déjà renseigné à la création du prospect. Cliquez sur Modifier pour corriger.",
  matrixViewDescription: "Vue matricielle des rôles et permissions",
  usersDescription: "Gérez les utilisateurs de la plateforme",
  usersSearchHint: "Nom, login ou email",
  roleAndOwner: "Rôle & Owner",
  archived: "Archivé",
  draft: "Brouillon",
  published: "Publié",
  none: "Aucun",
  twoSod: "2 SoD →",
  consult: "Consulter",
  modify: "Modifier",
  approve: "Approuver",
  export: "Exporter",
  compliance: "Conformité",
  credit: "Crédit",
  gdpr: "RGPD",
  linesPerPage: "Lignes par page",
  pageInfo: "Page 1 sur 8",
  notifications: "Notifications",
  noNotifications: "Aucune notification",
  noNotificationsHint:
    "Les alertes sur vos dossiers, la conformité et l'administration s'afficheront ici.",
  notificationsUnread: "{{count}} non lue(s)",
  notificationsTabAll: "Toutes",
  notificationsTabUnread: "Non lues",
  notificationsEmptyUnread: "Aucune notification non lue",
  notificationsToday: "Aujourd'hui",
  notificationsYesterday: "Hier",
  notificationsEarlier: "Plus anciennes",
  markAllAsRead: "Tout lire",

  // Form Steps Title
  formSteps: "Étapes du formulaire",
  fillInInformation: "Remplissez les informations",

  // Error Messages
  pleaseFixErrors: "Veuillez corriger les erreurs suivantes :",
  failedToSubmit: "Échec de la soumission du formulaire. Veuillez réessayer.",
  formSubmittedSuccessfully: "Formulaire soumis avec succès !",
  contactInfoUpdated: "Les coordonnées ont été mises à jour avec succès.",

  // Step Status
  current: "actuel",
  completed: "terminé",
  pending: "en attente",
  error: "erreur",

  failedGettingUserRole: "Échec de la récupération du rôle de l'utilisateur",
  backToHome: "Retour à l'accueil",
  pageNotFound: "Page non trouvée",
  WeCouldNotFindThePageYouAreLookingFor:
    "Nous n'avons pas pu trouver la page que vous recherchez.",
  internalServerError:
    "Le serveur rencontre des difficultés temporaires. Veuillez réessayer plus tard.",
  oopsSomethingWentWrong: "Oups, quelque chose s'est mal passé",
  youAreNotAuthorized: "Vous n'êtes pas autorisé à accéder à cette page",
  youDonTHavePermissionToAccessThisPage:
    "Vous n'avez pas la permission d'accéder à cette page",
  permissionDeniedPageDescription:
    "Votre compte ne dispose pas des droits nécessaires. Contactez votre administrateur si vous avez besoin d’un accès.",
  welcomeTo: "Bienvenue à",
  pleaseSignIn:
    "Veuillez vous connecter à votre compte et commencer l'aventure",
  password: "Mot de passe",
  rememberMe: "Se souvenir de moi",
  loginHeroTitle: "Espace Collaborateur",
  loginHeroSubtitle:
    "Accédez à vos outils de gestion de conformité, KYC et dossiers clients en toute sécurité.",
  loginSecurityNote: "Plateforme sécurisée et auditée",
  loginFormSecurityNote: "Connexion sécurisée et chiffrée",
  loginHelperText: "Saisissez vos identifiants professionnels pour continuer.",
  loginEmailPlaceholder: "ex : agnese@bni.ci",
  credentials: "Informations d'identification",
  badCredentials: "Authentification échouée.",
  emailOrPasswordInvalid: "Email ou mot de passe invalide",
  forgotPassword: "Mot de passe oublié",
  login: "Se connecter",
  firstLoginResetTitle: "Première connexion",
  firstLoginResetSubtitle:
    "Pour des raisons de sécurité, vous devez définir un nouveau mot de passe avant de continuer.",
  currentPassword: "Mot de passe actuel",
  newPasswordChoice: "Nouveau mot de passe",
  confirmNewPassword: "Confirmer le nouveau mot de passe",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
  passwordResetSuccess: "Mot de passe réinitialisé avec succès.",
  passwordResetSuccessReconnectHint:
    "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  changePassword: "Enregistrer le nouveau mot de passe",
  passwordStrengthWeak: "Faible",
  passwordStrengthFair: "Moyenne",
  passwordStrengthGood: "Bonne",
  passwordStrengthStrong: "Forte",
  passwordStrengthHint: "Niveau de sécurité du mot de passe",
  passwordRequirementMinLength: "Au moins 8 caractères",
  passwordRequirementUppercase: "Au moins une majuscule",
  passwordRequirementLowercase: "Au moins une minuscule",
  passwordRequirementDigit: "Au moins un chiffre",
  passwordRequirementSpecial: "Au moins un caractère spécial",
  passwordConfirmMatches: "Les mots de passe sont identiques",
  passwordMustDifferFromCurrent:
    "Le nouveau mot de passe doit être différent de l’actuel",
  inputLogin: "Identifiant",
  newOnOurPlatform: "Nouveau sur notre plateforme",
  createAnAccount: "Créer un compte",
  or: "ou",
  errorOccurred: "Une erreur s'est produite",
  unexpectedOrNetworkError: "Erreur inattendue ou réseau",
  unauthorizedAction: "Action non autorisée",
  subscriptionRequired: "Abonnement requis",
  resourceNotFound: "Ressource non trouvée",
  invalidInfos: "Informations invalides",
  conflictEncountered: "Conflit rencontré",
  unavailableServer: "Serveur non disponible",
  logoutFailed: "Échec de la déconnexion",
  logout: "Déconnexion",
  sessionExpired: "Session expirée",
  sessionExpiredMessage:
    "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
  externalResourceUnavailable:
    "Le service est temporairement indisponible. Veuillez réessayer plus tard.",
  unexpectedError:
    "Erreur inattendue, veuillez réessayer ou réessayer plus tard.",
  requiredField: "Ce champ est requis",
  invalidEmail: "Email invalide",
  invalidPassword: "Mot de passe invalide",
  failed: "Échoué",
  userAvatar: "Avatar de l'utilisateur",
  operationFailed: "Opération échouée",
  clientDataNotAvailable: "Données client non disponibles.",
  FailedToLogoutUser: "Échec de la déconnexion de l'utilisateur",
  tryAgain: "Réessayer",
  activities: "Activités",
  customers: "Clients",
  prospects: "Prospects",
  pipeline: "Pipeline",
  possibleMatch: "Possible match",
  duplicates: "Doublons",
  individuals: "Particuliers",
  professionals: "Professionnels",
  products: "Produits",
  inquirie_create_client: "Créer un client",
  inquiries: "Demandes",
  inquirie: "Demande",
  folders: "Dossiers",
  marketing: "Marketing",
  atm: "Agences & ATM",
  period: "Période",
  day: "Jour",
  week: "Semaine",
  month: "Mois",
  trimester: "Trimestre",
  semester: "Semestre",
  year: "Année",
  compareToPreviousDay: "comparé à hier",
  compareToPreviousWeek: "comparé à la semaine dernière",
  compareToPreviousMonth: "comparé au mois dernier",
  compareToPreviousTrimester: "comparé au trimestre dernier",
  compareToPreviousSemester: "comparé au semestre dernier",
  compareToPreviousYear: "comparé à l'année dernière",
  client: "Client",
  client360: "Clients 360",
  client360SearchFilters: "Affiner la recherche client",
  client360SearchFiltersHint:
    "Combinez les critères pour filtrer la liste des clients.",
  client360SearchSection: "Rechercher un client",
  client360ShowFilters: "Afficher la recherche",
  client360HideFilters: "Masquer la recherche",
  agency: "Agence",
  advisorName: "Conseiller",
  since: "Depuis",
  profile: "Profil",
  totalBalance: "Solde total",
  columns: "Colonnes",
  noResults: "Aucun résultat.",
  selectedRows: "ligne(s) sélectionnée(s)",
  advancedFilters: "Filtres avancés",
  kpi: "KPI",
  clear: "Effacer",
  call: "Appel",
  activity: "Activité",
  accountsProducts: "Comptes & Produits",
  transactions: "Transactions",
  analyse: "Analyse risque",
  informations: "Informations",
  notesInteractions: "Notes & Interactions",
  networkError:
    "Problème de connexion. Vérifiez votre connexion internet et réessayez.",
  customersPerPage: "Clients par page",
  loading: "Chargement",
  signature: "Signature",
  clientSince: "Client depuis",
  placeOfBirth: "Lieu de naissance",
  documentNumber: "Numéro de document",
  dateOfIssue: "Date d'émission",
  countryOfIssue: "Pays d'émission",
  placeOfDelivery: "Lieu de délivrance",
  documentReference: "Réf. doc",
  identityDocumentType: "Type de pièce d'identité",
  identityDocumentNumber: "Numéro de pièce d'identité",
  nationalIdNumber: "Numéro National de l'Identité (NNI)",
  expiryDate: "Date d'expiration",
  validatedPart: "Pièce validé",
  completionLevel: "Niveau de complétion",

  // RBAC Matrix - Additional keys
  matrixRBAC: "Matrice RBAC",
  rbacMatrixSearchSection: "Rechercher un rôle",
  rbacMatrixSearchHint: "Nom ou libellé du rôle",
  rbacMatrixFilters: "Affiner la matrice",
  rbacMatrixFiltersHint:
    "Filtrez par statut, criticité, cadence de revue et conformité SoD.",
  rolesAndAttributions: "Rôles & Attributions",
  medium: "Moyen",
  dependencies: "Dépendances",
  nbPermissions: "Nbre permissions",
  rulesManagement: "Règles",
  newRule: "Nouvelle règle",
  ruleName: "Nom de la règle",
  ruleDescription: "Description",
  noRulesFound: "Aucune règle trouvée",
  invalidPhoneFormat: "Format de téléphone invalide",

  // User
  user: "Utilisateur",
  state: "État",
  presence: "Présence",
  backup: "Backup",
  permissions: "Permissions",

  // Documents
  category: "Catégorie",
  date: "Date",
  send: "Envoyer",
  download: "Télécharger",
  documentDownloaded: "Document téléchargé",
  documentDownloadError: "Erreur lors du téléchargement du document",
  documentPreviewTitle: "Aperçu du document",
  documentPreviewError: "Impossible de charger l'aperçu du document",
  documentPreviewNotSupported: "Aperçu non disponible pour ce type de fichier",
  screeningReportDownloaded: "Rapport de screening téléchargé",
  screeningReportDownloadError:
    "Erreur lors du téléchargement du rapport de screening",
  documentPerPage: "Documents par page",
  // Demandes - Sélection manuelle UI
  filters: "Filtres",
  channel: "Canal",
  country: "Pays",
  segment: "Segment",
  availableRequests: "Demandes disponibles",
  continue: "Continuer",
  requiredFields: "Champs requis",
  missingFields: "Champs manquants",
  // Request items
  request_create_account: "Ouverture de compte",
  request_create_account_desc: "Démarrer une ouverture de compte bancaire.",
  request_onboarding_a2: "Démarrer Onboarding (A2)",
  request_onboarding_a2_desc:
    "Ouvrir un dossier d’onboarding A2 pour un client/prospect.",
  request_regen_otp: "Régénérer accès (OTP)",
  request_regen_otp_desc:
    "Envoyer des instructions OTP pour réinitialisation mot de passe / reconnexion.",
  request_secure_upload_reminder: "Relance upload sécurisé",
  request_secure_upload_reminder_desc:
    "Envoyer une relance avec lien sécurisé pour dépôt de pièces.",
  request_id_replacement: "Remplacement de pièce d’identité",
  request_id_replacement_desc:
    "Remplacer une pièce d’identité expirée ou invalide.",
  request_address_change: "Changement d’adresse",
  request_address_change_desc:
    "Mettre à jour l’adresse et justificatifs associés.",
  request_four_eyes: "4‑yeux documentaire",
  request_four_eyes_desc:
    "Déclencher un contrôle à 4‑yeux sur un dossier documentaire.",
  request_rekcy: "Déclencher Re‑KYC",
  request_rekcy_desc:
    "Ouvrir une demande Re‑KYC selon la politique en vigueur.",
  request_export_kpi: "Exporter KPI conformité",
  request_export_kpi_desc:
    "Demande d’export KPIs (complétude, expirés, erreurs OCR, ré‑usage).",
  request_contact_update: "Modification coordonnées",
  request_contact_update_desc:
    "Mettre à jour les informations de contact du client.",
  request_account_closure: "Clôture de compte",
  request_account_closure_desc: "Clôturer un compte bancaire actif.",
  request_add_proxy: "Ajouter une procuration (mandataire)",
  request_add_proxy_desc:
    "Créer/ajouter une procuration pour un client (portée et limites).",
  request_pep_declaration: "Déclaration PEP",
  request_pep_declaration_desc:
    "Déclarer ou mettre à jour le statut PEP (client ou proche).",
  request_civil_status_change: "Changement d'état civil",
  request_civil_status_change_desc:
    "Déclarer un changement d'état civil avec pièces justificatives.",
  request_add_legal_representative: "Ajout représentant légal",
  request_add_legal_representative_desc:
    "Ajouter/désigner un représentant légal avec justificatifs.",
  request_income_employer_update: "Mise à jour revenu et employeur",
  request_income_employer_update_desc:
    "Mettre à jour la rémunération, l'employeur et le secteur d'activité.",
  request_family_situation_change: "Changement de situation familiale",
  request_family_situation_change_desc:
    "Mettre à jour le régime matrimonial, le conjoint et le nombre d'enfants.",
  request_create_prospect: "Créer un prospect",
  request_create_prospect_desc:
    "Saisir la création d’un prospect et déclencher le flux associé.",
  demandes: "Demandes",
  nouvelleDemande: "Nouvelle Demande",

  // Prospects
  type: "Type",
  contact: "Contact",
  accessStatus: "Statut accès",
  canal: "Canal",
  screening: "Screening",
  additionalDocuments: "Documents & Pièces supplémentaires",
  lastUpdate: "Dernière MAJ",
  createdAt: "Créé le",

  birthDate: "Date de naissance",
  notes: "Notes",
  motif: "Motif",
  address1: "Adresse 1",
  address2: "Adresse 2",
  city: "Ville",
  deliveredDate: "Date de délivrance",
  IdDocType: "Type de document",
  IdDocNumber: "Numéro de document",
  birthPlace: "Lieu de naissance",

  // Onboarding
  identification: "Identification",
  update: "Editer",
  editable: "Editable",
  readOnly: "Lecture seule",

  // client
  clients: "Clients",
  selectClient: "Sélectionner un client",
  selectClientDescription: "Recherchez un client pour ouvrir sa vue 360.",
  clientSearch: "Nom, Party ID, NCI, téléphone, email",
  sensitiveClientsFilter: "Sensibilité",
  sensitiveFilterAll: "Tous",
  sensitiveFilterWithout: "Non sensible",
  sensitiveFilterWith: "Sensible",
  kyc: "KYC",
  partyid: "Party ID",
  account: "Comptes",

  synthese: "Synthèse",
  risqueReKyc: "Risques & Re-KYC",
  scoringProfilTitle: "Profil Risque",
  scoringScore: "Score",
  scoringDeclencheurs: "Déclencheurs",
  scoringVoirDetails: "Voir détails",
  scoringPolitiqueRisque: "Politique Risque",
  scoringNotCalculated: "Profil de risque non encore calculé",
  scoringClasseDeRisque: "Classe de risque",
  scoringNonCalcule: "Non calculé",
  scoringTrackA: "Référentiel Identité",
  scoringTrackB: "Contrôle externe",
  scoringCombined: "Score combiné",
  scoringDecision: "Décision",
  scoringCompleteness: "Complétude",
  scoringScoredAt: "Scoré le",
  scoringScoredBy: "Scoré par",
  scoringTrigger: "Déclencheur",
  scoringFactorsTitle: "Facteurs",
  scoringLoadError: "Le chargement du profil de risque a échoué.",
  scoringClassification: "Classification",
  scoringRawScore: "Score brut",
  scoringWeight: "Poids",
  scoringHardOverrides: "Dérogations",
  scoringEntity: "Entité",
  scoringEntityLabel: "Libellé",
  scoringLevel: "Niveau",
  scoringPoints: "Points",
  accounts: "Comptes",
  accountSingular: "Compte",
  consents: "Consentements",
  timeline: "Timeline",
  fiche: "Fiche client",

  // Create Prospect Page
  createProspectPhysicalPersonTitle:
    "Créer un prospect — Personne physique (PP) (BCEAO)",
  requiredInformation: "Informations obligatoires",
  optionalInformation: "Informations optionnelles",
  physicalPerson: "Personne Physique",
  sex: "Sexe",
  masculine: "Masculin",
  feminine: "Féminin",
  selectOption: "Sélectionnez",
  cni: "CNI",
  passport: "PASSEPORT",
  drivingLicense: "PERMIS DE CONDUIRE",
  notesOptional: "Notes (optionnel)",
  dateFormat: "jj/mm/aaaa",
  errorCreatingProspect: "Erreur lors de la création du prospect",
  prospectCreatedSuccessfully: "Prospect créé avec succès !",
  prospectCreatedRedirectMessage:
    "Votre prospect a été créé avec succès. Vous allez être redirigé...",
  requiredFieldsDisclaimer:
    "* champs obligatoires — au moins un contact (téléphone ou email).",
  cancel: "Annuler",
  create: "Créer",
  creating: "Création...",
  idType: "Type de pièce",
  idNumber: "N° pièce",
  issueDate: "Date délivrance",
  addressLine1: "Adresse (ligne 1)",
  addressLine2: "Adresse (ligne 2)",

  // New prospect form translations
  civilite: "Civilité",
  genre: "Genre",
  masculineShort: "M",
  feminineShort: "F",
  mr: "M.",
  mrs: "Mme.",
  miss: "Mlle.",
  mobile: "Téléphone portable",
  sendOTP: "Envoyer OTP",
  OTPSent: "OTP envoyé",
  verifyOTP: "Vérifier",
  otpCode: "Code de vérification",
  productOfInterest: "Produit d'intérêt",
  productsOfInterest: "Produits d'intérêt",
  intentComment: "Motif / Commentaire",
  intentCommentPlaceholder:
    "Précisez le motif ou ajoutez un commentaire… (280 caractères max.)",
  createProspectAccountObject: "Objet du compte",
  wantsContactForProducts: "Souhaite être contacté pour épargne/carte/crédit",
  validateAndContinue: "Valider & continuer",
  startOnboarding: "Démarrer Onboarding",
  coordinatesAndIntent: "Coordonnées & Intention",
  notesAndMentions: "Notes & @mentions",
  requestContext: "Contexte de la demande",
  what: "Type de demande",
  produit: "Produit",
  notDefined: "Non défini",
  characterLimit: "280 caractères",
  chooseOption: "Choisir",
  carte: "Carte",
  epargne: "Épargne",
  compteAVueXOF: "Compte à vue XOF",
  suivant: "Suivant",

  rm: "RM",
  relationshipManager: "Chargé de relation",
  prospectCreated: "Prospect créé",
  prospectCreatedModalDescription:
    "Souhaitez-vous enchaîner avec la collecte des pièces et consentements ?",
  prospectCreatedModalDescriptionPm:
    "Retrouvez-le depuis la liste des prospects pour poursuivre son traitement.",
  clientCreated: "Client créé avec succès",
  clientCreatedModalDescription:
    "Souhaitez-vous enchaîner sur la fiche client ?",
  nextStep: "Étapes suivantes",
  verifyRequiredDocuments: "Vérifier les pièces obligatoires du dossier.",
  confirmConsents: "Confirmer les consentements KYC et marketing.",
  goToProspectList: "Revenir à la liste prospects",
  continueOnboarding: "Continuer l’ouverture de compte",
  accessToClientProfile: "Accéder à la fiche client",
  continueClientProfile: "Continuer sur la fiche du client",
  generateClientAccess: "Générer un accès client",
  pepOnboardingSubmittedTitle: "Soumission réussie",
  pepOnboardingSubmittedDescription:
    "Le dossier a été enregistré et transmis pour traitement.",
  pepOnboardingComplianceFourEyesMessage:
    "Il a été envoyé en validation 4-yeux au service Conformité.",
  pepOnboardingAccountCreationPendingMessage:
    "Le compte client ne pourra être créé qu'après validation par le service Conformité.",
  createNewProspect: "Créer un nouveau prospect",
  onboardingGate_loading: "Vérification du screening en cours…",
  onboardingGate_error:
    "Impossible de récupérer le verdict du screening. Veuillez réessayer.",
  onboardingGate_unavailable:
    "Verdict de screening indisponible. Veuillez réessayer.",
  onboardingGate_pass_banner:
    "Screening conforme — la création du client est autorisée.",
  onboardingGate_outcome_created: "Le client a été créé avec succès.",
  onboardingGate_sanctions:
    "Création refusée : correspondance sanctions. Le service Conformité est notifié.",
  onboardingGate_pep:
    "Client PEP : le dossier est transmis au service Conformité pour revue 4-yeux. La Conformité prend le relais.",
  onboardingGate_screeningInProgress:
    "Screening en cours… Le verdict sera disponible dans un instant.",
  onboardingGate_softPass:
    "Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_outcome_createdRouted:
    "Le client a été créé. Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_routedReview:
    "Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_refresh: "Actualiser",
  onboardingGate_routed_title: "Dossier transmis à la Conformité",
  onboardingGate_sanctions_title: "Création refusée",

  onlyLetters: "Ce champ ne doit contenir que des lettres, espaces ou tirets",
  identityInformation: "Informations d'identité",
  companyIdentityInformation: "Identité entreprise",
  stepIncompleteHint: "Complétez cette étape pour continuer.",
  declarantContact: "Contact déclarant",
  companyName: "Raison sociale",
  registrationNumberOptional: "N° RCCM",
  contactPersonName: "Nom du contact",
  declarantRole: "Rôle du déclarant",
  pmOnboardingUnavailableTitle: "Fonctionnalité pas encore disponible",
  pmOnboardingUnavailableDescription:
    "L'onboarding en ligne des personnes morales est en cours de construction. Cette fonctionnalité sera disponible prochainement pour cette catégorie de prospects.",
  understood: "Compris",

  onboarding: "Onboarding",
  productIntent: "Intention / Intérêt produit",
  backgroundToRequest: "Contexte de la demande",
  infosIntent: "Coordonnées & Intention",
  addressProfile: "Coordonnées (adresse & profil)",
  salaryAmount: "Salaire (montant)",
  activitySector: "Secteur d'activité",
  stepEntreprise: "Entreprise",
  legalIdentificationKyb: "Identification légale (KYB)",
  addressAndContact: "Adresse & coordonnées",
  tradeName: "Nom commercial",
  companyPhone: "Téléphone entreprise",
  companyEmail: "Email entreprise",
  legalForm: "Forme juridique",
  registrationNumber: "N° RCCM",
  taxId: "Identifiant fiscal (NIF)",
  incorporationCountry: "Pays d'incorporation",
  incorporationDate: "Date de constitution",
  shareCapital: "Capital social (FCFA)",
  headOfficeAddress: "Adresse du siège social",
  financialAndAdministrative: "Données financières et administratives",
  authorizationNumber: "Numéro d'autorisation d'exercer",
  fiscalYearStart: "Début de l'exercice comptable",
  fiscalYearEnd: "Fin de l'exercice comptable",
  annualRevenue: "Chiffre d'affaires HT (XOF)",
  consolidatedRevenue: "Chiffre d'affaires consolidé HT (XOF)",
  netResult: "Résultat net (XOF)",
  totalAssets: "Total du bilan (XOF)",
  amountInvalid: "Saisissez un montant entier en francs CFA.",
  fiscalYearInvalid: "La fin de l'exercice doit suivre son début.",
  financialHint: "Transmises au CBS à l'ouverture du compte, à l'approbation.",
  corporateObject: "Objet social",
  legalFormSarl: "SARL",
  legalFormSa: "SA",
  legalFormSas: "SAS",
  legalFormGie: "GIE",
  legalFormHolding: "Holding",
  legalFormAssociation: "Association / ONG",
  legalFormPublicEntity: "Entité Publique",
  sectorCommerce: "Commerce général",
  sectorAgriculture: "Agriculture",
  sectorConstruction: "BTP / Construction",
  sectorRealEstate: "Immobilier",
  sectorForeignExchange: "Change manuel",
  sectorGambling: "Jeux d'argent",
  sectorFinancialServices: "Services financiers",
  sectorTransport: "Transport / Logistique",
  saveSuccessful: "Enregistré avec succès",
  saveFailed: "Échec de l'enregistrement",
  stepRepresentants: "Représentants",
  addRepresentative: "Ajouter un représentant / mandataire",
  removeRepresentative: "Retirer",
  activeSignatoryBlocksRemoval:
    "Cette personne est signataire actif d'un mandat en cours. Révoquez le mandat avant de la retirer.",
  alreadyKnownInSystem: "Déjà connu(e) dans le SI",
  representativesListTitle: "Représentants et mandataires",
  showDetails: "Détails",
  hideDetails: "Masquer",
  addedOn: "Ajouté le",
  identitySource: "Origine",
  sourceAgentInput: "Saisi manuellement",
  sourceRicProjection: "Projeté depuis le RIC",
  rolesHeld: "Rôles",
  addRole: "Ajouter un rôle",
  removeRole: "Retirer",
  lastRoleCannotBeRemoved: "Dernier rôle : non retirable",
  noRoleToAdd: "Tous les rôles disponibles sont déjà attribués",
  searchExistingPerson: "Rechercher une personne existante",
  searchPersonPlaceholder: "Nom du représentant...",
  noResultsFound: "Aucun résultat",
  manualEntry: "Saisie manuelle",
  chooseRole: "Choisir un rôle",
  possibleMatchesFound:
    "Un profil correspondant existe déjà — réutilisez-le ou confirmez qu'il s'agit d'une autre personne.",
  matchTypeExact: "Correspondance exacte",
  matchTypePartial: "Correspondance partielle — vérifiez avant de fusionner",
  reuseThisPerson: "Réutiliser cette personne",
  confirmDifferentPerson: "Il s'agit d'une autre personne",
  representativeAddedSuccess: "Représentant ajouté au dossier",
  removalNotSupportedYet:
    "Le retrait d'un représentant n'est pas encore possible : attribuez-lui plutôt un autre rôle si besoin.",
  alreadyLinkedRoles: "Rôles déjà tenus",
  functionGerant: "Gérant",
  functionDG: "Directeur Général",
  functionPDG: "Président-Directeur Général",
  functionPresident: "Président",
  functionAdministrateur: "Administrateur",
  residenceCountry: "Pays de résidence",
  identityDocumentSectionTitle: "Pièce d'identité",
  runOcr: "Lancer l'OCR",
  uploadDocumentToContinue:
    "Téléversez la pièce d'identité et lancez l'OCR pour continuer.",
  representativeDocumentType: "Type de pièce",
  documentTypeCNI: "CNI",
  documentTypePassport: "Passeport",
  documentTypeResidencePermit: "Titre de séjour",
  mandateSectionTitle: "Mandat & pouvoirs",
  mandateReference: "Référence du mandat",
  mandateType: "Type de mandat",
  mandateStartDate: "Date de début",
  mandateEndDate: "Date de fin",
  mandateCertifiedDocument: "Document certifié",
  mandateTypeStatutory: "Représentant légal statutaire",
  mandateTypeProxy: "Procuration",
  mandateTypeDelegation: "Délégation",
  mandateTypeBankMandate: "Mandat bancaire",
  mandatesSectionTitle: "Mandataires",
  addMandate: "Ajout de mandataire",
  mandateRole: "Rôle du mandataire",
  mandateRolePrincipal: "Principal",
  mandateRoleSimple: "Simple",
  mandateReason: "Motif / justification",
  mandateSaved: "Mandataire enregistré avec succès",
  mandateSaveFailed: "Échec de l'enregistrement du mandataire",
  mandateRemoved: "Mandataire retiré avec succès",
  mandateRemoveFailed: "Échec du retrait du mandataire",
  mandateRemoveConfirmTitle: "Retirer le mandataire",
  mandateRemoveConfirmDescription:
    "Fournissez un motif de retrait. Ce motif sera conservé dans l'historique du mandat.",
  mandateRemoveReasonLabel: "Motif de retrait",
  mandateRemoveReasonPlaceholder:
    "Décrivez pourquoi le mandataire est retiré… (500 caractères max.)",
  mandateRemoveReasonRequired:
    "Un motif est requis pour retirer le mandataire.",
  mandatePrincipalAlreadyExists:
    "Un mandataire principal actif existe déjà. Seuls des mandataires simples peuvent être ajoutés.",
  mandateListEmpty: "Aucun mandataire enregistré",
  stepActionnariat: "Actionnariat & UBO",
  significantShareholdersQuestion:
    "Y a-t-il des actionnaires détenant ≥ 25% du capital ou des droits de vote ?",
  addShareholder: "Ajouter un actionnaire",
  removeShareholder: "Retirer l'actionnaire",
  personTypePP: "Personne physique",
  personTypePM: "Personne morale",
  percentageHeldLabel: "% détenu",
  shareholderLegalName: "Raison sociale",
  shareholderRegistryNumber: "N° RCCM",
  uboEffectifLabel: "UBO effectif",
  belowUboThresholdLabel: "Sous le seuil 25%",
  shareholdingSumError:
    "La somme des pourcentages des actionnaires directs doit égaler 100%.",
  completeRequiredFieldsMessage: "Veuillez compléter les champs obligatoires.",
  controlGraphTitle: "Graphe de contrôle",
  exportGraph: "Exporter",
  exportComingSoon: "À venir",
  shareholderIdentificationDate: "Date identification",
  shareholderLastVerificationDate: "Dernière vérification",
  shareholderProofSource: "Source preuve",
  legendPpIdentified: "PP identifié",
  legendPmIntermediary: "PM intermédiaire",
  legendBelowThreshold: "Sous le seuil",

  stepDocuments: "Documents",
  documentChecklistTitle: "Documents requis",
  documentChecklistDescription:
    "Cette checklist est générée selon la forme juridique et le pays de l'entreprise.",
  documentChecklistLoading: "Génération de la checklist documentaire…",
  documentChecklistEmpty: "Aucune checklist documentaire pour le moment.",
  documentProvided: "Fourni",
  documentRequiredBadge: "Requis",
  documentChecklistIncompleteMessage:
    "Tous les documents requis doivent être marqués comme fournis avant de continuer.",
  documentIndeterminateBadge: "Indéterminé",
  documentChecklistIndeterminateMessage:
    "Les exigences documentaires n'ont pas pu être déterminées — vérifiez auprès de la conformité avant de continuer.",
  documentStatusAttendue: "Attendue",
  documentStatusRecue: "Reçue, en attente de contrôle",
  documentStatusValide: "Validée",
  documentStatusExpiree: "Expirée, à renouveler",
  documentOptionalBadge: "Optionnel",
  documentRegulatorySource: "Norme appliquée :",
  documentUploadButton: "Déposer la pièce",
  documentReplaceButton: "Remplacer la pièce",
  documentUploadUnavailable: "Dépôt en ligne pas encore disponible",
  documentUploadInProgress: "Dépôt en cours…",
  documentUploadError: "Le dépôt a échoué, réessayez.",
  documentValidateButton: "Valider la pièce",
  documentValidateError: "La validation a échoué, réessayez.",
  documentTypeStatuts: "Statuts constitutifs",
  documentTypeRccm: "Extrait RCCM",
  documentTypePieceIdentiteRl: "Pièce d'identité du représentant légal",
  documentTypeNominationDirigeants: "Acte de nomination des dirigeants",
  documentTypeDeclarationBeneficiairesEffectifs:
    "Déclaration des bénéficiaires effectifs",
  documentTypeConventionGie: "Convention constitutive du GIE",
  documentTypeRecepisseDeclaration: "Récépissé de déclaration",

  stepScreening: "Screening",
  pmScreeningTitle: "Screening sanctions / PEP / adverse media",
  pmScreeningDescription:
    "Le screening est exécuté en amont (RIC / VNeuron) sur l'entreprise, ses actionnaires et ses représentants — cet écran ne fait que projeter le résultat.",
  pmScreeningRunning: "Projection des résultats de screening…",
  pmScreeningEntityTypeEntreprise: "Entreprise",
  pmScreeningEntityTypeActionnaire: "Actionnaire",
  pmScreeningEntityTypeRepresentant: "Représentant",
  pmScreeningListSourceSanctions: "Sanctions",
  pmScreeningListSourcePep: "PEP",
  pmScreeningListSourceAdverseMedia: "Adverse media",
  pmScreeningQualificationTruePositive: "Vrai positif",
  pmScreeningQualificationFalsePositive: "Faux positif",
  pmScreeningQualificationUncertain: "Incertain (escaladé)",
  pmScreeningFalsePositivePendingValidation:
    "Faux positif — en attente de validation",
  pmScreeningStatusPending: "En attente",
  pmScreeningStatusClear: "Clear",
  pmScreeningStatusHit: "Hit",
  pmScreeningStatusInconclusive: "Non concluant",

  stepRiskScore: "Score de risque",
  riskScoreTitle: "Score de risque composite BCEAO",
  riskScoreDescription:
    "Calculé à partir du secteur d'activité de l'entreprise, de ses représentants et des résultats du screening.",
  riskScoreLoading: "Calcul du score de risque…",
  riskScoreCompositeLabel: "Score composite",
  riskScoreLevelLabel: "Niveau de risque",
  riskScoreFactorsTitle: "Facteurs de risque",
  riskScoreVigilanceMessage:
    "Une vigilance renforcée est requise pour ce dossier.",
  riskLevelLow: "Low",
  riskLevelStandard: "Standard",
  riskLevelHigh: "High",
  riskLevelCritical: "Critical",
  riskFactorBase: "Score de base composite",
  riskFactorHoldingStructure: "Structure Holding / complexité",
  riskFactorIntermediatePM: "PM intermédiaire dans la chaîne",
  riskFactorForeignUbo: "UBO étranger",
  riskFactorSensitiveSector: "Secteur d'activité sensible",
  riskFactorPepRepresentative: "PEP (RL ou BE)",
  riskFactorDigitalChannel: "Canal digital",
  riskFactorGafiNonCooperativeCountry: "Pays GAFI non-coopératif",
  riskFactorYoungCompany: "Entreprise < 2 ans",

  decisionOutcomeApprovedComplete: "Dossier complet / Approuver",
  decisionOutcomeApprovedWithRestrictions: "Approuver avec restrictions",
  decisionOutcomeRejected: "Rejeté",
  decisionOutcomeRegulatoryHold: "Mise en attente réglementaire",

  stepAccountOpening: "Ouverture de compte",
  stepSubmission: "Soumission",
  submissionTitle: "Soumission du dossier pour instruction",
  submissionDescription: "Le dossier est transmis à l'analyste conformité. Il n'est plus modifiable une fois soumis, sauf si un complément est demandé.",
  submissionSubmitButton: "Soumettre pour instruction",
  submissionAlreadyInInstruction: "Ce dossier est déjà soumis : il est entre les mains de la conformité, il n'y a plus rien à soumettre.",
  submissionOpenCase: "Ouvrir le dossier",
  submissionPrereqTitle: "Avant de soumettre",
  submissionPrereqBeneficialOwner: "Un bénéficiaire effectif est identifié, ou un repli dirigeant est documenté",
  submissionPrereqRegistration: "L'immatriculation de l'entreprise (RCCM) est vérifiée par la conformité",
  submissionPrereqOwnersVerified: "Les bénéficiaires effectifs sont vérifiés (sinon le dossier est signalé à la conformité)",
  submissionPrereqDocuments: "Les pièces obligatoires sont reçues",
  submissionPrereqDocumentsMissing: "pièce(s) obligatoire(s) manquante(s) : le dossier attendra le client",
  submissionPrereqFix: "Régler",
  submissionPrereqBlocked: "Réglez les points bloquants ci-dessus pour pouvoir soumettre.",
  submissionBlockedTitle: "Le dossier ne peut pas encore être soumis",
  submissionBlockerBeneficialOwnerMissing: "Aucun bénéficiaire effectif n'est identifié, et aucun repli dirigeant n'est soumis ou validé.",
  submissionBlockerRegistrationNotVerified: "Aucune immatriculation RCCM n'est vérifiée.",
  submissionBlockerUnknown: "Un prérequis est manquant :",
  submissionSubmittedMessage: "Dossier soumis. Il est maintenant en cours d'instruction par la conformité.",
  submissionAwaitingClientMessage: "Dossier soumis. Des pièces obligatoires manquent encore, il attend vos compléments. Pièces manquantes :",
  submissionAlreadySubmittedMessage: "Ce dossier était déjà soumis.",
  submissionFlagBeNonVerifie: "Vigilance : un bénéficiaire effectif n'est pas vérifié.",
  submissionFlagStructureOpaque: "Vigilance : la structure de détention est opaque.",
  kybCaseTitle: "Dossier KYB",
  kybCaseOpenButton: "Dossier KYB",
  kybCaseLoadError: "Impossible de charger le dossier KYB.",
  kybCaseNotFound: "Ce client n'a pas encore de dossier KYB actif. Soumettez d'abord le dossier d'onboarding.",
  kybCaseStatusLabel: "Statut",
  kybCaseStatusOpen: "Brouillon",
  kybCaseStatusSubmitted: "En instruction",
  kybCaseStatusAwaitingClient: "En attente du client",
  kybCaseStatusApproved: "Approuvé",
  kybCaseStatusApprovedWithRestrictions: "Approuvé avec restrictions",
  kybCaseStatusRejected: "Rejeté",
  kybCaseStatusRegulatoryHold: "En attente réglementaire",
  kybCaseStatusEnhancedSurveillance: "Surveillance renforcée",
  kybCaseStatusClosed: "Clos",
  kybMandatesTitle: "Mandats du dossier",
  kybMandatesBack: "Retour au dossier",
  kybMandatesOpen: "Mandats",
  kybMandatesEmpty: "Aucun mandat",
  kybMandatesLoadError: "Impossible de charger les mandats.",
  kybMandatesRetry: "Réessayer",
  kybMandatesNoCase: "Ce client n'a pas de dossier actif.",
  kybMandateColMandataire: "Mandataire",
  kybMandateColType: "Type",
  kybMandateColPerimeter: "Périmètre",
  kybMandateColCeiling: "Plafond",
  kybMandateColPeriod: "Période",
  kybMandateColSignature: "Signature",
  kybMandateColStatus: "État",
  kybMandateTypeStandard: "Standard",
  kybMandateTypeDelegation: "Délégation temporaire",
  kybMandateSignatureAlone: "Seule",
  kybMandateSignatureJoint: "Conjointe",
  kybMandateStatusPending: "En attente de validation",
  kybMandateStatusActive: "Actif",
  kybMandateStatusExpired: "Expiré",
  kybMandateStatusRevoked: "Révoqué",
  kybMandateOverdue: "Échu",
  kybMandateUnknownPerson: "Personne absente du dossier",
  kybMandateNonClient: "Non client de la banque",
  kybMandatePeriodFrom: "Du",
  kybMandatePeriodTo: "au",
  kybMandatePeriodOpenEnded: "sans date de fin",
  kybMandateDetailTitle: "Détail du mandat",
  kybMandateDetailEmpty: "Sélectionnez un mandat pour voir son détail.",
  kybMandateValidity: "Validité aujourd'hui",
  kybMandateValid: "Valide",
  kybMandateNotValid: "Non valide",
  kybMandateValidityLoading: "Vérification de la validité",
  kybMandateValidityError: "Validité indisponible.",
  kybMandateCreatedBy: "Créé par",
  kybMandateValidatedBy: "Validé par",
  kybMandateRevokedBy: "Révoqué par",
  kybMandateRevocationReason: "Motif",
  kybMandateRevocationComment: "Commentaire",
  kybMandateParent: "Délégué à partir du mandat",
  kybMandateClose: "Fermer",
  kybMandateNew: "Nouveau mandat",
  kybMandateCreateTitle: "Créer un mandat",
  kybMandateCreateHint: "Le mandat reste en attente de validation : il ne donne aucun pouvoir avant la validation de la conformité.",
  kybMandateFieldMandataire: "Mandataire (personne physique du dossier)",
  kybMandateFieldPerimeter: "Périmètre des pouvoirs",
  kybMandateFieldAccount: "Compte couvert",
  kybMandateAccountAll: "Tous les comptes de l'entreprise",
  kybMandateAccountPlaceholder: "Choisir un compte",
  kybMandateErrAccount: "Choisissez le compte couvert par le mandat, ou « Tous les comptes ».",
  kybMandateErrOperations: "Cochez au moins une opération couverte.",
  kybMandateOperationsUnavailable: "Les types d'opération ne sont pas disponibles : réessayez dans un instant.",
  kybMandateFieldCeiling: "Plafond",
  kybMandateFieldCurrency: "Devise (code ISO)",
  kybMandateFieldStart: "Date de début",
  kybMandateFieldEnd: "Date de fin (facultative)",
  kybMandateFieldSignature: "Mode de signature",
  kybMandateNoPerson: "Aucune personne physique dans le dossier : ajoutez d'abord un représentant.",
  kybMandateSubmit: "Créer le mandat",
  kybMandateCancel: "Annuler",
  kybMandateCreated: "Mandat créé, en attente de validation.",
  kybMandateCreateError: "Le mandat n'a pas pu être créé.",
  kybMandateCreateNotFound: "Le dossier ou le mandataire n'existe plus.",
  kybMandateErrMandataire: "Choisissez le mandataire.",
  kybMandateErrPerimeterRequired: "Décrivez le périmètre des pouvoirs.",
  kybMandateErrPerimeterTooLong: "Le périmètre est limité à 2000 caractères.",
  kybMandateErrCeiling: "Le plafond doit être un nombre supérieur à 0.",
  kybMandateErrCurrency: "Trois lettres majuscules, par exemple XOF.",
  kybMandateErrStart: "Saisissez une date de début valide.",
  kybMandateErrEndInvalid: "Saisissez une date de fin valide.",
  kybMandateErrEndBeforeStart: "La date de fin doit être postérieure à la date de début.",
  kybMandateDocsTitle: "Pièces justificatives",
  kybMandateDocsEmpty: "Aucune pièce pour l'instant.",
  kybMandateDocsLoadError: "Impossible de charger les pièces.",
  kybMandateDocsCount: "pièces sur 10",
  kybMandateDocsAdd: "Ajouter une pièce",
  kybMandateDocsType: "Type de preuve",
  kybMandateDocsValidity: "Date de validité juridique (facultative)",
  kybMandateDocsFile: "Fichier (PDF, PNG ou JPEG)",
  kybMandateDocsSend: "Envoyer",
  kybMandateDocsSent: "Pièce ajoutée.",
  kybMandateDocsSendError: "La pièce n'a pas pu être envoyée.",
  kybMandateDocsDownload: "Ouvrir",
  kybMandateDocsDownloadError: "La pièce n'a pas pu être ouverte.",
  kybMandateDocsTypePv: "Procès-verbal (PV)",
  kybMandateDocsTypeProxy: "Procuration",
  kybMandateDocsTypeDelegation: "Délégation",
  kybMandateDocsNotPending: "Une pièce ne peut être ajoutée que tant que le mandat attend sa validation.",
  kybMandateDocsFull: "La limite de 10 pièces est atteinte.",
  kybMandateDocsErrFile: "Choisissez un fichier.",
  kybMandateDocsErrFormat: "Seuls les fichiers PDF, PNG ou JPEG sont acceptés.",
  kybMandateDocsErrEmpty: "Le fichier est vide.",
  kybMandateDocsErrDate: "Saisissez une date valide.",
  kybMandateActTitle: "Validation par la conformité",
  kybMandateActLoading: "Vérification des conditions",
  kybMandateActEligibilityError: "Impossible de lire les conditions.",
  kybMandateActBlockedTitle: "Le mandat ne peut pas encore être validé :",
  kybMandateActComment: "Commentaire (facultatif)",
  kybMandateActButton: "Valider le mandat",
  kybMandateActDone: "Mandat validé.",
  kybMandateActFailed: "Le mandat n'a pas pu être validé.",
  kybMandateActSod: "Vous ne pouvez pas valider un mandat que vous avez créé ou documenté.",
  kybMandateActConcurrent: "Le mandataire a déjà un mandat actif sur une période qui recoupe celle-ci. Vérifiez la préséance avant de valider.",
  kybMandateGuardNoProof: "Aucun document probant attaché.",
  kybMandateGuardFileMissing: "Aucun document lisible dans le stockage.",
  kybMandateGuardProofExpired: "Tous les documents ont dépassé leur validité juridique.",
  kybMandateGuardMandantNotOperational: "Le dossier de l'entreprise n'est pas approuvé.",
  kybMandateGuardPeriodEnded: "La date de fin du mandat est dépassée.",
  kybMandateGuardParentNotActive: "Le mandat parent n'est pas actif.",
  kybMandateGuardUnknown: "Condition non remplie :",
  kybMandateRevokeButton: "Révoquer",
  kybMandateRevokeTitle: "Révoquer le mandat",
  kybMandateRevokeHint: "Les accès qui dépendent de ce mandat sont suspendus et leurs comptes fermés. Cette action est définitive : un nouveau mandat est nécessaire pour redonner des pouvoirs.",
  kybMandateRevokeReason: "Motif",
  kybMandateRevokeComment: "Justification",
  kybMandateRevokeCounter: "caractères",
  kybMandateRevokeConfirm: "Révoquer le mandat",
  kybMandateRevokeDone: "Mandat révoqué.",
  kybMandateRevokeFailed: "Le mandat n'a pas pu être révoqué.",
  kybMandateRevokeForbidden: "Vous ne pouvez pas révoquer un mandat que vous avez validé.",
  kybMandateRevokeAlready: "Mandat déjà révoqué le",
  kybMandateRevokeBy: "par",
  kybMandateRevokeResult: "Accès suspendus / maintenus / délégations révoquées :",
  kybMandateRevokeErrReason: "Choisissez un motif.",
  kybMandateRevokeErrComment: "La justification est obligatoire.",
  kybMandateRevokeReasonsError: "Impossible de charger les motifs.",
  kybMandateImpactTitle: "Ce que la révocation retire",
  kybMandateImpactLoadError: "Impossible de lire l'impact.",
  kybMandateImpactNone: "Aucun accès ne dépend de ce mandat.",
  kybMandateImpactDeactivate: "sera suspendu",
  kybMandateImpactMaintained: "maintenu (couvert par un autre mandat actif)",
  kybMandateImpactDelegations: "Délégations temporaires révoquées avec lui",
  kybMandateImpactCounters: "à suspendre / maintenus",
  kybMandateReasonFinFonction: "Fin de fonction du mandataire",
  kybMandateReasonCessation: "Cessation d'activité",
  kybMandateReasonDemande: "Demande du mandant",
  kybMandateReasonPouvoirs: "Changement des pouvoirs",
  kybMandateReasonConfiance: "Perte de confiance",
  kybMandateReasonFraude: "Fraude suspectée",
  kybMandateReasonErreur: "Mandat saisi par erreur",
  kybMandateReasonAutre: "Autre",
  kybDelegationTitle: "Délégations temporaires",
  kybDelegationEmpty: "Aucune délégation.",
  kybDelegationLoadError: "Impossible de charger les délégations.",
  kybDelegationNew: "Déléguer",
  kybDelegationCreateTitle: "Déléguer une partie des pouvoirs",
  kybDelegationCreateHint: "La délégation reste en attente de validation et ne donne aucun pouvoir avant la validation de la conformité. Elle prend fin avec son mandat parent.",
  kybDelegationFieldDelegate: "Délégué (personne physique du dossier)",
  kybDelegationFieldPerimeter: "Périmètre (celui du mandat parent si vide)",
  kybDelegationFieldOperations: "Opérations déléguées",
  kybDelegationOperationsNote: "Le compte est celui du mandat. On ne peut déléguer que des opérations du mandat : décochez celles à retirer.",
  kybDelegationLegacyNote: "Ce mandat est ancien, sans compte ni opérations enregistrés : la délégation reprend son périmètre tel quel.",
  kybDelegationPerimeterNote: "La restriction saisie n'est pas vérifiable par la machine : elle sera contrôlée par le valideur.",
  kybDelegationFieldCeiling: "Plafond (au plus celui du mandat parent)",
  kybDelegationFieldStart: "Date de début",
  kybDelegationFieldEnd: "Date de fin",
  kybDelegationSubmit: "Créer la délégation",
  kybDelegationCreated: "Délégation créée, en attente de validation.",
  kybDelegationCreateError: "La délégation n'a pas pu être créée.",
  kybDelegationErrDelegate: "Choisissez le délégué.",
  kybDelegationErrCeiling: "Le plafond doit être supérieur à 0 et au plus égal à celui du mandat parent.",
  kybDelegationErrStart: "Saisissez une date de début comprise dans la période du mandat parent.",
  kybDelegationErrEndRequired: "La date de fin est obligatoire.",
  kybDelegationErrEndPast: "La date de fin doit être dans le futur.",
  kybDelegationErrEndBeforeStart: "La date de fin doit être postérieure à la date de début.",
  kybDelegationErrEndOutside: "La délégation ne peut pas finir après son mandat parent.",
  kybDelegationErrTooLong: "Une délégation dure 90 jours au plus.",
  kybContactTitle: "Contact pour le compte d'accès",
  kybContactHint: "L'e-mail reçoit les codes de connexion du mandataire. Laissez un champ vide pour l'effacer : le contact retombe alors sur la fiche client de la banque.",
  kybContactEmail: "E-mail",
  kybContactPhone: "Téléphone",
  kybContactCurrent: "Contact actuel",
  kybContactNone: "Aucun contact saisi",
  kybContactFromBankFile: "repris de la fiche client de la banque",
  kybContactEmailExample: "Ex: awa.kone@exemple.org",
  kybContactPhoneExample: "Ex: +2250102030405",
  kybContactSave: "Enregistrer le contact",
  kybContactSaved: "Contact enregistré.",
  kybContactPendingSaved: "Demande enregistrée, en attente de validation par un second agent. Le contact actuel reste en place d'ici là.",
  kybContactSaveError: "Le contact n'a pas pu être enregistré.",
  kybContactAlreadyPending: "Une demande est déjà en attente pour cette personne.",
  kybContactErrEmail: "Saisissez une adresse e-mail valide (254 caractères au plus).",
  kybContactErrPhone: "Saisissez un numéro valide (6 à 20 chiffres, + facultatif).",
  kybContactErrUnchanged: "Le contact n'a pas changé.",
  kybContactChangesTitle: "Demandes de changement de contact",
  kybContactChangesEmpty: "Aucune demande.",
  kybContactChangesLoadError: "Impossible de charger les demandes.",
  kybContactChangeProposed: "Proposé",
  kybContactChangeBy: "par",
  kybContactChangeCleared: "(effacé)",
  kybContactStatusPending: "En attente de validation",
  kybContactStatusApproved: "Approuvée",
  kybContactStatusRejected: "Refusée",
  kybContactApprove: "Approuver",
  kybContactReject: "Refuser",
  kybContactDecisionApproveTitle: "Approuver le changement de contact",
  kybContactDecisionRejectTitle: "Refuser le changement de contact",
  kybContactDecisionProcedure: "Avant d'approuver, confirmez le changement par un autre canal que celui proposé (rappelez le mandataire au numéro que la banque détient déjà).",
  kybContactDecisionComment: "Commentaire",
  kybContactDecisionCommentRequired: "Un commentaire est obligatoire pour refuser.",
  kybContactDecisionConfirm: "Confirmer",
  kybContactDecisionApproved: "Changement de contact approuvé.",
  kybContactDecisionRejected: "Changement de contact refusé.",
  kybContactDecisionForbidden: "Vous ne pouvez pas trancher une demande que vous avez faite vous-même.",
  kybContactDecisionFailed: "La décision n'a pas pu être enregistrée.",
  kybAccessOpen: "Accès corporate",
  kybAccessTitle: "Accès corporate du dossier",
  kybAccessBack: "Retour au dossier",
  kybAccessLoadError: "Impossible de charger les accès.",
  kybAccessNoCase: "Ce client n'a pas de dossier actif.",
  kybAccessEmpty: "Aucun accès corporate pour l'instant.",
  kybAccessRetry: "Réessayer",
  kybAccessRefresh: "Actualiser",
  kybAccessUserLabel: "Accès corporate de",
  kybAccessStatusPending: "En attente de création du compte",
  kybAccessStatusActive: "Actif",
  kybAccessStatusSuspended: "Suspendu : mandat disparu",
  kybAccessStatusSuspendedRecert: "Suspendu : recertification non faite",
  kybRecertMenu: "Recertification",
  kybRecertTitle: "Recertification des accès corporate",
  kybRecertSubtitle: "Confirmez que chaque accès corporate reste justifié, ou révoquez-le. Sans décision à la fin du délai de grâce, l'accès est suspendu automatiquement.",
  kybRecertTabPending: "À traiter",
  kybRecertTabSuspended: "Accès suspendus",
  kybRecertTabJournal: "Journal des décisions",
  kybRecertRefresh: "Actualiser",
  kybRecertSelected: "sélectionné(s)",
  kybRecertCertifySelection: "Certifier la sélection",
  kybRecertRevokeSelection: "Révoquer la sélection",
  kybRecertLoadError: "La file de recertification n'a pas pu être chargée.",
  kybRecertRetry: "Réessayer",
  kybRecertEmpty: "Aucune recertification dans cette vue.",
  kybRecertSelectAll: "Tout sélectionner",
  kybRecertSelectRow: "Sélectionner la recertification de",
  kybRecertColCompany: "Entreprise",
  kybRecertColHolder: "Titulaire",
  kybRecertColAccess: "Accès",
  kybRecertColDue: "Échéance",
  kybRecertColGrace: "Fin du délai de grâce",
  kybRecertColSituation: "Situation",
  kybRecertColDecidedBy: "Décidé par",
  kybRecertColJustification: "Justification",
  kybRecertColActions: "Actions",
  kybRecertCertify: "Certifier",
  kybRecertRevoke: "Révoquer",
  kybRecertReactivate: "Réactiver",
  kybRecertStatusPending: "À décider",
  kybRecertStatusCertified: "Certifié",
  kybRecertStatusRevoked: "Révoqué",
  kybRecertStatusExpired: "Suspendu automatiquement",
  kybRecertStatusCancelled: "Sans objet",
  kybRecertPhaseNotice: "Préavis",
  kybRecertPhaseGrace: "Échéance passée, délai de grâce",
  kybRecertPhaseOverdue: "Grâce terminée : suspension imminente",
  kybRecertDialogCertifyTitle: "Certifier les accès",
  kybRecertDialogCertifyHint: "L'accès reste justifié : un nouveau cycle de recertification commence. Votre justification est enregistrée pour chaque accès.",
  kybRecertDialogRevokeTitle: "Révoquer les accès",
  kybRecertDialogRevokeHint: "L'accès est suspendu et ne donne plus aucun droit. Votre justification est enregistrée pour chaque accès.",
  kybRecertDialogReactivateTitle: "Réactiver l'accès",
  kybRecertDialogReactivateHint: "L'accès est rouvert et repart pour un nouveau cycle. Le mandat doit être encore en vigueur.",
  kybRecertJustification: "Justification",
  kybRecertJustificationHelp: "10 à 1000 caractères. Elle est conservée avec la décision.",
  kybRecertJustificationRequired: "Une justification d'au moins 10 caractères est obligatoire.",
  kybRecertConfirm: "Confirmer",
  kybRecertCancel: "Annuler",
  kybRecertDecided: "Décision enregistrée.",
  kybRecertReactivated: "Accès réactivé.",
  kybRecertActionFailed: "La décision n'a pas pu être enregistrée.",
  kybRecertSettingTitle: "Réglage de la recertification",
  kybRecertSettingPeriod: "Périodicité (mois)",
  kybRecertSettingNotice: "Préavis (jours)",
  kybRecertSettingGrace: "Délai de grâce (jours)",
  kybRecertSettingDefault: "Valeurs par défaut de la configuration : aucun réglage n'a été posé.",
  kybRecertSettingBy: "Réglé par",
  kybRecertSettingEdit: "Modifier",
  kybRecertSettingHint: "Le changement s'applique à la passe suivante et ne touche que les échéances à venir : le délai de grâce d'une tâche déjà ouverte ne change pas.",
  kybRecertSettingInvalid: "Chaque valeur doit être un entier dans ses bornes, et le motif d'au moins 10 caractères.",
  kybRecertSettingSaved: "Réglage enregistré.",
  kybRecertSettingFailed: "Le réglage n'a pas pu être enregistré.",
  kybMonitoringMenu: "Suivi KYB",
  kybMenuGroup: "KYB · Entreprises",
  kybMonitoringTitle: "Tableau de suivi KYB",
  kybMonitoringSubtitle: "État courant du portefeuille : bénéficiaires effectifs, diligences renforcées et accès corporate sensibles.",
  kybMonitoringRefresh: "Actualiser",
  kybMonitoringSectionUbo: "Bénéficiaires effectifs (UBO)",
  kybMonitoringSectionEdd: "Diligences renforcées (EDD)",
  kybMonitoringSectionAccess: "Accès corporate",
  kybMonitoringReadAt: "Lu le",
  kybMonitoringDegraded: "La source n'a pas répondu : les indicateurs de cette section sont indisponibles.",
  kybMonitoringUnavailable: "Indisponible",
  kybMonitoringSeeCases: "Voir les dossiers",
  kybMonitoringCasesTitle: "Dossiers",
  kybMonitoringCloseCases: "Fermer",
  kybMonitoringNoCases: "Aucun dossier.",
  kybMonitoringMore: "Charger la suite",
  kybMonitoringOpenCase: "Ouvrir",
  kybMonitoringUnknownCase: "Dossier sans nom connu",
  kybMonitoringLoadError: "La section n'a pas pu être chargée.",
  kybMonitoringCasesError: "La liste des dossiers n'a pas pu être chargée.",
  kybMonitoringRetry: "Réessayer",
  kybRetentionMenu: "Conservation",
  kybRetentionTitle: "Conservation des dossiers KYB",
  kybRetentionSubtitle: "Dossiers dont l'échéance de conservation approche ou est dépassée. Un dossier n'est jamais supprimé automatiquement : la suppression exige deux signatures de personnes distinctes.",
  kybRetentionWindowLabel: "Échéance dans les",
  kybRetentionDaysUnit: "jours",
  kybRetentionRefresh: "Actualiser",
  kybRetentionColCompany: "Entreprise",
  kybRetentionColDeadline: "Échéance",
  kybRetentionColDaysLeft: "Jours restants",
  kybRetentionColStatus: "État",
  kybRetentionOpen: "Ouvrir",
  kybRetentionEmpty: "Aucun dossier dans cette fenêtre.",
  kybRetentionLoadError: "Le registre n'a pas pu être chargé.",
  kybRetentionRetry: "Réessayer",
  kybRetentionUnknownCase: "Dossier sans nom connu",
  kybRetentionStatusActive: "Active",
  kybRetentionStatusDueSoon: "Échéance proche",
  kybRetentionStatusLegalHold: "Gel contentieux",
  kybRetentionStatusAwaiting: "Arbitrage attendu",
  kybRetentionStatusDeletionRequested: "Suppression demandée",
  kybRetentionStatusDeletionAuthorized: "Suppression autorisée",
  kybRetentionDetailTitle: "Conservation du dossier",
  kybRetentionDetailError: "Le détail n'a pas pu être chargé.",
  kybRetentionBaseDeadline: "Échéance de base",
  kybRetentionEffectiveDeadline: "Échéance en vigueur",
  kybRetentionHoldBy: "Gel posé par",
  kybRetentionDeletionBy: "Suppression demandée par",
  kybRetentionNoSnapshot: "Ce dossier n'a pas encore de snapshot : aucune échéance n'existe et aucune décision n'est possible.",
  kybRetentionJournal: "Journal des décisions",
  kybRetentionJournalEmpty: "Aucune décision consignée.",
  kybRetentionTypeExtension: "Prolongation",
  kybRetentionTypeHold: "Gel posé",
  kybRetentionTypeRelease: "Gel levé",
  kybRetentionTypeDeletionRequest: "Suppression demandée",
  kybRetentionTypeDeletionAuthorization: "Suppression autorisée",
  kybRetentionActionExtend: "Prolonger",
  kybRetentionActionHold: "Geler (contentieux)",
  kybRetentionActionRelease: "Lever le gel",
  kybRetentionActionRequestDeletion: "Demander la suppression",
  kybRetentionActionAuthorizeDeletion: "Autoriser la suppression",
  kybRetentionHintExtend: "Repousse l'échéance à une date postérieure à l'échéance en vigueur. Annule une demande de suppression en cours.",
  kybRetentionHintHold: "Interdit toute suppression tant que le gel n'est pas levé, quelle que soit l'échéance.",
  kybRetentionHintRelease: "Lève le gel. La personne qui l'a posé ne peut pas le lever.",
  kybRetentionHintRequestDeletion: "Première signature : possible seulement si l'échéance est dépassée et sans gel actif. Une seconde personne doit l'autoriser.",
  kybRetentionHintAuthorizeDeletion: "Seconde signature, par une autre personne que le demandeur.",
  kybRetentionFieldReason: "Justification",
  kybRetentionFieldLegalBasis: "Base légale",
  kybRetentionFieldNewDate: "Nouvelle échéance",
  kybRetentionReasonRequired: "La justification est obligatoire.",
  kybRetentionLegalBasisRequired: "La base légale est obligatoire.",
  kybRetentionDateInvalid: "La nouvelle échéance doit être postérieure à l'échéance en vigueur.",
  kybRetentionConfirm: "Confirmer",
  kybRetentionCancel: "Annuler",
  kybRetentionActionFailed: "La décision n'a pas pu être enregistrée.",
  kybRetentionDecided: "Décision enregistrée.",
  kybEvidenceTitle: "Dossier de preuve",
  kybEvidenceSubtitle: "Snapshots immuables du dossier, chaînés par empreinte, et export du pack pour l'inspection.",
  kybEvidenceExportJson: "Exporter en JSON",
  kybEvidenceExportPdf: "Exporter en PDF",
  kybEvidenceExported: "Dossier de preuve exporté.",
  kybEvidenceExportFailed: "L'export n'a pas pu être produit.",
  kybEvidenceLoadError: "Le dossier de preuve n'a pas pu être chargé.",
  kybEvidenceChainIntact: "Chaîne intacte",
  kybEvidenceChainBroken: "Chaîne compromise : l'export est bloqué",
  kybEvidenceChecked: "Snapshots contrôlés",
  kybEvidenceNoSnapshot: "Aucun snapshot : le premier export en prend un à la demande.",
  kybEvidenceColStep: "Étape",
  kybEvidenceColDate: "Capturé le",
  kybEvidenceColAuthor: "Auteur",
  kybEvidenceColHash: "Empreinte",
  kybEvidenceColIntegrity: "Intégrité",
  kybEvidenceSnapshotIntact: "Intact",
  kybEvidenceSnapshotAltered: "Altéré",
  kybEvidenceExportsTitle: "Journal des exports",
  kybEvidenceNoExport: "Aucun export.",
  kybEvidenceOutcomeExported: "Exporté",
  kybEvidenceOutcomeRefused: "Refusé",
  kybAccessUserDeactivated: "Utilisateur désactivé",
  kybAccessPendingHint: "Le compte est en cours de création. Il ne donne aucun droit tant qu'il n'est pas confirmé.",
  kybAccessMandate: "Mandat",
  kybAccessProfileButton: "Profil",
  kybAccessWithoutTitle: "Mandats actifs sans accès",
  kybAccessCreate: "Créer l'accès",
  kybAccessCreated: "Accès créé, en attente de la confirmation du compte.",
  kybAccessCreateError: "L'accès n'a pas pu être créé.",
  kybAccessNoContact: "Cette personne n'a pas de contact : saisissez d'abord un e-mail dans la carte du représentant.",
  kybAccessNoContactLink: "Aller aux représentants",
  kybAccessReactivate: "Réactiver",
  kybAccessReactivateTitle: "Réactiver l'utilisateur",
  kybAccessReactivateHint: "L'utilisateur a été fermé quand il a perdu tous ses mandats. Le rouvrir est une décision explicite de la conformité, tracée avec sa justification.",
  kybAccessReactivateComment: "Justification",
  kybAccessReactivateCommentRequired: "La justification est obligatoire.",
  kybAccessReactivateDone: "Utilisateur réactivé.",
  kybAccessReactivateFailed: "L'utilisateur n'a pas pu être réactivé.",
  kybProfileTitle: "Profil de droits",
  kybProfileLoadError: "Impossible de charger le profil.",
  kybProfileNone: "Aucun profil affecté : l'accès se voit tout refuser.",
  kybProfileAssignedBy: "Affecté par",
  kybProfileRoles: "Rôles",
  kybProfileAccounts: "Comptes (un par ligne)",
  kybProfileAccountsNote: "Les comptes sont vérifiés par le back contre ceux de l'entreprise.",
  kybProfileOperations: "Opérations et plafond par opération",
  kybProfileOperationCode: "Code de l'opération",
  kybProfileOperationLimit: "Plafond",
  kybProfileAddOperation: "Ajouter une opération",
  kybProfileRemoveOperation: "Retirer",
  kybProfileCountries: "Pays",
  kybProfileAddCountry: "Ajouter un pays",
  kybProfileCurrencies: "Devises (codes ISO, séparés par des virgules)",
  kybProfileMakerChecker: "Le cumul MAKER et CHECKER sera refusé par la séparation des tâches.",
  kybProfileSave: "Enregistrer le profil",
  kybProfileSaved: "Profil enregistré.",
  kybProfileSaveError: "Le profil n'a pas pu être enregistré.",
  kybProfileReadOnly: "Cet accès est suspendu : son profil ne peut plus être modifié.",
  kybProfileErrRoles: "Choisissez au moins un rôle.",
  kybProfileErrAccounts: "Saisissez de 1 à 200 comptes de 80 caractères au plus.",
  kybProfileErrOperations: "Saisissez au moins une opération, chacune avec un code différent.",
  kybProfileErrLimit: "Chaque opération demande un plafond supérieur à 0 (20 chiffres et 4 décimales au plus).",
  kybProfileErrCountries: "Choisissez au moins un pays.",
  kybProfileErrCurrencies: "Saisissez au moins une devise de trois lettres majuscules.",
  corpLoginTitle: "Première connexion d'un mandataire",
  corpLoginIntro: "Réservé aux mandataires d'une entreprise qui ont reçu un accès. Vous recevrez un code à l'adresse e-mail que la banque détient pour vous.",
  corpLoginLink: "Première connexion d'un mandataire d'entreprise ? Définir mon mot de passe",
  corpLoginEmail: "Adresse e-mail",
  corpLoginEmailInvalid: "Saisissez une adresse e-mail valide.",
  corpLoginSendCode: "Recevoir un code",
  corpLoginGeneric: "Si cette adresse est celle d'un accès actif, un code vient d'être envoyé. Il est valable 10 minutes.",
  corpLoginTooManyRequests: "Trop de demandes. Réessayez plus tard.",
  corpLoginCode: "Code reçu par e-mail",
  corpLoginCodeInvalid: "Saisissez le code reçu (4 à 8 chiffres).",
  corpLoginVerify: "Vérifier le code",
  corpLoginCodeWrong: "Le code est faux ou expiré.",
  corpLoginLocked: "Trop de tentatives. Réessayez plus tard.",
  corpLoginRestart: "Recommencer avec un autre code",
  corpLoginPasswordRules: "Votre mot de passe doit contenir :",
  corpLoginRuleLength: "au moins 8 caractères",
  corpLoginRuleLower: "une lettre minuscule",
  corpLoginRuleUpper: "une lettre majuscule",
  corpLoginRuleDigit: "un chiffre",
  corpLoginRuleSpecial: "un caractère spécial parmi @ $ ! % * ? & # + - _ = . , ; : / ( )",
  corpLoginNewPassword: "Nouveau mot de passe",
  corpLoginConfirmPassword: "Confirmer le mot de passe",
  corpLoginMismatch: "Les deux mots de passe sont différents.",
  corpLoginSetPassword: "Définir mon mot de passe",
  corpLoginPolicyRefused: "Le mot de passe ne respecte pas les règles.",
  corpLoginTokenExpired: "La session a expiré. Recommencez depuis le début.",
  corpLoginUnavailable: "Le service est indisponible. Réessayez plus tard.",
  corpLoginDone: "Mot de passe défini.",
  corpLoginDoneHint: "Connectez-vous avec votre adresse e-mail comme identifiant.",
  corpLoginBack: "Retour à la connexion",
  kybGridOpen: "Grilles de signature",
  kybGridTitle: "Grilles de signature du dossier",
  kybGridBack: "Retour au dossier",
  kybGridNoCase: "Ce client n'a pas de dossier actif.",
  kybGridLoadError: "Impossible de charger les grilles.",
  kybGridRetry: "Réessayer",
  kybGridEmpty: "Aucune grille de signature pour l'instant.",
  kybGridPropose: "Proposer une grille",
  kybGridType: "Type d'opération",
  kybGridCurrency: "Devise",
  kybGridStatusPending: "En attente de validation",
  kybGridStatusActive: "Active",
  kybGridStatusArchived: "Archivée",
  kybGridRange: "Plage",
  kybGridUnlimited: "sans limite supérieure",
  kybGridSignatures: "signature(s)",
  kybGridCreatedBy: "Proposée par",
  kybGridValidatedBy: "Validée par",
  kybGridProposeTitle: "Proposer une grille de signature",
  kybGridProposeHint: "Plages semi-ouvertes : la borne basse est incluse, la haute exclue. La première plage commence à 0, chacune commence où la précédente s'arrête, la dernière n'a pas de limite supérieure.",
  kybGridMin: "À partir de (inclus)",
  kybGridMax: "Jusqu'à (exclu)",
  kybGridRequired: "Signatures requises",
  kybGridAddRange: "Ajouter un palier",
  kybGridRemoveRange: "Retirer",
  kybGridSubmit: "Proposer la grille",
  kybGridProposed: "Grille proposée, en attente de validation.",
  kybGridConflictsTitle: "La grille n'est pas cohérente :",
  kybGridProposeError: "La grille n'a pas pu être proposée.",
  kybGridErrType: "Choisissez le type d'opération.",
  kybGridErrCurrency: "Trois lettres majuscules, par exemple XOF.",
  kybGridErrRanges: "Ajoutez au moins une plage.",
  kybGridErrRangeFormat: "Chaque plage demande un minimum de 0 ou plus, un maximum valide s'il est rempli, et au moins une signature.",
  kybGridActivate: "Valider",
  kybGridActivateTitle: "Valider la grille",
  kybGridActivateHint: "Le quorum est revérifié à ce moment. Valider archive la grille qui était active.",
  kybGridActivateComment: "Commentaire (facultatif)",
  kybGridActivateDone: "Grille validée.",
  kybGridActivateForbidden: "Vous ne pouvez pas valider une grille que vous avez proposée.",
  kybGridActivateFailed: "La grille n'a pas pu être validée.",
  kybGridSimTitle: "Simulateur",
  kybGridSimHint: "Rien n'est enregistré : la simulation lit la grille active et les signataires en vigueur.",
  kybGridSimAmount: "Montant",
  kybGridSimSigners: "Signataires proposés (facultatif)",
  kybGridSimRun: "Simuler",
  kybGridSimNoGrid: "Aucune grille active pour ce type d'opération et cette devise.",
  kybGridSimError: "La simulation a échoué.",
  kybGridSimErrAmount: "Saisissez un montant de 0 ou plus.",
  kybGridSimRangeApplied: "Plage appliquée",
  kybGridSimRequired: "Signatures requises",
  kybGridSimAvailable: "Signataires en vigueur",
  kybGridSimReachable: "Le quorum est atteignable.",
  kybGridSimUnreachable: "Le quorum n'est pas atteignable avec les mandats actuels.",
  kybGridSimMet: "Les signataires proposés atteignent le quorum.",
  kybGridSimNotMet: "Les signataires proposés n'atteignent pas le quorum.",
  kybGridSimCounted: "compté",
  kybGridSimDiscarded: "écarté",
  kybCaseCountry: "Pays",
  kybCaseLegalForm: "Forme juridique",
  kybCaseSubmittedBy: "Soumis par",
  kybCaseSubmittedAt: "Soumis le",
  kybCaseSlaPausedAt: "Délai d'instruction suspendu depuis le",
  kybCaseSlaResumedAt: "Délai d'instruction repris le",
  kybCaseReadyForValidation: "Prêt pour validation",
  kybCaseVigilanceTitle: "Points de vigilance",
  kybNextTitle: "Prochaine étape",
  kybNextEntryOpen: "Le dossier est en cours de saisie : terminez la saisie puis soumettez-le.",
  kybNextEntryOpenOther: "Le dossier est en cours de saisie par l'agent.",
  kybNextEntryResume: "Reprendre la saisie",
  kybNextAwaitingClient: "Le client doit compléter les pièces demandées. Une fois reçues, resoumettez le dossier.",
  kybNextAwaitingClientOther: "Le dossier attend les pièces du client.",
  kybNextSeePieces: "Voir les pièces",
  kybNextQualifyHits: "correspondance(s) de criblage à qualifier : homonyme ou bonne personne.",
  kybNextControlPieces: "pièce(s) reçue(s) à contrôler.",
  kybNextVerifyOwners: "Les bénéficiaires effectifs ne sont pas vérifiés.",
  kybNextMarkReady: "L'instruction est complète : marquez le dossier prêt pour validation.",
  kybNextInstructionOther: "Le dossier est en instruction par la conformité.",
  kybNextGoQualify: "Qualifier",
  kybNextGoControl: "Contrôler",
  kybNextGoVerify: "Vérifier",
  kybNextGoInstruction: "Ouvrir l'instruction",
  kybNextValidateL1: "Le dossier est prêt : validez-le (niveau 1).",
  kybNextValidateL1Other: "Le dossier attend la validation de niveau 1.",
  kybNextGoValidate: "Valider",
  kybNextDecide: "La validation de niveau 1 est faite : décidez du dossier (approbation, restrictions, rejet ou mise en attente).",
  kybNextDecideEdd: "Un EDD est exigé : il doit être approuvé avant d'approuver le dossier.",
  kybNextDecideOther: "Le dossier attend la décision du responsable conformité.",
  kybNextGoDecide: "Décider",
  kybNextOnHold: "Le dossier est en attente réglementaire : une nouvelle décision est possible une fois la levée obtenue.",
  kybNextApproved: "Le dossier est approuvé : suivez l'ouverture du compte, les mandats et les accès.",
  kybNextGoAccess: "Mandats et accès",
  kybNextClosed: "Le dossier est clos : rien à faire.",
  kybCaseTimelineTitle: "Historique du dossier",
  kybCaseTimelineEmpty: "Aucune entrée pour le moment.",
  kybCaseTimelineError: "Impossible de charger l'historique.",
  kybCaseTimelineActor: "Par",
  kybCaseTimelineJustification: "Justification",
  kybCaseTimelineCritical: "Critique",
  kybCaseTimelinePage: "Page",
  kybInstructionTitle: "Instruction du dossier",
  kybInstructionActionFailed: "L'action n'a pas pu aboutir.",
  kybInstructionCommentLabel: "Commentaire d'instruction",
  kybInstructionCommentPlaceholder: "Observation sur le dossier (conservée dans l'historique)",
  kybInstructionCommentButton: "Ajouter le commentaire",
  kybInstructionCommentRequired: "Le commentaire est obligatoire.",
  kybInstructionCommentAdded: "Commentaire ajouté au dossier.",
  kybHitsTitle: "Hits de criblage des personnes liées",
  kybHitsHint: "Un hit à qualifier bloque la décision du dossier. Concluez en justifiant : la conclusion est conservée au journal avec votre identifiant.",
  kybHitsLoadError: "Impossible de charger les hits de criblage.",
  kybHitToQualify: "À qualifier",
  kybHitConfirmed: "Correspondance confirmée",
  kybHitCleared: "Faux positif écarté",
  kybHitLegalParty: "Société interposée",
  kybHitEntity: "Entreprise du dossier",
  kybHitDecisionFalsePositive: "Faux positif",
  kybHitDecisionConfirmed: "Correspondance confirmée",
  kybHitJustification: "Justification",
  kybHitJustificationPlaceholder: "Pourquoi cette conclusion ? (10 caractères au moins)",
  kybHitSave: "Enregistrer la conclusion",
  kybHitSaved: "Conclusion enregistrée.",
  kybHitDecisionRequired: "Choisissez une conclusion.",
  kybHitCandidatesTitle: "Quelle correspondance est la personne du dossier ?",
  kybHitCandidateRequired: "Désignez la correspondance qui décrit la personne.",
  kybHitCandidatePep: "PEP",
  kybHitCandidateSanction: "Sanction",
  kybHitCandidateBirth: "Né(e) le",
  kybHitCandidateNationality: "Nationalité",
  kybHitCandidateScore: "Score",
  kybHitCandidateShowDetail: "Voir le détail",
  kybHitCandidateHideDetail: "Masquer le détail",
  kybHitCandidateSuggested: "Proposé par le fournisseur",
  kybHitCandidateCategory: "Catégorie",
  kybHitCandidatePlaceOfBirth: "Lieu de naissance",
  kybHitCandidateResidence: "Résidence",
  kybHitCandidateLists: "Listes",
  kybHitCandidateAssociates: "Personnes associées",
  kybHitCandidateSources: "Sources",
  kybHitCandidateNoDetail: "Le fournisseur ne connaît rien de plus sur ce candidat.",
  kybHitSubjectTitle: "Personne du dossier",
  kybHitSubjectUnknown: "donnée non renseignée",
  kybHitCompareIntro: "Comparez chaque correspondance du fournisseur à la personne du dossier, puis désignez la bonne ou écartez-les toutes.",
  kybHitIsPerson: "C'est la personne",
  kybHitIsNotAny: "Aucune n'est la personne (homonymes)",
  kybHitChosen: "Retenue",
  kybHitChosenNone: "Toutes écartées : faux positif",
  kybHitChangeChoice: "Changer",
  kybHitStateMatch: "concordant",
  kybHitStateDiffer: "divergent",
  kybHitStateUnknown: "non vérifiable",
  kybHitSourcesOf: "Sources du signalement",
  kybHitSubjectRole: "Rôle",
  kybHitNoIdentity: "Le fournisseur ne donne pas de date de naissance pour ce profil : rien à comparer.",
  kybHitSourceCountry: "Pays de la source",
  kybHitSourceCountryHelp: "Rattaché au signalement, pas à la personne : ce n'est pas sa nationalité.",
  kybHitScoreHelp: "Force du rapprochement calculée par le fournisseur entre la personne criblée et ce profil, de 0 à 100 %. Un score élevé ne prouve pas que c'est la bonne personne : comparez la date de naissance et les sources.",
  kybHitLegend: "Concordant : même date de naissance que le dossier. Divergent : date différente, signe d'un homonyme. Non vérifiable : information absente d'un côté, ou format différent.",
  kybHitStateUnknownHelp: "Le dossier ou le fournisseur n'a pas cette information, ou elle n'est pas écrite dans le même format : elle ne permet ni de confirmer ni d'écarter.",
  kybHitColFile: "Dossier",
  kybHitColProvider: "Fournisseur",
  kybHitNotProvided: "non fourni",
  kybHitScoreCaption: "rapprochement fournisseur",
  kybHistoryCount: "Modifications",
  kybHistoryFilterField: "Champ",
  kybHistoryFilterAllFields: "Tous les champs",
  kybHistoryFilterSource: "Origine",
  kybHistoryFilterAllSources: "Toutes les origines",
  kybHistoryFilterActor: "Auteur",
  kybHistoryFilterActorPlaceholder: "Identifiant",
  kybHistoryFilterFrom: "Du",
  kybHistoryFilterTo: "Au",
  kybHistoryFilterReset: "Réinitialiser",
  kybHistoryNoResult: "Aucune modification ne correspond à ces filtres.",
  kybHistoryMore: "Afficher la suite",
  kybHistoryChangeOne: "modification",
  kybHistoryChangeMany: "modifications",
  kybHistoryChange: "Modification",
  kybFilterSearchPlaceholder: "Raison sociale ou clé du dossier",
  kybFilterAllStatuses: "Tous les états",
  kybFilterNoMatch: "Aucun résultat pour ces filtres.",
  kybFilterReset: "Réinitialiser",
  onboardingLoadingProspect: "Chargement du prospect",
  requestCreateProspect: "Création d'un prospect",
  kybMandateSearchPlaceholder: "Nom du mandataire ou périmètre",
  newRequestSubtitle: "Choisissez la demande à ouvrir. Les demandes grisées ne sont pas encore disponibles.",
  kybRecertSearchPlaceholder: "Entreprise, titulaire ou clé du dossier",
  kybGuideButton: "Guide de la page",
  kybGuideGotIt: "J'ai compris",
  kybRecertGuideTitle: "À quoi sert cette page ?",
  kybRecertGuideIntro: "Chaque accès corporate donné à un représentant d'entreprise doit être reconfirmé à intervalle régulier (tous les 6 mois par défaut). Cette page liste les accès dont la reconfirmation approche ou est en retard, et vous permet de décider.",
  kybRecertGuideTabs: "Les trois vues",
  kybRecertGuideTabsText: "« À traiter » : les décisions attendues. « Accès suspendus » : les accès bloqués faute de décision, que l'on peut réactiver. « Journal des décisions » : l'historique, qui ne se modifie pas.",
  kybRecertGuideCertify: "Certifier",
  kybRecertGuideCertifyText: "L'accès reste justifié : un nouveau cycle de 6 mois commence. Une justification est obligatoire.",
  kybRecertGuideRevoke: "Révoquer",
  kybRecertGuideRevokeText: "L'accès n'est plus justifié : il est suspendu et ne donne plus aucun droit. Une justification est obligatoire.",
  kybRecertGuideGrace: "Délai de grâce",
  kybRecertGuideGraceText: "Temps laissé après l'échéance pour décider. Passé ce délai sans décision, l'accès est suspendu automatiquement.",
  kybRecertGuideSituation: "Colonne Situation",
  kybRecertGuideSituationText: "Elle indique où en est l'échéance. Passez la souris sur chaque pastille pour en lire la signification.",
  kybRecertHintPhaseNotice: "L'échéance approche : rien d'urgent, vous pouvez déjà décider.",
  kybRecertHintPhaseGrace: "L'échéance est dépassée mais l'accès reste actif jusqu'à la fin du délai de grâce. Décidez avant cette date.",
  kybRecertHintPhaseOverdue: "Le délai de grâce est terminé : sans décision, l'accès sera suspendu automatiquement à la prochaine passe quotidienne.",
  kybRecertHintStatusPending: "Une décision de la conformité est attendue sur cet accès.",
  kybRecertHintStatusCertified: "L'accès a été confirmé comme justifié : un nouveau cycle a démarré.",
  kybRecertHintStatusRevoked: "L'accès a été retiré par la conformité : il ne donne plus aucun droit.",
  kybRecertHintStatusExpired: "Aucune décision dans le délai de grâce : l'accès a été suspendu automatiquement. Il peut être réactivé depuis « Accès suspendus ».",
  kybRecertHintStatusCancelled: "La recertification n'a plus d'objet, par exemple parce que l'accès a disparu avec son mandat.",
  kybAccessHintPending: "Le compte de l'utilisateur est en cours de création : il n'est pas encore utilisable.",
  kybAccessHintActive: "L'utilisateur peut se connecter et agir selon son profil.",
  kybAccessHintSuspended: "Le mandat qui justifiait cet accès n'existe plus (révoqué ou échu) : l'accès est bloqué.",
  kybAccessHintSuspendedRecert: "La recertification n'a pas été faite à temps : l'accès est bloqué jusqu'à sa réactivation.",
  kybRecertHintColDue: "Date à laquelle l'accès doit être reconfirmé.",
  kybRecertHintColGrace: "Dernier jour pour décider avant la suspension automatique.",
  kybRecertHintColAccess: "État actuel du compte corporate de l'utilisateur.",
  kybRecertHintColSituation: "Où en est l'échéance. Survolez une pastille pour la détailler.",
  kybMonitoringViewLedger: "Registre",
  kybMonitoringViewChart: "Graphique",
  kybMonitoringViewLabel: "Affichage",
  kybCaseVerifyBeneficiaries: "Vérifier les bénéficiaires effectifs",
  customerKindColumn: "Dossier",
  customerKindKyc: "KYC",
  customerKindKyb: "KYB",
  customerKindKycHint: "Dossier d'une personne physique (KYC)",
  customerKindKybHint: "Dossier d'une entreprise (KYB)",
  customerKindFilterLabel: "Régime",
  customerKindFilterAll: "KYC et KYB",
  customerKindFilterKyc: "KYC : personnes",
  customerKindFilterKyb: "KYB : entreprises",
  documentFreeTitle: "Déposer une autre pièce",
  documentFreeHint: "Pièce demandée au client en dehors de la liste ci-dessus : choisissez son type, puis le fichier.",
  documentFreeTypeLabel: "Type de pièce",
  documentFreeChoose: "Choisir un type",
  documentFreeUpload: "Choisir le fichier",
  documentFreeOther: "Autre pièce (saisie manuelle)",
  documentFreeOtherLabel: "Nom de la pièce",
  kybCaseStagesTitle: "Parcours du dossier",
  kybStageSubmission: "Soumission",
  kybStageInstruction: "Instruction",
  kybStageValidation: "Validation L1",
  kybStageDecision: "Décision",
  kybStageDetailBy: "Par",
  kybStageDetailAssignedTo: "Assignée à",
  kybStageDetailUnassigned: "Pas encore assignée",
  kybStageDetailRecorded: "Consigné :",
  kybStageDetailReadyBy: "Prêt, par",
  kybStageDetailAwaitingClient: "En attente du client : instruction suspendue",
  kybStageDetailAwaitingL1: "En attente d'un validateur L1",
  kybStageDetailValidatedBy: "Validé par",
  kybStageDetailAwaitingDecision: "En attente de la décision du responsable conformité",
  kybStageDetailRegulatoryHold: "En attente réglementaire",
  kybInstructionStateValidated: "Validé en L1",
  kybInstructionStateSuspended: "Instruction suspendue",
  kybValidationDoneBy: "Ce dossier a été validé en L1 par",
  serviceUnavailableTitle: "Le service est momentanément indisponible",
  serviceUnavailableHint: "Vos données ne sont pas perdues. Vérifiez votre connexion, puis réessayez dans quelques instants ; si le problème persiste, prévenez le support.",
  historySearchLabel: "Recherche",
  historySearchPlaceholder: "Titre, auteur ou détail",
  historyNoResult: "Rien ne correspond à ces filtres.",
  historyCount: "Entrées",
  historyEntryOne: "événement",
  historyEntryMany: "événements",
  eddHistoryEmpty: "Aucun événement n'a encore été enregistré.",
  verdictHistoryTitle: "Historique des contrôles",
  verdictHistoryLoadError: "L'historique des contrôles n'a pas pu être chargé.",
  verdictHistoryRetry: "Réessayer",
  verdictHistoryEmpty: "Aucun contrôle n'a encore été évalué pour ce client.",
  riskEntityHistoryFilterAction: "Action",
  kybComplementTypesMenu: "Pièces complémentaires",
  kybComplementTypesTitle: "Pièces complémentaires du KYB",
  kybComplementTypesSubtitle: "Les pièces que l'instruction peut réclamer à un client en complément d'un dossier. Une pièce n'est jamais supprimée : désactivée, elle n'est plus proposée mais reste lisible dans les demandes déjà émises.",
  kybComplementTypesGuideTitle: "À quoi sert cette page ?",
  kybComplementTypesGuideIntro: "Quand un analyste demande des pièces à un client, il les choisit dans cette liste, ou saisit une autre pièce à la main. Vous décidez ici de ce qui lui est proposé.",
  kybComplementTypesGuideAdd: "Ajouter",
  kybComplementTypesGuideAddText: "Choisissez un code court (majuscules et tirets bas, définitif) et un libellé lisible : c'est le libellé que verront l'analyste et le gestionnaire.",
  kybComplementTypesGuideDisable: "Désactiver",
  kybComplementTypesGuideDisableText: "Une pièce désactivée disparaît de la liste proposée, sans effacer les demandes passées. Vous pouvez la réactiver à tout moment.",
  kybComplementTypesGuideOrder: "Ordre",
  kybComplementTypesGuideOrderText: "Les pièces sont proposées du plus petit rang au plus grand. Les plus courantes en premier.",
  kybComplementTypesAdd: "Ajouter une pièce",
  kybComplementTypesColLabel: "Libellé",
  kybComplementTypesColCode: "Code",
  kybComplementTypesColOrder: "Rang",
  kybComplementTypesColState: "État",
  kybComplementTypesColActions: "Actions",
  kybComplementTypesActive: "Proposée",
  kybComplementTypesInactive: "Désactivée",
  kybComplementTypesHintActive: "Cette pièce est proposée à l'instruction.",
  kybComplementTypesHintInactive: "Cette pièce n'est plus proposée ; les demandes déjà émises la montrent toujours.",
  kybComplementTypesDisable: "Désactiver",
  kybComplementTypesEnable: "Réactiver",
  kybComplementTypesRename: "Modifier",
  kybComplementTypesEmpty: "Aucune pièce dans le catalogue.",
  kybComplementTypesLoadError: "Le catalogue n'a pas pu être chargé.",
  kybComplementTypesRetry: "Réessayer",
  kybComplementTypesDialogAddTitle: "Ajouter une pièce",
  kybComplementTypesDialogEditTitle: "Modifier la pièce",
  kybComplementTypesFieldCode: "Code",
  kybComplementTypesFieldCodeHelp: "Majuscules, chiffres et tirets bas, 2 à 60 caractères. Définitif.",
  kybComplementTypesFieldLabel: "Libellé",
  kybComplementTypesFieldOrder: "Rang d'affichage",
  kybComplementTypesInvalid: "Un code valide (majuscules, chiffres, tirets bas) et un libellé sont obligatoires.",
  kybComplementTypesSave: "Enregistrer",
  kybComplementTypesCancel: "Annuler",
  kybComplementTypesSaved: "Pièce enregistrée.",
  kybComplementTypesEnabled: "Pièce réactivée.",
  kybComplementTypesDisabled: "Pièce désactivée.",
  kybComplementTypesFailed: "L'opération n'a pas pu être enregistrée.",
  kybComplementTypesSearch: "Libellé ou code de la pièce",
  kybInstructionStateInProgress: "Instruction en cours",
  kybInstructionStateReady: "Prêt pour validation",
  kybInstructionNotesTitle: "Notes d'instruction",
  kybInstructionNotesHelp: "Gardez la trace de votre analyse. La note est datée, signée et visible dans l'historique ; elle ne peut plus être modifiée.",
  kybInstructionOwnerTitle: "Instructeur",
  kybInstructionAssignedTo: "Instruction confiée à",
  kybInstructionChangeOwner: "Changer d'instructeur",
  kybInstructionKeepOwner: "Garder cet instructeur",
  kybInstructionOwnerHelp: "Désignez l'analyste qui reprend l'instruction. L'historique garde tous les instructeurs : aucun d'eux ne pourra valider le dossier (séparation des tâches).",
  kybInstructionOwnerBranchFilter: "Agence",
  kybInstructionOwnerAnalyst: "Analyste",
  kybInstructionOwnerChoose: "Choisir un analyste",
  kybInstructionBranchRelevant: "Agence du dossier et siège",
  kybInstructionBranchAll: "Toutes les agences",
  kybInstructionBranchHeadOffice: "Siège (sans agence)",
  kybInstructionGroupCaseBranch: "Agence du dossier",
  kybInstructionGroupHeadOffice: "Siège",
  kybInstructionGroupOther: "Autres agences",
  kybInstructionOwnerNone: "Aucun analyste ne correspond à ce filtre.",
  kybInstructionOwnerLoadFailed: "La liste des analystes n'a pas pu être lue : saisissez l'identifiant de l'analyste.",
  kybInstructionOwnerManual: "Identifiant de l'analyste",
  kybInstructionComplementHeading: "Demander des pièces au client",
  kybInstructionComplementHelp: "Le dossier repasse en « attente du client », le délai d'instruction est suspendu et le gestionnaire de relations est prévenu des pièces demandées.",
  kybInstructionPiecesLegend: "Pièces à fournir",
  kybInstructionPieceMissing: "Manquante",
  kybInstructionPieceOther: "Autre pièce",
  kybInstructionPieceOtherPlaceholder: "Nom de la pièce demandée",
  kybInstructionPieceAdd: "Ajouter",
  kybInstructionPieceRemove: "Retirer",
  kybInstructionPiecesSelected: "pièce(s) demandée(s)",
  kybInstructionComplementSend: "Envoyer la demande au client",
  kybInstructionReadyHeading: "Passer à la validation",
  kybInstructionReadyHelp: "Quand l'instruction est terminée et que toutes les pièces obligatoires sont reçues, marquez le dossier prêt : un autre responsable pourra alors le valider.",
  kybMonitoringOutOf: "sur",
  kybMonitoringShareOfTotal: "du total",
  kybMonitoringShareOfOpen: "des EDD ouverts",
  kybMonitoringSegmentClosed: "Clôturés",
  kybMonitoringSegmentOpenOnTime: "Ouverts, dans les délais",
  kybMonitoringSegmentOverdue: "Ouverts, en retard",
  kybMonitoringSegmentOtherStates: "Autres états (actifs, suspendus pour recertification)",
  kybMonitoringSegmentPending: "En attente de provision",
  kybMonitoringSegmentSuspended: "Suspendus (mandat révoqué ou expiré)",
  kybMonitoringCasesHint: "Ouvrez un dossier pour le consulter.",
  kybMonitoringColCase: "Entreprise",
  kybMonitoringColKey: "Clé du dossier",
  kybMonitoringGuideTitle: "À quoi sert cette page ?",
  kybMonitoringGuideIntro: "Elle donne l'état du portefeuille KYB à l'instant de la lecture : où en sont les bénéficiaires effectifs, les diligences renforcées et les accès corporate sensibles.",
  kybMonitoringGuideSections: "Les sections",
  kybMonitoringGuideSectionsText: "Chaque section n'apparaît que si votre profil a le droit de la lire. Sa date de lecture est rappelée en haut à droite.",
  kybMonitoringGuideChart: "Registre ou graphique",
  kybMonitoringGuideChartText: "Le registre détaille chaque indicateur avec sa définition ; le graphique compare les chiffres d'un coup d'œil, barres à l'échelle de la section.",
  kybMonitoringGuideCases: "Voir les dossiers",
  kybMonitoringGuideCasesText: "Cliquez sur un chiffre ou sur « Voir les dossiers » pour ouvrir la liste des dossiers comptés, puis ouvrez-en un.",
  kybMonitoringGuideUnavailable: "« Indisponible »",
  kybMonitoringGuideUnavailableText: "Un indicateur indisponible n'est pas un zéro : la source n'a pas pu être lue, la raison est indiquée.",
  kybHitJustificationRequired: "La justification est obligatoire (10 caractères au moins).",
  kybHitActionFailed: "La conclusion n'a pas pu être enregistrée.",
  kybHitConclusionLabel: "Conclusion",
  kybInstructionAssignLabel: "Assigner à un analyste (identifiant)",
  kybInstructionAssignButton: "Assigner",
  kybInstructionAssigneeRequired: "L'identifiant de l'analyste est obligatoire.",
  kybInstructionAssigned: "Instruction assignée.",
  kybInstructionComplementTitle: "Demander un complément",
  kybInstructionComplementPieces: "Pièces requises (une par ligne)",
  kybInstructionComplementMessage: "Message au gestionnaire de relations (facultatif)",
  kybInstructionComplementButton: "Demander le complément",
  kybInstructionPiecesRequired: "Au moins une pièce requise est obligatoire.",
  kybInstructionComplementRequested: "Complément demandé, le dossier attend maintenant le client.",
  kybInstructionReadyButton: "Marquer prêt pour validation",
  kybInstructionReadyAlready: "Le dossier est prêt pour validation.",
  kybInstructionClosed: "L'instruction est close : le dossier est prêt et attend la validation de niveau 1. Elle ne peut plus être modifiée tant qu'elle n'est pas rouverte.",
  kybReopenButton: "Rouvrir l'instruction",
  kybReopenConfirm: "Rouvrir",
  kybReopenReasonLabel: "Motif (obligatoire, consigné au journal du dossier)",
  kybReopenEffect: "Le dossier n'est plus prêt pour validation : il repasse en instruction, où l'on peut de nouveau commenter, changer d'instructeur et demander des pièces. Il faudra le marquer prêt de nouveau.",
  kybValidationSendBack: "Renvoyer en instruction",
  kybInstructionMarkedReady: "Dossier marqué prêt pour validation.",
  kybValidationTitle: "Validation à quatre yeux (L1)",
  kybValidationJustificationLabel: "Justification de la validation",
  kybValidationJustificationRequired: "La justification est obligatoire.",
  kybValidationNotReady: "L'instructeur doit marquer le dossier prêt avant sa validation.",
  kybValidationPrereqTitle: "Avant de valider",
  kybValidationPrereqReady: "L'instructeur a marqué le dossier prêt pour validation",
  kybValidationPrereqIndependent: "Vous n'êtes ni l'instructeur assigné ni celui qui a marqué le dossier prêt",
  kybValidationPrereqNotIndependent: "Vous avez contribué à l'instruction : un autre responsable doit valider (séparation des tâches)",
  kybValidationPrereqIndependentHelp: "Le serveur contrôle toutes les contributions à l'instruction (notes, conclusions, assignation) : un refus est journalisé.",
  kybValidationPrereqComment: "Justification de la validation saisie",
  kybValidationPrereqSeeInstruction: "Voir l'instruction",
  kybValidationButton: "Valider le dossier",
  kybValidationDone: "Dossier validé (quatre yeux).",
  kybDecisionTitle: "Décision de la conformité (P4)",
  kybDecisionOptionApprove: "Approuver",
  kybDecisionOptionApproveWithRestrictions: "Approuver avec restrictions",
  kybDecisionOptionReject: "Rejeter",
  kybDecisionOptionRegulatoryHold: "Mettre en attente réglementaire",
  kybDecisionJustificationLabel: "Justification de la décision",
  kybDecisionJustificationRequired: "La justification est obligatoire.",
  kybDecisionRestrictionsLabel: "Restrictions appliquées",
  kybDecisionRestrictionsRequired: "Les restrictions sont obligatoires pour cette décision.",
  kybDecisionChooseOption: "Choisissez une décision.",
  kybDecisionConfirmButton: "Confirmer la décision",
  kybDecisionDone: "Décision enregistrée.",
  kybDecisionEligibilityError: "Impossible de lire les conditions de décision.",
  kybDecisionBlockedTitle: "L'approbation n'est pas possible pour le moment :",
  kybGuardNotValidatedL1: "Le dossier n'est pas passé par la validation à quatre yeux (L1).",
  kybGuardScreeningPending: "Le screening d'une partie du dossier n'est pas terminé.",
  kybGuardScreeningHitUnqualified: "Un hit de screening n'est pas qualifié.",
  kybGuardSanctionsConfirmedMatch: "Une correspondance de sanctions est confirmée.",
  kybGuardRccmNotVerified: "Aucune immatriculation RCCM n'est vérifiée.",
  kybGuardEddInProgress: "Le dossier EDD exigé n'est pas encore approuvé.",
  kybGuardEddRejected: "Le dossier EDD a été refusé ou clos sans approbation.",
  kybGuardGo: "Y aller",
  kybGuardGoEdd: "Ouvrir les dossiers EDD",
  kybCbsTitle: "Ouverture du compte au CBS",
  kybCbsStateUnavailable: "L'envoi au CBS est désactivé (contrat de la banque non livré).",
  kybCbsStateWaiting: "L'ouverture au CBS est en attente d'envoi ou de nouvel essai.",
  kybCbsStatePushed: "L'ouverture est confirmée côté CBS.",
  kybCbsStateAbandoned: "L'ouverture au CBS a échoué définitivement : corrigez la cause, puis relancez-la.",
  kybCbsPushStatusPending: "À envoyer",
  kybCbsPushStatusRetry: "À rejouer",
  kybCbsPushStatusUnknown: "Issue incertaine, vérifiée avant tout renvoi",
  kybCbsPushStatusDone: "Terminée",
  kybCbsPushStatusDead: "Abandonnée, reprise manuelle possible",
  kybCbsAttempts: "Tentatives",
  kybCbsNextAttempt: "Prochaine tentative",
  kybCbsLastError: "Dernier échec",
  kybCbsReference: "Référence de l'opération CBS",
  kybCbsReferenceHelp: "Identifiant de l'opération chez le CBS, pour la retrouver côté banque.",
  kybCbsCopy: "Copier la référence",
  kybCbsCopied: "Référence copiée.",
  kybCbsPushedAt: "Confirmée le",
  kybCbsRetryButton: "Relancer l'ouverture",
  kybCbsRetried: "L'ouverture a été remise en file.",
  kybCbsNone: "Aucune ouverture n'est en file pour ce dossier.",
  kybCbsReadError: "Impossible de lire l'état de l'ouverture au CBS.",
  uboPartiesTitle: "Détenteurs et parties qui contrôlent",
  uboPartiesEmpty: "Aucune partie déclarée pour le moment.",
  uboAddPersonTitle: "Ajouter une personne physique",
  uboAddLegalPartyTitle: "Ajouter une société interposée",
  uboRoleLabel: "Rôle",
  uboRolePlaceholder: "Choisir un rôle",
  uboLastName: "Nom",
  uboFirstName: "Prénom",
  uboBirthDate: "Date de naissance",
  uboNationality: "Nationalité",
  uboDenomination: "Raison sociale",
  uboLegalForm: "Forme juridique",
  uboRegistration: "Numéro d'immatriculation",
  uboCountry: "Pays",
  uboAddPersonButton: "Ajouter la personne",
  uboAddLegalPartyButton: "Ajouter la société",
  uboPersonFieldsRequired: "Le rôle, le nom et le prénom sont obligatoires.",
  uboLegalPartyFieldsRequired: "Le rôle et la raison sociale sont obligatoires.",
  uboDuplicateTitle: "Une personne similaire existe déjà",
  uboDuplicateReuse: "Réutiliser",
  uboDuplicateCreateAnyway: "Créer quand même",
  uboDuplicateCancel: "Annuler",
  uboEdgesTitle: "Liens de détention",
  uboEdgesEmpty: "Aucun lien déclaré pour le moment.",
  uboEdgeOwner: "Détenteur",
  uboEdgeTarget: "Entité détenue",
  uboEdgeTargetRoot: "La société du dossier",
  uboEdgeNature: "Nature",
  uboNatureCapital: "Capital",
  uboNatureVoting: "Droits de vote",
  uboNatureControl: "Autre contrôle",
  uboEdgePercentage: "Pourcentage (%)",
  uboEdgeControlBasis: "Fondement du contrôle",
  uboEdgeAddButton: "Ajouter le lien",
  uboEdgeRemoveButton: "Retirer",
  uboEdgeFieldsRequired: "Choisissez un détenteur, une nature et le pourcentage (ou le fondement du contrôle).",
  uboEdgePercentageInvalid: "Le pourcentage doit être supérieur à 0 et au plus égal à 100, avec trois décimales au plus.",
  shareCapitalInvalid: "Le capital social doit être un nombre entier supérieur à 0.",
  entrepriseFieldTooLong: "Cette valeur est trop longue.",
  declarantEmail: "Email du déclarant",
  declarantPhone: "Téléphone du déclarant",
  declarantContactReadOnly: "Le déclarant se saisit et se vérifie à la création du prospect : ici il se lit sans se modifier. L'e-mail et le téléphone de l'entreprise, eux, s'enregistrent ici.",
  representativeExistingCustomer: "Client de la banque :",
  representativeExistingCustomerNote: "Son identité, sa date de naissance, sa nationalité et sa profession sont reprises de sa fiche : indiquez seulement le rôle.",
  uboAnalysisTitle: "Bénéficiaires effectifs et opacité",
  uboAnalysisRefresh: "Actualiser l'analyse",
  uboExportPdf: "Exporter en PDF",
  uboExportJson: "Exporter en JSON",
  uboOwnersEmpty: "Aucun bénéficiaire effectif calculé pour le moment.",
  uboOriginHolding: "Par détention",
  uboOriginControl: "Par contrôle",
  uboOriginDefaultDirector: "Dirigeant par défaut",
  uboCapitalPercent: "Capital effectif",
  uboVotePercent: "Droits de vote effectifs",
  uboThreshold: "Seuil",
  uboOpacityScore: "Score d'opacité",
  uboOpacityEddRecommended: "Un examen renforcé est recommandé.",
  uboOpacityLevelLow: "Faible",
  uboOpacityLevelMedium: "Moyen",
  uboOpacityLevelHigh: "Élevé",
  uboFallbackTitle: "Repli sur le dirigeant",
  uboFallbackHint: "À utiliser seulement si aucun bénéficiaire effectif ne peut être établi. Un responsable conformité (P4) doit le valider.",
  uboFallbackDirector: "Dirigeant retenu",
  uboFallbackJustification: "Pourquoi aucun bénéficiaire effectif ne peut être établi (30 caractères minimum)",
  uboFallbackSaveButton: "Enregistrer le brouillon",
  uboFallbackSubmitButton: "Soumettre à validation",
  uboFallbackFieldsRequired: "Choisissez le dirigeant et donnez une justification.",
  uboFallbackStatus: "Statut",
  uboFallbackStatusDraft: "Brouillon",
  uboFallbackStatusSubmitted: "En attente de validation P4",
  uboFallbackStatusValidated: "Validé",
  uboFallbackStatusRejected: "Refusé, le dossier reste bloqué",
  uboFallbackStatusObsolete: "Obsolète, un bénéficiaire effectif est apparu",
  uboFallbackDecisionReason: "Motif de la décision",
  kybFallbackDecisionTitle: "Repli dirigeant à statuer",
  kybFallbackDecisionApprove: "Valider le repli",
  kybFallbackDecisionReject: "Refuser le repli",
  kybFallbackDecisionReasonLabel: "Motif (obligatoire pour refuser)",
  kybFallbackDecisionReasonRequired: "Un motif est obligatoire pour refuser le repli.",
  kybFallbackDecisionDone: "Décision sur le repli enregistrée.",
  accountOpeningTitle: "Récapitulatif final & ouverture de compte",
  accountOpeningRecapCompanyName: "Entreprise",
  accountOpeningRecapLegalForm: "Forme juridique",
  accountOpeningRecapShareholders: "Actionnaires",
  accountOpeningRecapScreening: "Screening",
  accountOpeningRecapScoreDecision: "Score · Décision",
  accountOpeningRecapSignatoriesTitle: "Signataires à enregistrer",
  accountOpeningBlockedMessage:
    "Le compte ne peut être créé que lorsque le dossier a été approuvé.",
  accountOpeningCreateButton: "Créer le compte",
  accountOpeningConfirmTitle: "Créer le compte ?",
  accountOpeningConfirmDescription:
    "Cette action est irréversible : le compte et ses signataires seront créés dans Orion.",
  accountOpeningConfirmAction: "Confirmer la création",
  accountOpeningSuccessMessage: "Compte créé avec succès.",
  accountOpeningAccountNumberLabel: "Numéro de compte",
  accountOpeningSignatoriesLabel: "Signataires",

  stepEvidencePack: "Evidence pack",
  evidencePackTitle: "Evidence pack",
  evidencePackDescription:
    "Récapitulatif exportable du dossier, conforme à l'instruction applicable, avec la date de la prochaine revue périodique.",
  evidencePackGenerateButton: "Générer & exporter l'evidence pack",
  evidencePackLoading: "Génération de l'evidence pack…",
  evidencePackComplianceStatement:
    "Cet evidence pack est conforme à l'Instruction BCEAO n°003-03-2025.",
  evidencePackReferenceLabel: "Référence",
  evidencePackGeneratedAtLabel: "Généré le",
  evidencePackNextReviewDateLabel: "Prochaine revue périodique",
  evidencePackDownloadButton: "Télécharger (PDF)",
  evidencePackRegenerateButton: "Régénérer",
  evidencePackContinueButton: "Ouverture du compte",
  evidencePackHashLabel: "Hash",
  evidencePackSectionIdentification: "Identification client",
  evidencePackSectionRegistration: "Immatriculation & Fiscalité",
  evidencePackSectionRepresentation: "Représentant légal & Mandats",
  evidencePackSectionShareholding: "Actionnariat & UBO",
  evidencePackSectionDocuments: "Documents reçus",
  evidencePackSectionScreening: "Résultats screening",
  evidencePackSectionRiskScore: "Score de risque",
  evidencePackSectionDecision: "Décision KYB",
  evidencePackSectionRestrictions: "Restrictions éventuelles",
  evidencePackSectionAuditTrail: "Audit trail",
  evidencePackSectionStatusVerified: "Vérifié",
  evidencePackSectionStatusComplete: "Complet",
  evidencePackSectionStatusPartial: "Partiel",
  evidencePackSectionStatusMissing: "Manquant",
  evidencePackDetailVerified: "Vérifié",
  evidencePackDetailNotVerified: "Non vérifié",
  evidencePackDetailMissing: "Manquant",
  evidencePackDetailComplete: "Complet",
  evidencePackDetailPartial: "Partiel",
  evidencePackDetailHitConfirmed: "Hit confirmé",
  evidencePackDetailNone: "Aucune",
  evidencePackDetailRestrictionsApplied: "Restrictions appliquées",
  evidencePackDetailAwaitingDecision: "En attente de décision",

  request: "Demande",
  partsApproval: "Pièces & Consentements",
  metadataOcr: "Métadonnées & OCR",
  summaryValidation: "Résumé & validation",
  reviewSummaryTitle: "Récapitulatif — Validation avant création client",
  verifyBeforeCreate:
    "Vérifiez l'ensemble des informations avant de confirmer la création",
  screeningAndProfile: "Screening & Profil",
  screeningRule: "Règle",
  screeningDetail: "Détail",
  noScreeningRules: "Aucune règle de contrôle",
  screeningRulesPending: "Contrôles en cours, les résultats arrivent...",
  screeningRulesUnavailable: "Les contrôles sont indisponibles pour le moment. Réessayez dans quelques instants ou signalez-le au support.",
  screeningProvider: "Source",
  screeningAdvisoryNotice: "Le contrôle externe VNeurone est consultatif : son verdict est enregistré et transmis à la conformité, mais il ne bloque pas l'entrée en relation. La décision finale est notifiée séparément.",
  screeningExternalNotStarted: "Le contrôle d'éligibilité externe n'a pas encore répondu. Il est lancé en parallèle et son résultat s'affichera ici : ce n'est pas une anomalie.",
  screeningExternalPending: "Le contrôle d'éligibilité externe a ouvert une revue chez le partenaire bancaire. Un analyste y lève les correspondances homonymes ; sa décision nous sera notifiée. L'entrée en relation n'est pas bloquée pendant ce temps.",
  riskFactorsTitle: "Facteurs de risque",
  riskFactorsDecisive: "Facteurs déterminants",
  riskFactorsOthers: "Autres facteurs évalués",
  riskFactorsScore: "Score",
  riskFactorsCompleteness: "Complétude du dossier",
  riskFactorsHardOverride: "Règle de surclassement appliquée",
  riskFactorsUnavailable:
    "Le détail des facteurs de risque n'est pas disponible pour ce dossier.",
  riskFactorNotApplicable: "Non évalué",
  riskFactorUnknownCode: "Code inconnu",
  riskFactorNoValue: "Aucune valeur renseignée",
  riskFactorsColEntity: "Entité",
  riskFactorsColValue: "Valeur retenue",
  riskFactorsColLevel: "Niveau",
  riskFactorsColPoints: "Points",
  riskFactorsAssessedEntities: "entités évaluées",

  // Screening step & OCR
  ocrExtractionTitle: "Extraction OCR",
  ocrExtractionDescription:
    "Les champs issus de l’OCR peuvent être vérifiés et corrigés avant enregistrement.",
  ocrStatusInProgress: "EN COURS",
  ocrStatusFailed: "ÉCHEC",
  ocrStatusReady: "PRÊT",
  screeningInvalidIdTitle: "Pièce d'identité invalide",
  screeningInvalidIdDescription:
    "Vous ne pouvez pas continuer avec une pièce d'identité invalide. Veuillez téléverser un nouveau document valide.",
  screeningInvalidIdInline:
    "Vous ne pouvez pas continuer tant que la pièce d'identité est invalide.",
  ocrApplyButton: "Valider et enregistrer",
  ocrApplyButtonLoading: "En cours...",

  // Result Screening
  SANCTIONS_PEP: "Sanctions PEP",
  ELIGIBILITE_EXTERNE: "Contrôle éligibilité externe",
  screeningStatus_clean_label: "CLEAN",
  screeningStatus_pending_label: "EN ATTENTE",
  screeningStatus_reject_label: "REFUS",
  COMPLETUDE: "Complétude",
  OCR_QUALITE: "Qualité OCR",
  COHERENCE_IDENTITE: "Coherence identité",
  RISQUE_INITIAL: "Risque initial",

  productsAccounts: "Produits & Comptes",
  productsAccountsDescription:
    "Sélectionnez le type de client, le produit et les services demandés.",
  screeningContext: "Contexte de screening",
  majorMinor: "Majeur/Mineur",
  resident: "Résident",
  nonResident: "Non-résident",
  pepStatus: "Statut PEP",
  clientType: "Type de client",
  product: "Produit",
  productCategory: "Catégorie de produit",
  additionalServices: "Services supplémentaires",
  classicCreditCard: "Carte de crédit classique",
  classicCreditCardDescription: "Carte de débit classique",
  smsBanking: "SMS Banking",
  smsBankingDescription: "Alertes et opérations par SMS",
  internetBanking: "Internet Banking",
  internetBankingDescription: "Accès web aux opérations",
  checkbook: "Chéquier",
  checkbookDescription: "Carnet de chèques nominatif",

  // Screening status pills (labels)
  screeningStatus_ok_label: "OK",
  screeningStatus_avert_label: "AVERT.",
  screeningStatus_alerte_label: "ALERTE",
  screeningStatus_echec_label: "ECHEC",
  screeningStatus_clear_label: "CLEAR",
  screeningStatus_faible_label: "FAIBLE",
  screeningStatus_standard_label: "STANDARD",
  screeningStatus_high_label: "ÉLEVÉ",
  screeningStatus_unknown_label: "INCONNU",
  screeningStatus_unknown_tooltip: "Statut de screening non reconnu.",

  // Screening status pills (tooltips by rule)
  screeningStatus_risqueInitial_ok: "Aucun risque détecté.",
  screeningStatus_risqueInitial_avert:
    "Risque modéré (pièce invalide, documents manquants…).",
  screeningStatus_risqueInitial_alerte: "Risque élevé, revue manuelle requise.",

  screeningStatus_coherenceIdentite_ok: "Données concordantes.",
  screeningStatus_coherenceIdentite_avert:
    "Match partiel (par exemple prénoms seulement).",
  screeningStatus_coherenceIdentite_echec:
    "Incohérence identité ou pièce non valide.",

  screeningStatus_ocrQualite_ok:
    "Qualité vérifiée, données OCR extraites correctement.",
  screeningStatus_ocrQualite_echec:
    "Données OCR manquantes ou illisibles, contrôle manuel requis.",

  screeningStatus_completude_ok:
    "Tous les documents KYC requis ont été fournis.",

  screeningStatus_sanctionsPep_clear: "Aucun match sanctions / PEP détecté.",
  screeningStatus_sanctionsPep_faible:
    "Matchs de faible pertinence, à surveiller.",
  screeningStatus_sanctionsPep_standard:
    "Matchs pertinents, une revue détaillée est requise.",
  screeningStatus_sanctionsPep_high:
    "Matchs de haute pertinence, risque élevé de sanctions / PEP.",

  // Additional Documents Step (Onboarding)
  additionalDocumentsStepTitle: "Documents supplémentaires",
  requiredShort: "Obligatoires",
  optionalShort: "Optionnels",
  validatedShort: "Validés",
  pendingShort: "En attente",
  idDocumentName: "Pièce d'identité",
  proofOfResidenceUnder3Months: "Justificatif de domicile < 3 mois",
  signedOpeningForm: "Formulaire d'ouverture signé",
  pepDeclaration: "Déclaration PEP",
  savingsObjectiveCertificate: "Attestation objectif épargne",

  // OCR sections
  ocrAddressContactTitle: "Adresse & contact",
  ocrIdentityTitle: "Identité du client",
  ocrDocumentDetailsTitle: "Détails du document",
  ocrDocumentDetailsDescription:
    "Informations extraites du document d'identité. Vérifiez et corrigez si nécessaire.",
  ocrFamilyTitle: "Situation familiale",
  ocrProfessionalTitle: "Situation professionnelle",
  ocrAdditionalFieldsTitle: "Champs complémentaires",
  placeholderPaysProfessionExample: "Ex: CI",

  // OCR placeholders/examples
  placeholderCityExample: "ex: Paris",
  placeholderPostalCodeExample: "ex: 75001",
  placeholderPlaceOfBirthExample: "ex: Paris",
  placeholderDocumentNumberExample: "Ex: CI1234567890",
  placeholderCountryExample: "ex: Côte d'Ivoire",
  placeholderNumberOfChildrenExample: "ex: 2",
  placeholderProfessionExample: "Ex: Chef d'entreprise",
  placeholderActivitySectorExample: "ex: Agriculture",
  placeholderSalaryExample: "ex: 450 000",

  // Core Banking Search
  coreBanking: "Core banking",
  searchCoreBanking: "Rechercher un client dans le core banking",
  searchCoreBankingDescription:
    "Saisissez un numéro de compte pour interroger le core banking. Les résultats apparaîtront dans la liste.",
  accountNumber: "Numéro de compte",
  searchCoreBankingTip:
    "Astuce : vous pouvez fermer cette boîte de dialogue, les résultats core banking restent visibles dans la liste.",

  // Empty State Messages
  noCustomersFound: "Aucun client ne correspond à votre recherche.",
  tryAdjustingFilters:
    "Essayez d'ajuster vos filtres pour obtenir plus de résultats.",
  startSearching: "Commencez par rechercher ou ajuster les filtres ci-dessus.",

  access_generated_successfully: "Accès généré avec succès",
  access_generated_successfully_description:
    "L'accès a été généré avec succès. Vous pouvez maintenant vous connecter.",
  access_generated_failed: "Échec de la génération de l'accès",
  access_generated_failed_description:
    "Une erreur s'est produite lors de la génération.",
  access_generating: "Génération en cours...",
  access_generating_description:
    "La génération de l'accès est en cours. Veuillez patienter.",
  regenerate_access: "Régénérer accès",
  generate_access: "Générer accès",
  revoke_access: "Révoquer accès",
  revoke_confirm_title: "Confirmer la révocation d'accès",
  revoke_confirm_description:
    "Cette action révoque immédiatement l'accès du prospect. Le motif est obligatoire.",
  revoke_sensitive_warning:
    "Action sensible : l'accès sera désactivé immédiatement.",
  revoke_reason_label: "Motif",
  revoke_reason_placeholder: "Sélectionner un motif",
  revoke_reason_suspicion_fraud: "Suspicion de fraude",
  revoke_reason_creation_error: "Erreur de création",
  revoke_reason_end_relationship: "Fin de relation prospect",
  revoke_reason_customer_request: "Demande du prospect",
  revoke_reason_internal_control: "Contrôle interne",
  revoke_reason_other: "Autre",
  revoke_reason_custom_placeholder: "Précisez le motif (minimum 10 caractères)",
  revoke_reason_min_counter: "{{count}}/10 caractères minimum",
  revoke_confirm_button: "Confirmer la révocation",
  revoke_confirming_button: "Révocation...",
  access_revoking: "Révocation de l'accès en cours...",
  access_revoking_description:
    "Veuillez patienter pendant la révocation des credentials.",
  access_revoked_successfully: "Accès révoqué",
  access_revoked_successfully_description:
    "L'accès du prospect a été révoqué avec succès.",
  access_revoke_failed: "Échec de la révocation d'accès",
  access_revoke_failed_description:
    "La révocation a échoué. Veuillez réessayer.",
  access_revoked_alert_title: "Accès révoqué",
  access_revoked_alert_description:
    "L'accès a été révoqué. Les accès de ce prospect sont coupés.",

  missing: "Manquant",
  uploaded: "Téléchargé",
  verified: "Vérifié",
  required: "Obligatoire",
  optional: "Optionnel",
  clickToUpload: "Glisser-déposer ou cliquez pour ajouter",
  notdocumentToUpload: "Aucun document à télécharger",
  notdocumentToUploadDescription:
    "Il n'y a aucun document à télécharger, vous pouvez soumettre l'oanboarding.",

  // KYC
  civilIdentity: "Identité civile",
  actionRequired: "Action requise",
  officialIdentifiers: "Identifiants officiels",
  notExpired: "Non expiré",
  changeIdentity: "Remplacement de la pièce d'identité",
  contactDetails: "Coordonnées",
  mainMobileNumber: "Téléphone principal",
  secondaryMobileNumber: "Téléphone secondaire",
  taxationCompliance: "Fiscalité & conformité",
  declarationPEP: "Déclaration PEP",
  CountryOfTaxation: "Pays de résidence fiscale",
  TaxIDNumber: "TIN / N° fiscal",
  pep: "PEP",
  residentStatus: "Statut résident",
  residenceAddress: "Adresse de résidence",
  changeAddress: "Changement d'adresse",
  reference: "Référence",
  balance: "Solde",
  money: "Devise",
  rib: "RIB",
  openAt: "Ouvrir le",
  downloadRIB: "Télécharger le RIB",
  ribDownloading: "Génération du RIB...",
  ribDownloaded: "RIB téléchargé",
  ribDownloadError: "Impossible de télécharger le RIB",
  miniStatement: "Mini-relevé",
  viewMiniStatement: "Voir le mini-relevé",
  comingSoon: "Bientôt disponible",
  debit: "Débit",
  movementLabel: "Libellé",
  movementSense: "Sens",
  movementAmount: "Montant",
  movementBalanceAfter: "Solde après opération",
  noMovements: "Aucune écriture sur ce compte",
  miniStatementLoadError: "Impossible de charger le mini-relevé",
  customerDocuments: "Documents du client",
  expiration: "Expiration",
  reusable: "Réutilisable",
  RelatedRequest: "Demandes liées",
  civility: "Civilité",
  sectorActivity: "Secteur d'activité",
  comment: "Commentaire",
  contactForSavingCardCredit: "Contact épargne / carte / crédit",

  // Dashboard Page Not Ready
  dashboardPageNotReady: "Tableau de bord en cours de développement",
  dashboardPageNotReadyDescription:
    "Cette page est actuellement en cours de développement. Elle sera bientôt disponible avec des fonctionnalités complètes pour la gestion de votre tableau de bord",

  // Prospects & Client360 - Common
  all: "Tous",
  legalPerson: "Personne morale",
  moreCharacters: "de plus",
  start: "Début",
  end: "Fin",
  datePlaceholder: "dd/mm/yyyy",
  invalidAccountNumber: "Ce numéro de compte est invalide.",
  accountNumberExample: "Ex: 00XXXXXXXXXX",
  pageOf: "Page {0} sur {1}",
  searchAndFilterProspects: "Recherchez et filtrez les prospects",
  identityRepository: "Référentiel Identité",
  importCsv: "Importer CSV",
  newProspectRequest: "Nouvelle demande prospect",
  importing: "Importation...",
  importAction: "Enregistrer dans le référentiel",

  // Prospects - Status & Types
  eligible: "Eligible",
  toComplete: "To complete",
  refused: "Refused",
  duplicatePending: "Duplicate pending",
  web: "Web",
  branch: "Branch",
  corporate: "Corporate",
  clearScreening: "Clear",
  possible: "Possible",
  matchedSanction: "Matched sanction",
  noneScreening: "None",

  // Core Banking Columns
  clientCode: "Code client",
  lastNameColumn: "Nom",
  genderColumn: "Genre",
  nationalityColumn: "Nationalité",
  maritalStatusColumn: "Statut Marital",
  postalCodeColumn: "Code postal",
  phoneColumn: "Téléphone",
  lastUpdateAbbr: "MAJ",

  Voir: "Voir",
  minor: "Mineur",
  major: "Majeur",
  sinceAt: "Depuis le",
  viewer: "Visualiser",

  digits: "chiffres",
  maxPhoneCharactersMessage: "Le numéro de téléphone ne peut pas dépasser",
  minPhoneCharactersMessage: "Le numéro de téléphone doit comporter au moins",

  assignments: "Assignations",
  attributeRole: "Attribuer de rôle",
  noRolesFound: "Aucun rôle trouvé",
  rolesPerPage: "Rôles par page",

  // Administration
  featureComingSoon:
    "Cette fonctionnalité sera bientôt disponible en production.",
  rolesAndRights: "Rôles & Droits (RBAC)",
  rolesAndRightsDescription:
    "Administration des rôles, utilisateurs et paramètres de sécurité",
  newUser: "Nouvel utilisateur",
  newUserDialogTitle: "Ajouter un nouvel utilisateur manuellement",
  newUserDialogDescription:
    "Création d'un utilisateur sans synchronisation AD. Renseignez les informations d'identité.",
  editImportDescription:
    "Renseignez les informations pour l'enregistrement manuel d'un utilisateur.",
  phone1: "Téléphone principal",
  email1: "Email principal",
  phone2: "Téléphone secondaire",
  email2: "Email secondaire",
  chooseOrEnterEmail: "Choisir ou saisir un email",
  chooseOrEnterPhone: "Choisir ou saisir un numéro de téléphone",
  kycInformation: "Informations KYC",

  // fiche-client360 specific
  identityDocument: "Pièce d'identité",
  phoneNumbers: "Numéros de téléphone",
  primaryPhone: "Téléphone principal",
  secondaryPhone: "Téléphone secondaire",
  fax: "Fax",
  primaryEmail: "Email principal",
  secondaryEmail: "Email secondaire",
  emailAddresses: "Adresses email",
  noPhoneProvided: "Aucun numéro de téléphone renseigné",
  noEmailProvided: "Aucune adresse email renseignée",
  notDetermined: "Non déterminé",
  recentScreeningReports: "Rapports Screening récents",
  accountsOverview: "Comptes (aperçu)",
  viewAllAccounts: "Voir tous les comptes",
  complianceTitle: "Conformité",
  nextReKYC: "Prochaine Re-KYC",
  consentsSummary: "Consentements (résumé)",
  openConsentCenter: "Ouvrir Consent Center",
  noResult: "Aucun résultat",
  loadingError: "Erreur lors du chargement",
  title: "Titre",
  dataset: "Dataset",
  statusRating: "Statut/Rating",
  profileNotFound: "Profil introuvable",
  profileNotFoundDescription:
    "Le profil que vous recherchez n'existe pas ou a été supprimé.",
  notVerified: "Non vérifié",
  otpVerificationRequired:
    "La modification du téléphone ou de l'email nécessite une vérification par code OTP.",
  verificationCodeSent: "Code de vérification envoyé au",
  didNotReceiveCode: "Vous n'avez pas reçu le code ?",
  resendIn: "Renvoyer dans",
  resendCode: "Renvoyer le code",
  sendCode: "Envoyer le code",
  enterMinDigitsToReceiveCode:
    "Saisissez au moins 10 chiffres pour recevoir le code de vérification.",
  enterValidEmailToReceiveCode:
    "Saisissez une adresse email valide pour recevoir le code de vérification.",
  verify: "Vérifier",

  // Client360 - access regeneration tooltip
  verify_contacts_before_regenerate_access:
    "Vérifiez l'email ou le téléphone du client pour activer la régénération de l'accès.",

  // Onboarding – validation errors
  onboarding_identityDocRequired:
    "Une pièce d'identité (CNI ou Passeport) est requise",
  onboarding_addressProofRequired: "Un justificatif de domicile est requis",
  onboarding_idInvalidUploadNew:
    "La pièce d'identité est invalide. Veuillez téléverser un nouveau document valide.",
  onboarding_applyOcrAndFillRequired:
    "Veuillez appliquer le formulaire OCR et renseigner tous les champs obligatoires.",
  onboarding_productsAccountsRequired:
    "Les informations de produits et comptes sont requises",
  onboarding_uploadRequiredDocsFirst:
    "Veuillez d'abord télécharger les documents requis",

  // Onboarding – toasts & submit
  onboarding_resubmit: "Re-soumettre",
  onboarding_submittedSuccess: "Onboarding soumis avec succès",
  onboarding_submitError:
    "Une erreur s'est produite lors de la soumission du formulaire",
  onboarding_businessKeyMissing: "BusinessKey manquant",
  onboarding_submitFailed: "Échec de soumission de l'onboarding",
  onboarding_productsSaveSuccess:
    "Sauvegarde des produits terminée avec succès !",
  onboarding_productsSaveSuccessDesc:
    "Les produits ont été sauvegardés et en cours de traitement.",
  onboarding_productsSaveFailed: "Échec de la sauvegarde des produits",
  onboarding_productsSaveFailedDesc:
    "Les produits n'ont pas pu être sauvegardés.",
  onboarding_productsSaving: "Sauvegarde des produits en cours...",
  onboarding_productsSavingDesc:
    "Veuillez patienter pendant que nous sauvegardons les produits.",
  onboarding_productsFetchFailed:
    "Échec lors de la récupération des informations produits & comptes",
  onboarding_productsFetchError:
    "Une erreur est survenue lors de la récupération des informations produits & comptes",
  onboarding_identitySavedSuccess:
    "Informations d'identité sauvegardées avec succès",
  onboarding_identitySaveFailed:
    "Échec de la sauvegarde des informations d'identité",
  onboarding_metadataSavedSuccess: "Métadonnées sauvegardées avec succès",
  onboarding_metadataSaveFailed: "Échec de la sauvegarde des métadonnées",
  onboarding_metadataSaveError:
    "Une erreur est survenue lors de la sauvegarde des métadonnées",

  // UserProfile
  roles: "Rôles",
  lastConnection: "Dernière connexion",
  profileCreatedAt: "Crée le - MAJ",
  permission: "Permissions (aperçu)",
  recentActivities: "Activité récente",
  action: "Action",
  inactivate: "Désactiver",
  activate: "Activer",

  // Onboarding - Document Card
  removeFile: "Supprimer le document",
  removeFileDescription:
    "Voulez-vous vraiment supprimer ce document ? Cette action est irréversible.",
  confirm: "Confirmer",
  deleting: "Suppression...",

  // Roles Matrix
  preCheckSoD: "Pré-check SoD",
  roleName: "Nom du rôle",
  roleNamePlaceholder: "Ex: Rôle de gestion de la filiale",
  purpose: "Finalité",
  purposePlaceholder: "Ex: Gestion de la filiale",
  scope: "Portée",
  permissionSelected: "Permissions sélectionnées",
  selected: "sélectionnée(s)",
  loadingPermissions: "Chargement des permissions…",
  domain: "Domaine",
  description: "Description",
  grant: "Accorder",
  preCheckSoDDescription:
    "Pré-check SoD automatique après modification des permissions.",
  noConflicts: "Aucun conflit détecté",
  conflict: "Conflit détecté",
  restart: "Relancer",
  noDetailsShown: "Aucun détails à afficher",
  usersList: "Liste des utilisateurs",
  addNewUser: "Ajouter un utilisateur",
  addNewUserDescription:
    "Recherchez l'utilisateur par son matricule pour pré-remplir ses informations, puis créez son utilisateur RBAC.",
  createUser: "Créer l'utilisateur",
  searchUser: "Rechercher le l'utilisateur",
  confirmCreation: "Confirmer la création",
  userEmail: "Email de l'utilisateur",
  searching: "Recherche...",
  userFound: "Utilisateur trouvé",
  selectedUser: "Utilisateur sélectionné",
  rbacId: "Identifiant RBAC (username)",
  usernameLettersNumbers: "Lettres, chiffres, points, tirets et underscores.",
  userWillBeCreatedInactive: "L'utilisateur sera créé avec le statut",
  withoutRoleAssigned: "et sans rôle assigné.",
  activeSOD: "SOD actifs",
  notAvailable: "Non disponible",
  na: "N/A",
  sodConflicts: "Conflits SoD détectés",
  sodConflictsDescription:
    "Ce rôle présente des conflits de séparation des devoirs. Une justification sera requise.",
  highCriticality: "Rôle à haute criticité",
  highCriticalityDescription:
    "Cette attribution nécessite une approbation manager et une justification écrite.",
  attribute: "Attribuer",
  justification: "Justification",
  justificationRequired:
    "La justification doit contenir au moins 10 caractères.",
  selectedUsers: "utilisateur(s) sélectionné(s)",
  noPermissions: "Aucune permission",
  showMore: "Voir plus",
  showLess: "Voir moins",
  owner: "Propriétaire",
  numberOfAssignments: "Nombre d'assignations",
  userFile: "Fiche utilisateur",
  userFileDescription: "Fiche utilisateur (résumé des rôles et permissions)",
  street: "Rue",
  bankInformation: "Informations bancaires",
  agencyCode: "Code agence",
  employmentType: "Type d'emploi",
  company: "Entreprise",
  otherInformation: "Autres informations",
  profilRating: "Score Profil",
  customerDetailsFromCoreBanking: "Détails du client depuis Core Banking.",
  importStep: "Mettre à jour les informations",

  // Commercial Dashboard (P1)
  commercialDashboard: "Tableau de bord commercial",
  volumeOnboardingInities: "Volume onboarding initiés",
  kpiProspectsCrees: "Prospects créés",
  kpiKycCompletion: "Taux complétion KYC (TTC)",
  kpiAvgTimeToCollect: "Délai moyen collecte",
  kpiConversionRate: "Taux conversion Prospect→Client",
  kpiCeMois: "Ce mois",
  kpiRetry: "Réessayer",
  kpiDataUnavailable: "Données temporairement indisponibles",
  kpiOutlierBadge: "⚠ {{count}} dossier(s) > 90j",
  kpiConversionTooltip: "Taux calculé sur prospects créés et convertis ce mois",
  kpiConversionSubLabel: "{{converted}} sur {{total}} convertis",
  kpiTipOnboardingVolume: "Nombre de dossiers d'entrée en relation ouverts sur la période et pas encore soumis à validation.",
  kpiTipKycCompletion: "Part des clients dont le dossier KYC a réellement été instruit : identité complétée et contrôle de conformité effectué. Un client repris du système bancaire sans ce parcours compte au dénominateur mais pas au numérateur.",
  kpiTipTimeToCollect: "Nombre moyen de jours entre l'ouverture d'un dossier et sa soumission. Les dossiers encore en cours sont comptés jusqu'à aujourd'hui.",
  kpiTipConversion: "Part des dossiers ouverts sur la période devenus clients. Les dossiers refusés pour conformité sont exclus du calcul.",
  kpiTipBranchSla: "Délai moyen, en jours, entre l'ouverture du dossier et l'activation du compte pour les clients activés sur la période.",
  kpiTipDocRejection: "Part des dossiers contrôlés dont au moins une pièce a été rejetée (qualité de lecture ou incohérence d'identité). Les simples avertissements de complétude ne sont pas comptés.",
  kpiTipRekycBacklog: "Dossiers de révision périodique arrivés à échéance. Indicateur en attente du module de révision KYC.",
  kpiTipCommercialVolume: "Nombre de comptes clients activés sur la période, tous conseillers confondus.",
  kpiTipTriage: "Nombre d'alertes de conformité en attente de qualification par un analyste.",
  kpiTipEddDelay: "Durée moyenne de traitement d'une vigilance renforcée, de son ouverture à sa décision.",
  kpiTipFalsePositive: "Part des alertes qualifiées qui se sont révélées sans correspondance réelle. Un taux élevé signale un filtrage trop large.",
  kpiTipBacklogAge: "Ancienneté moyenne, en jours, des alertes encore en attente de qualification.",
  kpiTipSodConformity: "Part des rôles publiés respectant la séparation des tâches, sans cumul de fonctions incompatibles.",
  kpiTipFourEyesSla: "Délai moyen de validation par le second valideur dans le circuit à quatre yeux.",
  kpiTipHighRiskCoverage: "Part des dossiers à risque déjà qualifiés par la conformité. Le reste attend encore une décision.",
  kpiTipSodDerogation: "Nombre de dérogations à la séparation des tâches approuvées sur la période.",
  kpiTipTriggerLabel: "En savoir plus sur cet indicateur",
  kpiConvertedSubLabel: "{{converted}} sur {{total}} convertis",
  kpiDays: "j",
  kpiHours: "h",
  kpiActiveEddCasesSubLabel: "{{count}} dossier(s) en cours",
  kpiTrendUp: "En hausse",
  kpiTrendDown: "En baisse",

  // Dashboards — menu section & persona titles / breadcrumbs
  dashboardsSection: "Tableaux de bord",
  dashboardCommercial: "Commercial (P1)",
  dashboardAgence: "Agence (P2)",
  dashboardCompliance: "Compliance (P3)",
  dashboardConformite: "Conformité (P4)",
  dashboardCommercialSubtitle:
    "Suivi de l'activité commerciale et de la qualité d'onboarding",
  dashboardAgenceSubtitle:
    "Pilotage des ouvertures de compte et de la production de l'agence",
  dashboardComplianceSubtitle:
    "Productivité du triage des alertes AML/CFT et qualité des contrôles",
  dashboardConformiteSubtitle: "Conformité SoD, couverture EDD et dérogations",
  agence: "Agence",

  // KPI — unavailable tile
  kpiComingSoon: "Bientôt disponible",
  kpiComingSoonDescription: "Cet indicateur n'est pas encore disponible.",

  // KPI — P1 conversion drill-down card
  kpiConversionDrillDownCta: "Voir les prospects à convertir",

  // KPI — P2 (Agence)
  kpiBranchSla: "Délai moyen ouverture compte",
  kpiBranchSlaSubLabel: "{{count}} comptes ouverts",
  kpiDocRejection: "Taux de rejet documentaire",
  kpiDocRejectionSubLabel: "{{rejected}}/{{total}} documents rejetés",
  kpiCommercialVolume: "Volume de production commerciale",
  kpiCommercialVolumeSubLabel: "Comptes ouverts sur la période",
  kpiRekycBacklog: "Backlog Re-KYC",

  // KPI — P3 (Compliance)
  kpiTriageProductivity: "Productivité de triage",
  kpiTriageSubLabel: "{{count}} alertes en cours",
  kpiEddDelay: "Délai moyen traitement EDD",
  kpiFalsePositiveRate: "Taux de faux positifs",
  kpiFalsePositiveSubLabel: "{{clear}}/{{total}} évalués",
  kpiBacklogAge: "Âge moyen du backlog",

  // KPI — P4 (Conformité)
  kpiSodConformity: "Taux de conformité SoD",
  kpiSodConformitySubLabel: "{{compliant}}/{{total}} rôles conformes",
  kpiFourEyesSla: "SLA validation 4-yeux",
  kpiHighRiskCoverage: "Couverture EDD HR/PEP",
  kpiHighRiskCoverageSubLabel: "{{covered}}/{{total}} clients couverts",
  kpiHighRiskUncoveredPill: "{{count}} clients sans EDD valide",
  kpiSodDerogation: "Volume de dérogations SoD",
  kpiSodDerogationSubLabel: "{{count}} dérogations accordées",
  userMatricule: "Matricule utilisateur",
  function: "Fonction",
  departement: "Département",

  assigningRoleToUsers: "Attribution de rôle aux utilisateurs en cours...",
  roleAssignedSuccessfully: "Attribution de rôle aux utilisateurs réussie",
  roleAssignedSuccessfullyDescription: "Le rôles a été attribué avec succès.",
  revokeRole: "Révoquer le rôle",
  revokeRoleConfirmTitle: "Révoquer le rôle",
  revokeRoleConfirmDescription:
    "Cette action retire le rôle à l'utilisateur et est irréversible. Veuillez justifier cette révocation.",
  revokingRole: "Révocation du rôle en cours...",
  roleRevokedSuccessfully: "Rôle révoqué avec succès",
  roleRevokedSuccessfullyDescription:
    "Le rôle a été retiré de l'utilisateur avec succès.",

  civilStatusAndCapacity: "État civil & capacité",
  changeCivilStatus: "Changement d'état civil",
  addLegalRepresentative: "Ajout représentant légal",
  civilStatusLabel: "État civil",
  legalCapacity: "Capacité juridique",
  legalReferent: "Référent légal",
  fatherFirstNames: "Prénoms du père",
  motherFirstNames: "Prénoms de la mère",
  deathDate: "Date de décès",
  socioProfessionalSituation: "Situation socio-professionnelle",
  updateIncomeEmployer: "Mise à jour revenu et employeur",
  professionCountry: "Pays de profession",
  clientQuality: "Qualité client",
  monthlyRemuneration: "Rémunération mensuelle",
  bceaoSocioProNote:
    "Règle BCEAO : la catégorie est distincte de la profession. Ces données alimentent le profil de risque et la périodicité Re-KYC.",
  matrimonialAndFamily: "Régime matrimonial & famille",
  changeFamilySituation: "Changement de situation familiale",
  matrimonialRegime: "Régime matrimonial",
  marriageContract: "Contrat de mariage",
  spouseLastName: "Nom du conjoint",
  spouseFirstName: "Prénoms du conjoint",
  belongingAndBanking: "Appartenance & bancarisation",
  relationOtherInstitutions: "Relation avec d'autres établissements",
  bankPersonnel: "Personnel de la banque",

  patrimoineRealEstateAssets: "Actifs immobiliers",
  patrimoineRealEstateAssetsHint: "Appartements, maisons, terrains, …",
  patrimoineHowManyProperties: "Combien de biens ?",
  patrimoineAssetsInsured: "Les biens sont-ils assurés ?",
  patrimoineEstimatedValue: "Valeur estimée",
  patrimoineOtherBankAccounts: "Autres comptes bancaires",
  patrimoineOtherBankAccountsHint: "Compte courant, épargne, …",
  patrimoineTotalApproximateValue: "Valeur approximative totale",
  patrimoineValuableObjects: "Objets de valeur",
  patrimoineValuableObjectsHint: "Bijoux, art, …",
  patrimoineEdit: "Éditer",

  roleBlocked: "Rôle bloqué",
  roleBlockedDescription: "Ce rôle est bloqué et ne peut pas être publié.",

  commercial: "Commercial (P1)",
  conformite: "Conformité (P4)",
  thisMonth: "Ce mois",
  previousMonth: "Mois précédent",

  // Risk Entity Referential (US-6.5a)
  riskEntityReferential: "Référentiel de Scoring",
  riskEntityReferentialDescription:
    "Gérez les codes de niveau de risque par type d'entité.",
  riskEntityTabEntities: "Entités Risques",
  riskEntityTabWeighting: "Pondération",
  riskEntityWeightingDescription:
    "Chaque champ accepte une valeur entre 0 et 100 %. Les deux valeurs additionnées doivent faire exactement 100 %.",
  riskEntityWeightingSectionTitle:
    "Pondération Référentiel Identité et Contrôle externe",
  riskEntityWeightingSectionSubtitle:
    "Répartissez le poids relatif des deux sources externes dans le calcul du score client. Une répartition à 100 % garantit que le modèle reste équilibré et interprétable.",
  riskEntityWeightingCardTitle: "Saisie des pourcentages",
  riskEntityWeightingTotalLabel: "Total",
  riskEntityWeightingLseg: "Référentiel Identité",
  riskEntityWeightingVneurone: "Contrôle externe",
  riskEntityWeightingPercentHint: "Pourcentage (%)",
  riskEntityWeightingSubmitLoading: "Mise à jour en cours…",
  riskEntityWeightingValidate: "Mettre à jour",
  riskEntityWeightingSumMustBe100:
    "La somme Référentiel Identité + Contrôle externe doit être strictement égale à 100 %.",
  riskEntityWeightingInvalidPercent: "Saisissez un nombre valide.",
  riskEntityWeightingPercentRange:
    "Le pourcentage doit être compris entre 0 et 100.",
  riskEntityWeightingSubmittedSuccess: "Pondération enregistrée.",
  riskEntityWeightingConfigLoading: "Chargement de la pondération actuelle…",
  riskEntityWeightingReason: "Motif de la modification",
  riskEntityWeightingReasonPlaceholder:
    "Ex. bascule mode CONSERVATIVE — décision SteerCo 2026-07-15",
  riskEntityWeightingReasonRequired: "Le motif est obligatoire.",
  riskEntityWeightingReasonMinLength:
    "Le motif doit contenir au moins 5 caractères.",
  riskEntityWeightingHistorySheetTitle:
    "Historique — pondération Référentiel Identité / Contrôle externe",
  riskEntityWeightingHistorySheetSubtitle:
    "Chaque ligne correspond à une modification enregistrée (poids, auteur, motif).",
  riskEntityWeightingHistoryLoading: "Récupération de l'historique…",
  riskEntityWeightingHistoryEmpty: "Aucune entrée dans l'historique.",
  riskEntityWeightingHistoryColDate: "Date",
  riskEntityWeightingHistoryColAuthor: "Utilisateur",
  riskEntityWeightingHistoryColBefore: "Avant (Réf. Identité / Contrôle ext.)",
  riskEntityWeightingHistoryColAfter: "Après (Réf. Identité / Contrôle ext.)",
  riskEntityWeightingHistoryColReason: "Motif",
  entityType_OBJET_COMPTE: "Objet de compte",
  entityType_SOURCE_REVENU: "Source de revenu",
  entityType_PAYS: "Pays",
  entityType_PROFESSION: "Profession",
  entityType_ACTIVITE: "Activité",
  entityType_PRODUIT: "Produit",
  entityType_CANAL: "Canal",
  entityType_ANNEE_CONSTITUTION: "Année de constitution",
  riskLevel_RE: "RE — Risque Élevé",
  riskLevel_RM: "RM — Risque Modéré",
  riskLevel_RF: "RF — Risque Faible",
  riskEntityCode: "Code",
  riskEntityLibelle: "Libellé",
  riskEntityLevel: "Niveau",
  riskEntityActive: "Actif",
  riskEntityLastModified: "Dernière modification",
  riskEntityAddCode: "Ajouter un code",
  riskEntityEditLevel: "Modifier le niveau",
  riskEntityDeactivate: "Désactiver",
  riskEntityHistory: "Historique",
  riskEntityNewCode: "Nouveau code",
  riskEntityEditCode: "Modifier le code",
  riskEntityDeactivateTitle: "Désactiver ce code ?",
  riskEntityDeactivateDescription:
    "Le code sera masqué du scoring mais restera visible dans la table.",
  riskEntityRollbackTitle: "Restaurer cette version ?",
  riskEntityRollbackDescription:
    "Cette action appliquera l'état précédent et créera une entrée dans l'historique.",
  riskEntityRollbackConfirm: "Restaurer",
  riskEntityRestoreVersion: "Restaurer cette version",
  riskEntityChangeReason: "Motif de modification",
  riskEntityChangeReasonPlaceholder: "Indiquez le motif de ce changement…",
  riskEntityNoCodesFound: "Aucun code trouvé",
  riskEntityFilterByLevel: "Filtrer par niveau",
  riskEntityAllLevels: "Tous les niveaux",
  riskEntitySearchPlaceholder: "Rechercher un code ou libellé…",
  riskEntityStatusActive: "Actif",
  riskEntityStatusInactive: "Inactif",
  riskEntityHistoryAction_ADD: "Ajout",
  riskEntityHistoryAction_MODIFY: "Modification",
  riskEntityHistoryAction_DEACTIVATE: "Désactivation",
  riskEntityHistoryAction_ROLLBACK: "Restauration",
  riskEntityCreatedSuccess: "Code créé avec succès",
  riskEntityUpdatedSuccess: "Niveau mis à jour avec succès",
  riskEntityDeactivatedSuccess: "Code désactivé avec succès",
  riskEntityRolledBackSuccess: "Version restaurée avec succès",
  riskEntityOperationFailed: "L'opération a échoué. Veuillez réessayer.",
  riskEntityCodes: "code(s)",
  riskEntityModifyConfirmTitle: "Confirmer la modification",
  riskEntityNoHistory: "Aucun historique disponible pour ce type d'entité.",

  // Risk Entity Referential — CSV Import (US-6.5b)
  riskEntityImportCsv: "Importer CSV",
  riskEntityImportModalTitle: "Importer des codes via CSV",
  riskEntityImportDropzone:
    "Glissez un fichier .csv ici ou cliquez pour sélectionner",
  riskEntityImportDropzoneHint:
    "Format attendu : code,label,risk_level (UTF-8)",
  riskEntityImportSelectFile: "Sélectionner un fichier",
  riskEntityImportPreviewTitle: "Aperçu des modifications",
  riskEntityImportAdded: "Ajoutés",
  riskEntityImportModified: "Modifiés",
  riskEntityImportUnchanged: "Inchangés",
  riskEntityImportInvalid: "Invalides",
  riskEntityImportConfirmBtn: "Confirmer l'import",
  riskEntityImportSuccess:
    "Import appliqué : {applied} modifié(s), {added} ajouté(s), {errors} erreur(s)",
  riskEntityImportShowUnchanged: "Afficher les inchangés",
  riskEntityImportHideUnchanged: "Masquer les inchangés",
  riskEntityImportErrorReason: "Raison",
  riskEntityImportEmpty:
    "Le fichier est vide ou ne contient aucune ligne valide.",
  riskEntityImportFileTypeError:
    "Format non supporté. Veuillez sélectionner un fichier .csv.",
  riskEntityImportColumnCode: "Code",
  riskEntityImportColumnLabel: "Libellé",
  riskEntityImportColumnOldLevel: "Niveau actuel",
  riskEntityImportColumnNewLevel: "Nouveau niveau",
  riskEntityImportColumnStatus: "Statut",
  riskEntityImportChooseAnother: "Choisir un autre fichier",
  riskEntityImportConfirmCloseTitle: "Annuler l'import ?",
  riskEntityImportConfirmCloseDescription:
    "Le fichier analysé sera perdu. Vous devrez le sélectionner à nouveau.",

  // Risques Conformité — menu (libellés courts pour la sidebar ; titres de page plus descriptifs)
  risquesConformite: "Conformité & Risques",
  fileDeRevueL1: "File de Revue",
  validation4Yeux: "Reclassements",

  // EDD 4-yeux module
  eddTitle: "Diligence (EDD)",
  eddEmpty: "Aucun dossier EDD.",
  eddColBusinessKey: "ID client",
  eddColCustomer: "Client",
  eddColTrigger: "Déclencheur",
  eddColStatus: "Statut",
  eddColAnalyst: "Analyste",
  eddColCreatedAt: "Créé le",
  eddFilterAll: "Tous",
  eddFilterAssignedToMe: "Qui me sont assignés",
  eddStatus_OPEN: "Ouvert",
  eddStatus_IN_PROGRESS: "En cours",
  eddStatus_PENDING_L1: "En attente L1",
  eddStatus_PENDING_L2: "En attente L2",
  eddStatus_APPROVED: "Approuvé",
  eddStatus_REJECTED: "Rejeté",
  eddStatus_SUSPENDED: "Suspendu",
  eddTrigger_PEP: "PEP",
  eddTrigger_PEP_SANCTIONED: "PEP + pays sanctionné",
  eddTrigger_HIGH_RISK: "Risque élevé",
  eddTrigger_KYB_HIGH_RISK: "Risque élevé de l'entreprise (KYB)",
  eddTrigger_MANUAL: "Manuel",
  eddTrigger_ESCALATION_L1: "Escalade revue L1",
  eddTrigger_RE_KYC: "Re-KYC",
  eddTrigger_TRANSACTION_ALERT: "Alerte transaction",
  eddTrigger_UNKNOWN: "Autre",
  eddDocType_IDENTITY: "Pièce d'identité",
  eddDocType_SOURCE_OF_FUNDS: "Source des fonds",
  eddDocType_BUSINESS_ACTIVITY: "Activité professionnelle",
  eddDocType_BENEFICIAL_OWNER: "Bénéficiaire effectif",
  eddDocType_OTHER: "Autre",
  eddDocumentsTitle: "Pièces justificatives",
  eddNoDocuments: "Aucune pièce.",
  eddDownload: "Télécharger",
  eddPreview: "Aperçu",
  eddUploadTitle: "Ajouter une pièce",
  eddUploadType: "Type de pièce",
  eddUploadFile: "Fichier",
  eddUploadComment: "Commentaire (optionnel)",
  eddUploadSubmit: "Téléverser",
  eddHistoryTitle: "Historique",
  eddActionAddDocument: "Ajouter une pièce",
  eddActionSubmitL1: "Soumettre à la validation L1",
  eddActionSubmitL1Hint: "Au moins une pièce « Source des fonds » est requise.",
  eddActionAssign: "Prendre en charge",
  eddActionSuspend: "Suspendre",
  eddActionResume: "Reprendre",
  eddActionApproveL1: "Approuver (L1 agence)",
  eddActionApproveL2: "Approuver (L2 conformité)",
  eddActionApproveL2FourEyesHint:
    "Contrôle 4-yeux : le validateur L2 doit être différent du validateur L1.",
  eddActionReject: "Rejeter",
  eddRejectReason: "Motif du rejet",
  eddSuspendReason: "Motif de la suspension",
  eddMfaTitle: "Vérification de sécurité (MFA)",
  eddMfaSentTo: "Un code de validation a été envoyé à",
  eddMfaTestMode: "Environnement de test : aucun mail n'a été envoyé. Saisissez le code de test :",
  eddMfaExpiresIn: "expire dans",
  eddMfaSendError: "Impossible d'envoyer le code de vérification. Réessayez.",
  eddMfaCodeLabel: "Code de vérification",
  eddMfaResend: "Renvoyer un code",
  eddMfaValidate: "Valider et confirmer",
  eddDecisionNotes: "Notes (optionnel)",
  eddApproveL2Title: "Valider (L2 conformité)",
  eddApproveL2RiskAssessment: "Réévaluation du risque",
  eddApproveL2Conclusion: "Conclusion (optionnel)",
  eddRisk_MAINTAINED: "Maintenu",
  eddRisk_UPGRADED: "Relevé",
  eddRisk_DOWNGRADED: "Abaissé",

  // L1 Review page (US 6.3)
  l1ReviewTitle: "File de revue L1",
  l1ReviewBusinessKey: "Business Key",
  l1ReviewCustomerName: "Nom",
  l1ReviewAssignedTo: "Attribué à",
  l1ReviewUnassigned: "Non attribué",
  l1ReviewRisk: "Risque",
  l1ReviewTabPending: "En attente",
  l1ReviewTabEscalated: "Escaladés",
  l1ReviewTabAuthorized: "Autorisés",
  l1ReviewTabRejected: "Rejetés",
  l1ReviewTabSlaBreached: "SLA dépassé",
  l1ReviewDetailTitle: "Détail du dossier de revue L1",
  l1ReviewDetailNotFound: "Dossier introuvable.",
  l1ReviewTriggerReason: "Motif de déclenchement",
  l1ReviewTrackAScore: "Score Référentiel Identité",
  l1ReviewTrackBScore: "Score contrôle externe",
  l1ReviewSlaDeadline: "Échéance SLA",
  l1ReviewSlaExpired: "SLA Expiré",
  l1ReviewAuthorize: "Autoriser",
  l1ReviewSuspend: "Suspendre",
  l1ReviewReject: "Rejeter",
  l1ReviewAssign: "S'attribuer",
  l1ReviewHeldBy: "Déjà attribué, seul son assigné peut le traiter",
  l1ReviewAssignHint: "Attribuez-vous le dossier pour pouvoir l'autoriser.",
  l1ReviewQualifyFirstHint:
    "Tranchez d'abord chaque correspondance : la décision se prend une fois établi s'il s'agit bien de la personne.",
  l1ReviewEscalate: "Escalader",
  l1ReviewSuspensionReason: "Motif de suspension",
  l1ReviewSuspensionReasonPlaceholder: "Décrivez le motif de suspension…",
  l1ReviewAuthorizeSuccess: "Dossier autorisé avec succès.",
  l1ReviewSuspendSuccess: "Dossier suspendu avec succès.",
  l1ReviewEscalateSuccess: "Dossier escaladé vers la validation P4.",
  l1ReviewActionFailed: "L'action a échoué. Veuillez réessayer.",
  l1ReviewEmpty: "Aucun dossier en attente de revue.",
  l1ReviewLoading: "Chargement des dossiers en attente…",
  l1ReviewLoadingError: "Échec du chargement des dossiers. Veuillez réessayer.",

  // P4 Validation page (US 4.5)
  p4ValidationTitle: "Reclassifications de risque (P4)",
  p4ValidationBusinessKey: "ID Client",
  p4ValidationOldClass: "Classe actuelle",
  p4ValidationNewClass: "Nouvelle classe",
  p4ValidationScoreDelta: "Δ Score",
  p4ValidationTrigger: "Motif",
  p4ValidationSlaDeadline: "Échéance SLA",
  p4ValidationSlaExpired: "SLA Expiré",
  p4ValidationFlaggedDirectionRisques: "Signalé : Direction Risques",
  p4ValidationApprove: "Approuver",
  p4ValidationReject: "Rejeter",
  p4ValidationJustification: "Justification",
  p4ValidationJustificationPlaceholder:
    "Fournissez une justification pour le rejet (min. 10 caractères)…",
  p4ValidationNotes: "Notes (facultatif)",
  p4ValidationNotesPlaceholder: "Notes complémentaires…",
  p4ValidationApproveSuccess:
    "Validation approuvée. Nouvelle classe de risque appliquée.",
  p4ValidationRejectSuccess:
    "Validation rejetée. Classe de risque actuelle conservée.",
  p4ValidationActionFailed:
    "L'action n'a pas pu aboutir. Veuillez réessayer dans un instant.",
  p4ValidationForbidden:
    "Vous n'avez pas les droits pour valider une reclassification de risque. Cette décision revient à un Responsable Conformité (P4).",
  p4ValidationSelfReviewForbidden:
    "Décision impossible : par principe des quatre yeux, la personne à l'origine du changement ne peut pas le valider elle-même. Un autre valideur doit s'en charger.",
  p4ValidationAlreadyDecided:
    "Cette reclassification a déjà été traitée par un autre valideur. La liste va se rafraîchir.",
  p4ValidationEmpty: "Aucune reclassification à valider pour le moment.",
  p4ValidationEmptyApproved: "Aucune reclassification approuvée à afficher.",
  p4ValidationEmptyRejected: "Aucune reclassification rejetée à afficher.",
  p4ValidationLoading: "Chargement des reclassifications…",
  p4ValidationLoadingError:
    "Échec du chargement des reclassifications. Veuillez réessayer.",
  p4ValidationPendingCount: "en attente de validation",
  // Filtre par statut + descriptions métier au-dessus de la liste
  p4StatusPending: "À valider",
  p4StatusApproved: "Approuvées",
  p4StatusRejected: "Rejetées",
  p4StatusDescPending:
    "Le niveau de risque de ces clients a changé (ex. passage Faible → Élevé). Un second valideur doit confirmer ou refuser ce changement avant qu'il ne devienne définitif. Le client reste actif pendant ce temps.",
  p4StatusDescApproved:
    "Changements de niveau de risque confirmés : le nouveau niveau a été appliqué au client. Historique en lecture seule.",
  p4StatusDescRejected:
    "Changements de niveau de risque refusés : le client conserve son niveau précédent. Les cas signalés sont transmis à la direction des risques pour suite à donner.",

  // Compliance triage — shared header, SLA countdown, queue summary, toolbar
  l1ReviewSubtitle:
    "Revue de niveau 1 des alertes de screening, triées par échéance.",
  p4ValidationSubtitle:
    "Double contrôle des changements de niveau de risque (Faible ↔ Élevé) sur les clients existants, triés par échéance.",
  eddSubtitle:
    "Dossiers de diligence renforcée en cours de traitement (4 yeux).",
  slaDueIn: "Échéance dans",
  slaOverdueSince: "Dépassée depuis",
  queueTotalPending: "En attente",
  queueDueSoon: "Échéance < 2 h",
  queueBreached: "SLA dépassé",
  queueFlaggedDR: "Signalés DR",
  eddQueueOpen: "Ouverts",
  eddQueuePendingL1: "Attente L1",
  eddQueuePendingL2: "Attente L2",
  eddRowClickHint: "Cliquez sur un dossier pour afficher son détail.",
  eddOpenCaseAria: "Ouvrir le dossier",
  eddDetailBack: "Retour aux dossiers",
  eddDetailCaseInfoTitle: "Informations du dossier",
  eddDetailSubmittedAt: "Soumis le",
  eddDetailL1ApprovedBy: "Validé L1 par",
  eddDetailL2ApprovedBy: "Validé L2 par",
  eddDetailSlaDeadline: "Échéance SLA",
  eddDetailNotFound: "Dossier introuvable.",
  eddCustomerDetailsTitle: "Détails du prospect",
  eddCustomerLoadError: "Impossible de charger les détails du prospect.",
  eddCustomerDocumentsTitle: "Documents du client",
  eddCustomerNoDocuments: "Aucun document.",
  eddCustomerDocColType: "Type",
  eddCustomerDocColName: "Document",
  eddCustomerDocColExpiration: "Expiration",
  eddCustomerDocView: "Voir",
  complianceSearchBusinessKey: "Business key",
  complianceFilterTrigger: "Motif",
  complianceFlaggedOnly: "Signalés DR uniquement",
  p4ValidationRiskChange: "Changement de classe",
  l1AuthorizeConfirmTitle: "Autoriser cette revue ?",
  l1AuthorizeConfirmBody:
    "La revue sera autorisée et retirée de la file. Cette action est définitive.",
  l1EscalateConfirmTitle: "Escalader cette revue ?",
  l1EscalateConfirmBody:
    "La revue sera escaladée vers la validation P4. Cette action est définitive.",

  // Les deux pistes sont nommées par ce qu'elles sont pour la banque, jamais par le prestataire
  // qui les alimente : le nom d'un fournisseur AML n'a pas à sortir sur un écran métier, et il
  // changerait à chaque bascule de provider alors que la lecture du verdict, elle, ne change pas.
  cvTrackA: "Référentiel Identité",
  cvTrackB: "Contrôle externe",
  cvFinalDecision: "Décision finale",
  cvWeights: "Pondérations",
  cvDecidedBy: "Tranché par",
  cvScoringWeights: "Pondérations du scoring",
  cvCanCreate: "Création autorisée",
  cvCannotCreate: "Création bloquée",
  cvVerdictHold: "En revue",
  cvVerdictUnknown: "Statut inconnu",
  cvHoldPending:
    "Client enregistré, aucun compte ouvert tant que la revue n'est pas levée",
  cvBlockingReason: "Motif de blocage",
  cvVNeuroneMode: "Mode contrôle externe",
  cvComputedAt: "Calculé le",
  cvVerdictClean: "Propre",
  cvVerdictWait: "En attente",
  cvVerdictFlagged: "Signalé",
  cvVerdictBlocked: "Bloqué",
  cvVerdictManualReview: "Revue manuelle",
  cvPendingOver48h: "En attente depuis plus de 48h",
  cvScreeningDetails: "Détails du screening",
  cvLoadError: "Impossible de charger le verdict.",

  additionalInformationKYC: "Informations complémentaires KYC",
  additionalInformationKYCDescription:
    "Mettez à jour les informations complémentaires du client.",
  financialSituationSection: "Situation financière",
  pepStatusSection: "Statut PPE",
  effectiveBeneficiarySection: "Bénéficiaire effectif",
  wealthSituation: "Situation patrimoniale",
  sourceOfFunds: "Source des fonds",
  bankRelationPurpose: "Objet de la relation bancaire",
  taxResidenceCountry: "Résidence fiscale (pays)",
  pepFunctionExercised: "Fonction PPE exercée",
  effectiveBeneficiary: "Bénéficiaire effectif",
  effectiveBeneficiaryIdentity: "Identité du bénéficiaire effectif",
  placeholderWealthSituation: "Ex : bien immobilier, épargne, placements",
  placeholderSourceOfFunds: "Ex : salaire, héritage, cession d'actif",
  placeholderBankRelationPurpose:
    "Ex : épargne, opérations courantes, virements internationaux",
  placeholderTaxResidenceCountry: "Ex : Côte d'Ivoire",
  placeholderPepFunction: "Ex : ministre, député, magistrat…",
  placeholderEffectiveBeneficiaryIdentity:
    "Ex : nom complet et qualité du bénéficiaire",
  immatriculationsSectionTitle: "Immatriculations",
  taxIdentifiersSectionTitle: "Identifiants fiscaux",
  addImmatriculation: "Ajouter une immatriculation",
  saveRegistrations: "Enregistrer",
  addTaxIdentifier: "Ajouter un identifiant fiscal",
  removeImmatriculation: "Retirer",
  removeTaxIdentifier: "Retirer",
  registryType: "Type de registre",
  registryTypeRCCM: "RCCM",
  registryTypeOther: "Autre",
  immatriculationNumber: "Numéro d'immatriculation",
  immatriculationDate: "Date d'immatriculation",
  immatriculationStatus: "Statut de vérification",
  statusVerified: "Vérifié",
  statusNotVerified: "Non vérifié",
  statusInProgress: "En cours",
  statusToReverify: "À revérifier",
  screeningStatusPending: "Criblage en attente",
  screeningRelaunch: "Relancer le criblage",
  screeningRelaunchAll: "Relancer le criblage des personnes en attente",
  screeningRelaunchDone: "Criblage effectué.",
  screeningRelaunchStillPending: "Criblage toujours différé : complétez la nationalité de la personne, puis relancez.",
  screeningRelaunchFailed: "Le fournisseur n'a pas répondu, réessayez plus tard.",
  screeningRelaunchAlreadyDone: "Cette personne est déjà criblée.",
  screeningRelaunchScreenedLabel: "criblée(s)",
  screeningRelaunchStillPendingLabel: "toujours en attente",
  screeningRelaunchFailedLabel: "en échec",
  screeningStatusNoMatch: "Criblage : aucune correspondance",
  screeningStatusToQualify: "Criblage : à qualifier",
  screeningStatusMatch: "Criblage : correspondance confirmée",
  screeningStatusFailed: "Criblage : échec fournisseur",
  registrationSyncedReadOnly:
    "Ajouté au dossier. Le statut de vérification est décidé par la conformité, avec preuve à l'appui.",
  justificationAlternative: "Justification alternative",
  pendingComplianceValidation: "À valider conformité",
  taxIdentifierType: "Type d'identifiant fiscal",
  taxIdentifierTypeIFU: "IFU",
  taxIdentifierTypeNIF: "NIF",
  taxIdentifierTypeNINEA: "NINEA",
  taxIdentifierTypeOther: "Autre",
  taxIdentifierValue: "Valeur",
  immatriculationGateBlocked:
    "Le dossier ne pourra pas être approuvé tant qu'aucune immatriculation n'est vérifiée.",
  registrationVerificationDecide: "Décider de la vérification",
  registrationVerificationTitle: "Décision de vérification",
  registrationVerificationTargetStatus: "Statut visé",
  registrationVerificationSource: "Source de vérification",
  verificationSummarySource: "Source",
  verificationSummaryBy: "Vérifié par",
  verificationSummaryJustification: "Justification",
  verificationSummaryNoJustification: "Justification non conservée pour cette décision (antérieure à son enregistrement).",
  verificationSummaryProof: "Voir la preuve",
  verificationSourceRccm: "Registre du commerce et du crédit mobilier (RCCM)",
  verificationSourceCepici: "Guichet unique de formalités (CEPICI)",
  verificationSourceTaxAuthority: "Administration fiscale (DGI)",
  verificationSourceCourtRegistry: "Greffe du tribunal de commerce",
  verificationSourceOfficialJournal: "Journal officiel ou annonce légale",
  verificationSourceOriginalDocument: "Document original présenté par le client",
  verificationSourceOther: "Autre",
  verificationSourceOtherPlaceholder: "Précisez la source",
  registrationVerificationSourceRequired: "Choisissez la source de la vérification.",
  registrationVerificationJustification: "Justification",
  registrationVerificationProofFile: "Preuve à déposer",
  registrationVerificationSubmit: "Enregistrer la décision",
  registrationVerificationCancel: "Annuler",
  registrationVerificationProofRequired:
    "Un fichier de preuve est obligatoire pour le statut Vérifié.",
  registrationVerificationPendingSync:
    "Enregistrez d'abord le dossier pour pouvoir décider de la vérification.",
  registrationVerificationError:
    "La décision n'a pas pu être enregistrée. Vérifiez les informations et réessayez.",

  ocrChangeCriticalTitle: "Modification d'une information d'identité",
  ocrChangeCriticalIntro:
    "Vous êtes sur le point de modifier des informations qui identifient le client :",
  ocrChangeCriticalConsequence:
    "Ces informations relancent le contrôle de conformité du client et sont enregistrées à votre nom. Vérifiez qu'elles correspondent bien à la pièce présentée.",
  ocrChangeCriticalAttestation:
    "Je confirme avoir vérifié ces informations sur la pièce d'identité originale",
  ocrChangeReasonLabel: "Motif de la modification",
  ocrChangeReasonPlaceholder:
    "Ex. : erreur de lecture OCR corrigée d'après la pièce présentée",
  ocrChangeSensitiveTitle: "Informations modifiées par la nouvelle lecture",
  ocrChangeSensitiveIntro:
    "La nouvelle lecture de la pièce modifie les informations suivantes :",
  ocrChangeNewCaptureTitle: "Informations détectées sur la pièce",
  ocrChangeNewCaptureIntro:
    "La lecture de la pièce a détecté les informations suivantes, pas encore renseignées sur ce dossier. Vérifiez qu'elles sont correctes avant de continuer :",
  ocrChangeDetectedValue: "Valeur détectée",
  ocrChangeAlsoChanged: "Également modifié :",
  ocrChangeLegalAgeWarning:
    "Cette date fait passer le client de mineur à majeur (ou l'inverse) : la liste des pièces exigées pour ce dossier va changer.",
  ocrChangeIdPaperWarning:
    "Si ce numéro de pièce est déjà enregistré sur un autre client, la modification sera refusée.",
  ocrChangeBefore: "Avant",
  ocrChangeAfter: "Après",
  ocrChangeCancel: "Annuler",
  ocrChangeConfirm: "Confirmer la modification",
  ocrChangeFieldLastName: "Nom",
  ocrChangeFieldFirstName: "Prénom",
  ocrChangeFieldBirthDate: "Date de naissance",
  ocrChangeFieldIdPaperNumber: "Numéro de la pièce",
  ocrChangeFieldNni: "NNI",
  ocrChangeFieldNationality: "Nationalité",
  ocrChangeFieldBirthPlace: "Lieu de naissance",
  ocrChangeFieldGender: "Sexe",
  ocrChangeFieldDeliveryDate: "Date de délivrance",
  ocrChangeFieldValidityDate: "Date d'expiration",
  staffDirectoryTitle: "Annuaire du personnel",
  staffDirectoryBranch: "Agence de rattachement",
  staffDirectoryEmail: "Email transmis au criblage",
  staffDirectoryNoBranch:
    "Aucune agence de rattachement dans l'annuaire du personnel. Les dossiers que vous ouvrez partent sans conseiller ni agence et ne sont pas criblés : faites créer votre rattachement avant de saisir un nouveau client.",
  staffDirectoryAmbiguousBranch:
    "Plusieurs agences de rattachement dans l'annuaire du personnel : aucune ne peut être retenue. Les dossiers que vous ouvrez ne sont pas criblés tant qu'il n'en reste qu'une.",
  staffDirectoryBranchCount: "Agences rattachées",
    accountOpeningRecapDecision: "DÃ©cision",
    accountOpeningRecapRepresentatives: "ReprÃ©sentants",
    accountOpeningRecapRiskLevel: "Niveau de risque",
    decisionJustificationLabel: "Justification",
    decisionMakerNameLabel: "Agent dÃ©cisionnaire",
    decisionOutcomeLabel: "Issue",
    decisionOutcomeRequestAdditionalInfo: "Demande de complÃ©ment",
    decisionTitle: "DÃ©cision KYB",
    pmScreeningLaunchButton: "Lancer le screening",
    pmScreeningNoHitsMessage: "Aucun hit dÃ©tectÃ©. Le screening est clear.",
    pmScreeningQualificationPending: "En attente",
    pmScreeningQualifyFalsePositive: "Faux positif",
    pmScreeningQualifyTruePositive: "Vrai positif",
    pmScreeningUnqualifiedHitsBlockMessage:
    "Chaque hit doit Ãªtre qualifiÃ© avant de continuer.",
    riskFactorScreeningHit: "Hit de screening confirmÃ©",
    riskLevelEleve: "Ã‰levÃ©",
    riskLevelFaible: "Faible",
    riskLevelModere: "ModÃ©rÃ©",
  
  stepDecision: "DÃ©cision",

  platformSettings: "Paramètres plateforme",
  platformSettingsDescription:
    "Activation des modules et bascules réservées à l'éditeur.",
  kybModuleToggleTitle: "Module KYB (onboarding personne morale)",
  kybModuleToggleDescription:
    "Active ou désactive l'onboarding personne morale (KYB) dans toute l'application : segment PM, dossiers KYB, écrans associés.",
  kybModuleToggleEnabled: "Actif",
  kybModuleToggleDisabled: "Inactif",
  kybModuleUnavailableTitle: "Module non actif",
  kybModuleUnavailableMessage:
    "Ce module n'est pas actif. Veuillez demander son activation dans votre abonnement.",
  identityPolicyToggleTitle: "Motif obligatoire sur la modification d'identité",
  identityPolicyToggleDescription:
    "Actif : toute modification d'un champ identifiant (nom, prénom, date de naissance, numéro de pièce, NNI, nationalité) exige un motif, refusée en 400 sinon. Inactif : le motif reste facultatif.",
  screeningPolicyPepTitle: "Blocage création sur hit PEP",
  screeningPolicyPepDescription:
    "Actif : un hit PEP Track A bloque la création du client jusqu'à EDD 4-yeux APPROVED.",
  screeningPolicyHighTitle: "Blocage création sur scoring HIGH",
  screeningPolicyHighDescription:
    "Actif : un scoring Track A = HIGH bloque la création et ouvre une revue L1 (soft-gate).",
  screeningPolicyVneuroneModeLabel: "Mode VNeurone",
  screeningPolicyProviderLabel: "Provider AML actif",
  secretEncryptionTitle: "Chiffrement de secret",
  secretEncryptionDescription:
    "Transforme une valeur en clair au format ENC(...) attendu par les .properties et les secrets Kubernetes, pour une rotation de clé.",
  secretEncryptionInputLabel: "Valeur en clair",
  secretEncryptionInputPlaceholder: "Coller la valeur à chiffrer",
  secretEncryptionButton: "Chiffrer",
  secretEncryptionOutputLabel: "Valeur chiffrée",
  secretEncryptionCopy: "Copier",
  secretEncryptionCopied: "Copié dans le presse-papiers",
  secretEncryptionError: "Échec du chiffrement. Réessayez.",
  customerPurgeTitle: "Purge client",
  customerPurgeDescription:
    "Supprime entièrement un client (base, identité Keycloak, objets MinIO) pour rejouer un test avec la même pièce et le même numéro. Irréversible.",
  customerPurgeBusinessKeyLabel: "BusinessKey du client",
  customerPurgeBusinessKeyPlaceholder: "Ex. aaa0087",
  customerPurgeButton: "Purger",
  customerPurgeConfirmTitle: "Confirmer la purge",
  customerPurgeConfirmDescription:
    "Cette action est irréversible : toutes les données du client seront supprimées.",
  customerPurgePasswordLabel: "Votre mot de passe",
  customerPurgePasswordPlaceholder: "Mot de passe",
  customerPurgeConfirmButton: "Confirmer la purge",
  customerPurgeSuccess: "Client purgé.",
  customerPurgeError: "Échec de la purge. Vérifiez le businessKey et votre mot de passe.",
  customerPurgeUnlockButton: "Déverrouiller",
  customerPurgeLockedHint: "Saisissez votre mot de passe pour déverrouiller cette zone.",
  customerPurgeBusinessKeyInvalid: "Format attendu : 3 lettres + 4 chiffres, ex. aaa0087.",

  agences: "Agences",
  agencesDescription: "Référentiel des agences - lecture seule.",
  agenceCode: "Code",
  agenceName: "Nom",
  agenceCity: "Ville",
  agenceAddress: "Adresse",
  agenceContact: "Contact",
  agenceCoordinates: "Coordonnées",
  agenceHours: "Horaires",
  agenceHoursOrdinary: "Semaine",
  agenceHoursSaturday: "Samedi",
  agenceHoursSunday: "Dimanche",
  agenceEmptyState: "Aucune agence trouvée.",
  agenceLoadError: "Impossible de charger le référentiel des agences.",
  subscriptionChannel: "Canal de souscription",
  ent360Identity: "Identité de l'entreprise",
  ent360Representatives: "Représentants légaux",
  ent360Beneficiaries: "Bénéficiaires effectifs",
  ent360NoData: "Aucune donnée",
  ent360Declarant: "Déclarant",
  ent360Documents: "Pièces du dossier",
  ent360Completeness: "Complétude",
  kybTabOverview: "Vue d'ensemble",
  kybTabCompany: "Entreprise",
  kybTabPeople: "Personnes",
  kybTabCompliance: "Conformité",
  kybTabDocuments: "Pièces",
  kybTabAccess: "Mandats et accès",
  kybTabHistory: "Historique et preuves",
  kybGuideOverview: "Où en est le dossier : les étapes du parcours, l'ouverture du client et du compte au CBS, et les comptes ouverts. Commencez ici pour savoir quoi faire ensuite.",
  kybGuideCompany: "Identité, coordonnées et données financières de l'entreprise, telles que transmises au CBS à l'ouverture du compte.",
  kybGuidePeople: "Les représentants légaux et les bénéficiaires effectifs du dossier, avec le résultat de leur criblage.",
  kybGuideCompliance: "Le travail de conformité : instruction, correspondances de criblage à qualifier, validation de niveau 1 et décision finale.",
  kybGuideDocuments: "Les pièces exigées pour cette forme juridique et ce pays, et leur état : attendue, reçue, validée ou expirée.",
  kybGuideAccess: "Qui peut agir pour l'entreprise : mandats, accès à la banque en ligne et grilles de signature.",
  kybGuideHistory: "La trace de tout ce qui s'est passé sur le dossier et le dossier de preuve exportable pour l'inspection.",
  kybEditStep: "Modifier",
  kybEditLocked: "Modifiable avant la soumission, ou lorsqu'un complément est demandé au client.",
  kybDocsRequired: "Obligatoire",
  kybDocsOptional: "Facultative",
  kybScreeningPerson: "Criblage",
  kybAccountsTitle: "Comptes ouverts",
  kybScreenMatch: "Correspondance confirmée",
  kybScreenToQualify: "À qualifier",
  kybScreenNoMatch: "Aucune correspondance",
  kybScreenFailed: "Criblage en échec",
  kybScreenNotScreened: "Non criblé",
  kybScreenPending: "En attente du référentiel",
  kybSummaryTitle: "Synthèse de conformité",
  kybSummaryReassure: "Le criblage sanctions et PEP a été exécuté sur l'entreprise et ses personnes. Aucune correspondance ne demande de décision.",
  kybSummaryAttention: "Des points restent ouverts sur ce dossier.",
  kybSummaryEntityScreening: "Criblage de l'entreprise",
  kybSummaryPeopleScreening: "Criblage des personnes",
  kybSummaryBeneficiaries: "Bénéficiaires effectifs vérifiés",
  kybSummaryStructure: "Structure de détention lisible",
  kybSummaryDocuments: "Pièces du dossier complètes",
  kybSummaryInstruction: "Instruction",
  kybSummaryL1: "Validation de niveau 1",
  kybSummaryDecision: "Décision",
  kybSummaryDone: "Fait",
  kybSummaryTodo: "À faire",
  kybDocsCompany: "Pièces de l'entreprise",
  kybDocsPeople: "Pièces des personnes physiques",
  kybPiecePreview: "Aperçu",
  kybPieceReplace: "Remplacer",
  kybPieceReopen: "Remettre en attente",
  kybPieceReopened: "Pièce remise en attente : elle peut être redéposée.",
  kybPieceReopenFailed: "La pièce n'a pas pu être remise en attente.",
  kybComplementDeposit: "Déposer la pièce",
  kybComplementDepositValidated: "Cette pièce est déjà validée : remettez-la en attente depuis la liste des pièces avant d'en déposer une nouvelle.",
  kybDocsAwaitedNote: "pièce(s) demandée(s) au client en attente (hors complétude ci-dessus) :",
  kybDocsCompletenessRequired: "Complétude des pièces obligatoires",
  kybDocsOptionalPending: "pièce(s) facultative(s) non validée(s), sans effet sur la complétude :",
  kybPieceDeposit: "Déposer",
  kybPiecePreviewTitle: "Aperçu du document",
  kybPiecePreviewLoading: "Chargement du document…",
  kybPiecePreviewUnavailable: "Aperçu indisponible pour ce document : ouvrez le fichier dans un nouvel onglet.",
  kybPieceOpenNewTab: "Ouvrir dans un nouvel onglet",
  kybPieceValidated: "Pièce validée.",
  kybProofsTitle: "Preuves de vérification",
  kybProofsEmpty: "Aucune preuve déposée : une immatriculation vérifiée en porte une.",
  kybProofsDecidedBy: "Décidée par",
  kybPieceDepositDone: "Pièce enregistrée.",
  kybPieceDepositFailed: "Le dépôt a échoué, réessayez.",
  kybMaMandates: "Mandats",
  kybMaAccess: "Accès à la banque en ligne",
  kybMaGrids: "Grilles de signature",
  kybMaManage: "Gérer",
  kybMaEmpty: "Aucun pour le moment",
  kybMaMandatesHelp: "Qui peut engager l'entreprise, jusqu'à quel plafond.",
  kybMaAccessHelp: "Qui se connecte à la banque en ligne au nom de l'entreprise.",
  kybMaGridsHelp: "Combien de signatures par type d'opération et par montant.",
  kybCbsStepApproved: "Dossier approuvé",
  kybCbsStepSent: "Envoyé au CBS",
  kybCbsStepCreated: "Client et compte créés",
  kybCbsOpenedToast: "Le compte a été ouvert au CBS : le client et son numéro de compte sont créés.",
  kybCbsAccountNumber: "Numéro de compte",
  kybEditLockedStatus: "Le dossier est « {status} » : il se modifie avant sa soumission, ou quand la conformité demande un complément au client. Dossier créé par {author}.",
  kybEditLockedRight: "Réservé aux agents habilités à créer et corriger les dossiers d'entreprise.",
  uboPhLastName: "Ex : KOUASSI",
  uboPhFirstName: "Ex : Awa",
  uboPhDenomination: "Ex : HOLDING AFRIQUE SA",
  uboPhRegistration: "Ex : CI-ABJ-2020-B-12345",
  uboPhPercentage: "Ex : 25",
  uboPhControlBasis: "Ex : pouvoir de nommer la majorité des dirigeants",
  uboPhFallback: "Ex : aucune personne ne détient plus de 25 % ni ne contrôle l'entreprise",
  uboPhOwner: "Choisir le détenteur",
  uboPhCountry: "Choisir un pays",
  uboPhLegalForm: "Choisir une forme juridique",
  uboPhLegalFormFirst: "Choisir d'abord le pays",
  uboPhNationality: "Choisir une nationalité",
  uboPhDirector: "Choisir le dirigeant",
  documentFreeOtherPlaceholder: "Ex : Attestation d'assurance",
  documentChecklistProgress: "pièces obligatoires en règle",
  kybGuardBeneficialOwnerNotVerified: "Un bénéficiaire effectif n'est pas vérifié : vérifiez-le à l'étape « Actionnariat & UBO » avant d'approuver.",
  kybVerifyButton: "Vérifier",
  kybVerifyTitle: "Vérifier cette personne",
  kybVerifyHelp: "Confrontez la personne à un acte : elle sera marquée vérifiée, avec votre nom et la date. Tant qu'un bénéficiaire effectif n'est pas vérifié, le dossier ne peut pas être approuvé.",
  kybVerifySource: "Acte invoqué",
  kybVerifySourcePlaceholder: "Choisir ou saisir l'acte",
  kybVerifySourceStatutes: "Statuts de la société",
  kybVerifySourceRegister: "Registre des actionnaires",
  kybVerifySourceMinutes: "PV d'assemblée",
  kybVerifySourceRccm: "Extrait RCCM",
  kybVerifyConfirm: "Confirmer la vérification",
  kybVerifyDone: "Personne vérifiée.",
  kybVerified: "Vérifié",
  kybNotVerified: "Non vérifié",
  kybVerifiedBy: "par",
  kybDetailProvider: "Fournisseur",
  kybDetailReference: "Référence",
  kybDetailCaseReference: "Dossier chez le fournisseur",
  kybDetailResult: "Résultat",
  kybDetailScreenedAt: "Criblé le",
  kybDetailReport: "Rapport de criblage",
  kybDetailDownload: "Télécharger",
  kybDetailNotScreened: "Pas encore criblée",
  kybDetailBy: "Par",
  kybDetailOn: "Le",
  kybDetailNotes: "Notes d'instruction",
  kybDetailHitConclusions: "Conclusions sur les correspondances",
  kybDetailAssignee: "Analyste assigné",
  kybDetailHistory: "Voir l'historique complet",
  kybDetailOpenCase: "Étape de l'assistant à corriger",
  kybDetailToggle: "Afficher le détail",
  kybDetailNone: "Aucun élément à détailler",
  kybDetailVerifyHint: "À vérifier dans l'onglet Personnes.",
  kybDetailOpaque: "Un indicateur d'opacité recommande un examen renforcé.",
  kybDetailTransparent: "Aucun indicateur d'opacité relevé.",
  kybSummaryEdd: "Diligence renforcée (EDD)",
  kybSummaryDocumentsAwaited: "attendue(s) du client :",
  kybNextAwaitingClientNamed: "Pièces attendues du client (resoumettez le dossier une fois reçues) :",
  kybNextAssign: "Désignez l'instructeur qui reprend le dossier : il instruit, un autre responsable valide ensuite.",
  kybNextGoAssign: "Désigner",
  kybNextResubmit: "Les pièces demandées sont arrivées : resoumettez le dossier pour reprendre l'instruction, les pièces se contrôlent ensuite.",
  kybNextResubmitButton: "Resoumettre le dossier",
  kybDocsControlAfterResubmit: "Les pièces reçues se contrôlent une fois le dossier resoumis : l'instruction est suspendue tant qu'il attend le client.",
  kybSummaryEddNotRequired: "Non requise",
  kybSummaryEddRequired: "Requise : le motif figure dans le risque de l'entreprise",
  kybSummaryEddRequiredBecause: "Requise :",
  kybSummaryEddDecided: "Clôturée, risque",
  kybEddUpgraded: "relevé",
  kybEddMaintained: "maintenu",
  kybEddDowngraded: "abaissé",
  kybRiskTitle: "Risque de l'entreprise",
  kybRiskHelp: "Calculé sur cinq déterminants propres à l'entreprise ; chaque ligne dit pourquoi. Une correspondance confirmée, un pays sanctionné ou à risque, ou une structure opaque forcent le niveau élevé.",
  kybRiskScore: "Score",
  kybRiskWeight: "Poids",
  kybRiskLow: "Risque faible",
  kybRiskStandard: "Risque standard",
  kybRiskHigh: "Risque élevé",
  kybRiskLevelRF: "Faible",
  kybRiskLevelRM: "Modéré",
  kybRiskLevelRE: "Élevé",
  kybRiskOverrides: "Niveau élevé imposé par",
  kybRiskEddRequired: "EDD exigé avant approbation",
  kybRiskEddOpen: "Traiter l'EDD",
  kybRiskOpenCase: "Ouvrir le dossier KYB",
  kybRiskLoadError: "Impossible de calculer le risque de l'entreprise.",
  kybEddKybCardTitle: "Dossier KYB de l'entreprise",
  kybEddKybCardHelp: "Pourquoi l'EDD est exigé, et où se traitent les personnes, pièces et criblages de l'entreprise.",
  kybDetCompany: "Entreprise",
  kybSummaryPeopleClear: "sans correspondance",
  kybScreenPep: "PEP confirmé",
  kybScreenSanction: "Sanction confirmée",
  kybScreenMatchUnknown: "Correspondance confirmée (nature non précisée)",
  kybScreenHomonyms: "homonymes écartés par le fournisseur",
  kybScreenRetained: "Profil retenu par le fournisseur",
  kybScreenWhy: "Le fournisseur a comparé le nom, la date de naissance et la nationalité du dossier ; il retient ce profil et écarte les homonymes.",
  kybScreenNoProfile: "Aucun profil détaillé n'a été conservé pour ce criblage.",
  kybScreenToggle: "Voir le profil retenu",
  kybEddDocsInKyb: "Les pièces de l'entreprise et de ses personnes se consultent et se complètent dans le dossier KYB : ne les redemandez pas ici.",
  kybEddScreeningInKyb: "Criblage des personnes",
  kybAccountRequested: "Compte demandé",
  kybAccountRequestedHelp: "Le produit choisi à la création du dossier. Le compte n'existe pas encore : il est ouvert au CBS, avec son numéro, à l'approbation du dossier.",
  kybAccountToOpen: "À ouvrir à l'approbation",
  kybDetailReportPdf: "Rapport PDF",
  kybDetailReportError: "Impossible de produire le rapport de criblage.",
  kybVerifyProof: "Pièce justificative",
  kybVerifyProofHelp: "Joignez l'acte lui-même (PDF ou image) : la vérification sans pièce n'est pas acceptée.",
  kybRiskCfgTab: "Risque des entreprises",
  kybRiskCfgTitle: "Règle de risque d'une entreprise",
  kybRiskCfgIntro: "Le risque d'une entreprise est la moyenne pondérée de cinq déterminants notés de 1 à 3. Les poids et les seuils se règlent ici ; les valeurs par pays et par secteur se règlent dans l'onglet des entités. Une correspondance confirmée, un pays sanctionné ou une structure opaque imposent toujours le niveau élevé, quels que soient ces réglages.",
  kybRiskCfgReferentialLink: "Modifier les valeurs par pays et par secteur",
  kybRiskCfgWeights: "Poids des déterminants",
  kybRiskCfgTotal: "Total",
  kybRiskCfgCountry: "Pays d'immatriculation",
  kybRiskCfgCountryHelp: "Risque du pays où l'entreprise est immatriculée.",
  kybRiskCfgSector: "Secteur d'activité",
  kybRiskCfgSectorHelp: "Risque du secteur déclaré ; inconnu vaut modéré.",
  kybRiskCfgStructure: "Complexité de la structure",
  kybRiskCfgStructureHelp: "Opacité de la chaîne de détention du capital.",
  kybRiskCfgOwners: "Pays des bénéficiaires effectifs",
  kybRiskCfgOwnersHelp: "Pays le plus exposé parmi les bénéficiaires.",
  kybRiskCfgScreening: "Résultat du criblage",
  kybRiskCfgScreeningHelp: "Correspondance PEP ou sanction, ou criblage propre.",
  kybRiskCfgThresholds: "Seuils des classes",
  kybRiskCfgThresholdsHelp: "Score de 1 à 3. En dessous du premier seuil : faible ; jusqu'au second : standard ; au-delà : élevé.",
  kybRiskCfgLowMax: "Faible jusqu'à",
  kybRiskCfgStandardMax: "Standard jusqu'à",
  kybRiskCfgThresholdsInvalid: "Les seuils doivent être compris entre 1,00 et 3,00, le premier strictement inférieur au second.",
  kybRiskCfgReason: "Motif de la modification",
  kybRiskCfgReasonPlaceholder: "Ex. : revue annuelle du comité conformité",
  kybRiskCfgReasonHelp: "10 caractères au moins. Conservé dans l'historique ; les risques déjà figés à une décision ne changent pas.",
  kybRiskCfgSave: "Enregistrer",
  kybRiskCfgSaved: "Règle de risque enregistrée.",
  kybRiskCfgSaveError: "La règle de risque n'a pas pu être enregistrée.",
  kybRiskCfgLoadError: "La règle de risque n'a pas pu être chargée.",
  kybRiskCfgRetry: "Réessayer",
  kybRiskCfgHistory: "Historique des modifications",
  kybRiskCfgNoHistory: "Aucune modification : la règle par défaut s'applique.",
  kybRiskFrozenTitle: "Risque au moment de la décision",
  kybRiskFrozenChanged: "Le calcul actuel diffère de celui qui a fondé la décision.",
  kybInstructionHeadOfficeTag: "Siège",
  kybInstructionReadyConditions: "Conditions pour passer à la validation",
  kybInstructionReadyCondInstruction: "Une instruction est consignée (une note, ou une conclusion sur un hit)",
  kybInstructionReadyCondPieces: "Aucune pièce obligatoire ne manque",
  kybInstructionReadyBlocked: "Complétez les conditions ci-dessus pour marquer le dossier prêt.",
  kybComplementTitle: "Pièces demandées au client",
  kybComplementReceived: "Reçue",
  kybComplementWaiting: "En attente de dépôt",
  kybComplementFree: "À vérifier par l'analyste",
  kybInstructionReadyCondComplement: "Les pièces réclamées au client sont arrivées",
  uboRequiredLegend: "Champ obligatoire",
  uboHoldersTitle: "Détenteurs",
  uboNoLegalDetails: "Pays et immatriculation à compléter",
  uboHoldersDesc: "Les personnes et les sociétés qui détiennent ou contrôlent l'entreprise, directement ou par une société interposée.",
  uboHoldersEmpty: "Aucun détenteur pour l'instant.",
  uboHoldersEmptyHint: "Ajoutez une personne physique ou une société interposée pour commencer.",
  uboAddPersonCta: "Ajouter une personne physique",
  uboAddLegalCta: "Ajouter une société interposée",
  uboAddEdgeCta: "Ajouter un lien de détention",
  uboDialogAdd: "Ajouter",
  uboDialogPersonTitle: "Ajouter une personne physique",
  uboDialogPersonDesc: "Une personne qui détient une part de l'entreprise ou d'une société interposée, ou qui la contrôle. Vous la relierez ensuite à ce qu'elle détient.",
  uboDialogLegalTitle: "Ajouter une société interposée",
  uboDialogLegalDesc: "Une société qui se place entre l'entreprise et ses détenteurs : elle détient une part de l'entreprise, et d'autres la détiennent à leur tour.",
  uboDialogEdgeTitle: "Ajouter un lien de détention",
  uboDialogEdgeDesc: "Dites qui détient quoi : une personne ou une société détient une part de l'entreprise, ou d'une société interposée.",
  uboFormErrorsBanner: "Corrigez les champs signalés en rouge.",
  uboFieldRequired: "Ce champ est obligatoire",
  uboBirthDateFuture: "La date de naissance ne peut pas être dans le futur",
  uboPercentHint: "Entre 0 et 100, trois décimales au plus (ex. 25 ou 12,5)",
  uboPercentRange: "Le pourcentage doit être supérieur à 0 et ne pas dépasser 100",
  uboPercentFormat: "Saisissez un nombre, avec trois décimales au plus (ex. 25 ou 12,5)",
  uboPercentOverTotal: "Le total dépasserait 100 % : il reste",
  uboEdgeSelfOwned: "Une société ne peut pas se détenir elle-même",
  uboEdgeDuplicate: "Ce lien existe déjà : retirez-le avant de le recréer",
  uboCapacityAllocated: "Déjà réparti",
  uboCapacityRemaining: "Reste à répartir",
  uboEdgesDesc: "Qui détient quoi, avec la part de chacun. Pour un même détenu, le total du capital (ou des droits de vote) ne peut pas dépasser 100 %.",
  uboEdgesNeedHolder: "Ajoutez d'abord un détenteur : un lien relie deux parties.",
  uboAnalysisDesc: "Calculés à partir des liens ci-dessus ; relancez le calcul après une modification.",
  uboSummaryHolders: "Détenteurs",
  uboSummaryLinks: "Liens de détention",
  uboSummaryOwners: "Bénéficiaires effectifs",
  uboBornOn: "Né(e) le",
  uboNoIdentityDetails: "Identité à compléter (date de naissance, nationalité)",
  kybClosureTitle: "Clôturer le dossier",
  kybClosureHelp: "Le dossier est rejeté. Clôturer est définitif : il n'y a plus rien à instruire et le dossier ne peut pas être rouvert. Le motif est conservé dans l'historique.",
  kybClosureReasonLabel: "Motif de la clôture",
  kybClosureReasonRequired: "Le motif de la clôture est obligatoire.",
  kybClosureAction: "Clôturer le dossier",
  kybClosureDone: "Dossier clôturé.",
  kybMaNoneLive: "Aucun en vigueur",
  kybMaAndMore: "et {count} autres : voir dans Gérer",
  kybMandateFilterLive: "En vigueur",
  kybMandateNonClientHelp: "cela n'empêche pas le mandat : son contact vient de la personne liée du dossier",
  kybMandateSectionPower: "Pouvoir",
  kybMandateSectionPeriod: "Période",
  kybMandateSectionTrail: "Suivi",
  kybDelegationExplain: "Déléguer : le mandataire confie une partie de ses pouvoirs à une autre personne du dossier, pour une durée courte et bornée, avec un plafond au plus égal au sien. La délégation reste sans effet tant que la conformité ne l'a pas validée, et elle s'arrête avec le mandat.",
  kybAccessTallyActive: "actifs",
  kybAccessTallyPending: "en attente de création",
  kybAccessTallySuspended: "suspendus",
  kybAccessUsersTitle: "Utilisateurs et accès",
  kybAccessWithoutHelp: "Ces mandats sont en vigueur mais n'ont pas encore de compte de banque en ligne : créez l'accès pour que le mandataire puisse se connecter.",
  kybAccessShowSuspended: "Afficher les {count} accès suspendus",
  kybAccessHideSuspended: "Masquer les accès suspendus",
  kybAccessColUser: "Utilisateur",
  kybAccessColActions: "Actions",
  kybCurrencyPlaceholder: "Choisir une devise",
  kybSelectPlaceholder: "Choisir dans la liste",
  kybAmountPlaceholder: "Ex. : 5 000 000",
  kybGridMaxPlaceholder: "Vide = sans limite",
  kybMandatePerimeterPlaceholder: "Ex. : Compte courant principal : virements et retraits",
  kybRevokeCommentPlaceholder: "Ex. : fin de fonction du mandataire, acte joint au dossier",
  kybProfileOperationPlaceholder: "Choisir une opération",
  kybProfileLimitPlaceholder: "Plafond, ex. : 5 000 000",
  kybProfileAccountsPlaceholder: "Un numéro de compte par ligne, ex. : 08688603234",
  kybProfileCountryPlaceholder: "Ajouter un pays",
  kybGridRangeBelow: "Moins de {max}",
  kybGridRangeBetween: "De {min} à moins de {max}",
  kybGridRangeFrom: "À partir de {min}",
  kybGridColAmount: "Montant de l'opération",
  kybGridColRequired: "Signatures requises",
  kybGridSignatureOne: "signature",
  kybGridSignaturesMany: "signatures",
  kybGridShowHistory: "Afficher l'historique des grilles archivées ({count})",
  kybGridHideHistory: "Masquer l'historique",
  kybAccessIntro: "Un accès corporate est le droit, pour un mandataire, de se connecter à la banque en ligne au nom de l'entreprise. Il découle d'un mandat : un mandat, un accès. Le profil de droits fixe ce que le mandataire peut y faire (comptes, opérations, plafonds, pays, devises).",
  kybAccessStatActive: "Actifs",
  kybAccessStatActiveHelp: "Le compte de banque en ligne existe et est confirmé : le mandataire peut se connecter, dans les limites de son profil.",
  kybAccessStatPending: "En cours de création",
  kybAccessStatPendingHelp: "Le compte de banque en ligne est en préparation : identifiant créé, e-mail d'activation envoyé. Tant qu'il n'est pas confirmé, il ne donne aucun droit. Si cela dure, vérifiez l'e-mail et le téléphone du mandataire, puis actualisez.",
  kybAccessStatSuspended: "Suspendus",
  kybAccessStatSuspendedHelp: "L'accès est coupé : le mandat a pris fin (expiré ou révoqué) ou la recertification périodique n'a pas été faite. Il se rétablit avec un mandat en vigueur ou une recertification.",
  kybAccessUserDeactivatedHelp: "Compte de banque en ligne désactivé : une réactivation validée par P4 est requise.",
  kybGridAllAmounts: "Tous les montants",
  kybGridTiersTitle: "Paliers de signatures",
  kybGridTiersHelp: "Chaque palier commence là où le précédent s'arrête ; le premier commence à 0. Laissez « jusqu'à » vide sur le dernier : il n'a pas de limite.",
  kybGridToValidate: "Grille proposée",
  kybGridReplaced: "Grille actuellement en vigueur",
  kybGridActivateArchives: "Elle sera archivée dès la validation de la grille proposée.",
  kybGridActivateFirst: "Aucune grille n'est en vigueur pour cette opération et cette devise : la grille proposée sera la première.",
  kybRecertSettingLead: "Chaque accès corporate actif doit être reconfirmé régulièrement. Voici le calendrier appliqué : quand la tâche s'ouvre, à quelle fréquence, et ce qui se passe si personne ne décide.",
  kybRecertStepNoticeUnit: "jours de préavis",
  kybRecertStepNoticeText: "La tâche de recertification s'ouvre ce nombre de jours avant l'échéance de l'accès.",
  kybRecertStepPeriodUnit: "mois entre deux recertifications",
  kybRecertStepPeriodText: "Chaque accès actif est à reconfirmer à cette fréquence : le responsable le certifie, ou le révoque.",
  kybRecertStepGraceUnit: "jours de grâce",
  kybRecertStepGraceText: "Après l'échéance, sans décision dans ce délai, l'accès est suspendu automatiquement.",
  kybRecertEmptyPendingTitle: "Rien à recertifier pour le moment",
  kybRecertEmptyTitle: "Aucune décision dans cette vue",
  kybRecertEmptyPendingText: "Une tâche s'ouvre {notice} jours avant l'échéance de {period} mois de chaque accès actif. Elle apparaîtra ici dès que ce sera le cas.",
  kybAccessCreateBlockedDeactivated: "Réactivez d'abord l'utilisateur (validation P4), dans le tableau ci-dessous.",
  kybRetentionRuleYearsUnit: "ans de conservation",
  kybRetentionRuleYearsText: "Chaque dossier KYB est conservé 10 ans : c'est l'obligation légale. L'échéance est la date où cette durée prend fin.",
  kybRetentionRuleManualTitle: "Jamais de suppression automatique",
  kybRetentionRuleManualText: "À l'échéance, le responsable conformité décide : prolonger la conservation, geler le dossier (gel légal) ou demander sa suppression.",
  kybRetentionRuleSignaturesUnit: "signatures pour supprimer",
  kybRetentionRuleSignaturesText: "Une suppression n'a lieu qu'avec l'accord de deux personnes distinctes : la première la demande, la seconde l'autorise.",
  kybRetentionEmptyTitle: "Aucun dossier n'arrive à échéance dans les {days} jours",
  kybRetentionEmptyText: "Les dossiers apparaissent ici quand leur échéance de conservation approche ou est dépassée. Rien n'est à décider tant que la liste est vide.",
  kybRetentionSeeFurther: "Voir les {days} prochains jours",
  kybMandateFieldOperations: "Opérations couvertes",
  kybOptional: "facultatif",
  kybPerimeterActionFailed: "L'opération n'a pas abouti.",
  kybPerimeterActivate: "Activer",
  kybPerimeterActivateCountryEffect: "Votre signature autorise l'ouverture de dossiers KYB pour ce pays, avec les formes juridiques déjà activées.",
  kybPerimeterActivateCountryTitle: "Activer ce pays",
  kybPerimeterActivateFormEffect: "Votre signature permet d'ouvrir des dossiers KYB pour cette forme dans ce pays.",
  kybPerimeterActivateFormTitle: "Activer cette forme juridique",
  kybPerimeterActivateRequirementEffect: "Votre signature rend cette pièce exigée dans les nouveaux dossiers concernés.",
  kybPerimeterActivateRequirementTitle: "Activer cette exigence",
  kybPerimeterCancel: "Annuler",
  kybPerimeterCasesAllowed: "Dossiers KYB ouvrables",
  kybPerimeterColActions: "Actions",
  kybPerimeterColBasis: "Norme appliquée (loi, article)",
  kybPerimeterColForm: "Forme juridique",
  kybPerimeterColLegalBase: "Texte applicable",
  kybPerimeterColObligation: "Caractère",
  kybPerimeterColPiece: "Pièce",
  kybPerimeterColPublishedAt: "Publiée le",
  kybPerimeterColQuantity: "Exemplaires",
  kybPerimeterColState: "État",
  kybPerimeterColUbo: "Bénéficiaires effectifs",
  kybPerimeterColVersion: "Version",
  kybPerimeterCountries: "Pays",
  kybPerimeterCountryActivated: "Pays activé",
  kybPerimeterCountryDeactivated: "Pays désactivé",
  kybPerimeterCountryOpened: "Pays ouvert en brouillon",
  kybPerimeterCountryReferences: "Références du pays",
  kybPerimeterCountryRequired: "Choisissez le pays à ouvrir.",
  kybPerimeterCountryState: "État du pays",
  kybPerimeterDeactivate: "Désactiver",
  kybPerimeterDeactivateCountryEffect: "Plus aucun dossier KYB ne pourra être ouvert pour ce pays. Les dossiers déjà ouverts gardent leur version et continuent.",
  kybPerimeterDeactivateCountryTitle: "Désactiver ce pays",
  kybPerimeterDeactivateFormEffect: "Les nouveaux dossiers ne pourront plus choisir cette forme. Les dossiers déjà ouverts continuent.",
  kybPerimeterDeactivateFormTitle: "Désactiver cette forme juridique",
  kybPerimeterDeleteDraft: "Supprimer le brouillon",
  kybPerimeterDeleteDraftEffect: "Le brouillon disparaît sans effet sur les dossiers : il n'avait pas été activé.",
  kybPerimeterDeleteDraftTitle: "Supprimer ce brouillon",
  kybPerimeterEdit: "Modifier",
  kybPerimeterResignWarning:
    "Cette ligne est active. L'enregistrer la repasse en brouillon : elle ne s'appliquera plus aux nouveaux dossiers tant qu'elle n'est pas réactivée sous une nouvelle signature du responsable conformité.",
  kybPerimeterFieldBasis: "Base réglementaire",
  kybPerimeterFieldCentif: "CENTIF nationale",
  kybPerimeterFieldComment: "Commentaire",
  kybPerimeterFieldCountry: "Pays",
  kybPerimeterFieldCountryPlaceholder: "Choisir un pays",
  kybPerimeterFieldForm: "Forme juridique",
  kybPerimeterFieldFormPlaceholder: "Choisir une forme",
  kybPerimeterFieldJustification: "Justification",
  kybPerimeterFieldLaw: "Législation sur les données",
  kybPerimeterFieldLegalBase: "Texte applicable",
  kybPerimeterFieldObligation: "Caractère",
  kybPerimeterFieldOrgans: "Organes de direction",
  kybPerimeterFieldPiece: "Pièce",
  kybPerimeterFieldPiecePlaceholder: "Choisir une pièce",
  kybPerimeterFieldQuantity: "Exemplaires minimum",
  kybPerimeterFieldRegistry: "Registre des entreprises",
  kybPerimeterFieldRepresentation: "Représentation légale",
  kybPerimeterFieldScope: "Portée",
  kybPerimeterFieldTax: "Autorité fiscale",
  kybPerimeterFieldThreshold: "Seuil de détention",
  kybPerimeterFieldUbo: "Bénéficiaires effectifs exigés",
  kybPerimeterFormActivated: "Forme activée",
  kybPerimeterFormAdd: "Ajouter une forme",
  kybPerimeterFormAddTitle: "Ajouter une forme juridique",
  kybPerimeterFormDeactivated: "Forme désactivée",
  kybPerimeterFormEditTitle: "Modifier la forme juridique",
  kybPerimeterFormInvalid: "Choisissez une forme et, si les bénéficiaires effectifs sont exigés, un seuil entre 1 et 100.",
  kybPerimeterFormsEmpty: "Aucune forme juridique n'est encore paramétrée pour ce pays.",
  kybPerimeterFormsSubtitle: "Seules les formes activées permettent d'ouvrir un dossier dans ce pays.",
  kybPerimeterFormsTitle: "Formes juridiques admises",
  kybPerimeterGuideIntro: "Tout se prépare en brouillon. Rien ne s'applique tant que le responsable conformité n'a pas signé l'activation.",
  kybPerimeterGuideStep1: "1. Ouvrir le pays",
  kybPerimeterGuideStep1Text: "Choisissez le pays et saisissez son régime : registre des entreprises, autorité fiscale, CENTIF et législation. Le responsable conformité l'active ensuite.",
  kybPerimeterGuideStep2: "2. Admettre les formes juridiques",
  kybPerimeterGuideStep2Text: "Seules les formes activées permettent d'ouvrir un dossier. Pour chacune, indiquez le texte applicable, les organes et le seuil des bénéficiaires effectifs. « Activer les brouillons » signe toutes les formes d'un coup.",
  kybPerimeterGuideStep3: "3. Définir les pièces",
  kybPerimeterGuideStep3Text: "Les défauts du pays valent pour toutes les formes ; une exigence propre à une forme remplace le défaut. Une pièce facultative est acceptée sans bloquer le dossier. Une exigence activée se désactive : elle repasse en brouillon.",
  kybPerimeterGuideStep4: "4. Publier la version",
  kybPerimeterGuideStep4Text: "La simulation montre ce que la publication change et ce qui l'empêche. La version publiée est celle des nouveaux dossiers.",
  kybPerimeterJourneyTitle: "Où en est ce pays",
  kybPerimeterJourneyNext: "Prochaine étape",
  kybPerimeterJourneyGo: "Ouvrir l'onglet",
  kybPerimeterJourneyDone: "Fait",
  kybPerimeterJourneyTodo: "À faire",
  kybPerimeterJourneyActiveLabel: "Activées",
  kybPerimeterJourneyDraftLabel: "En brouillon",
  kybPerimeterJourneyDisabledLabel: "Désactivées",
  kybPerimeterJourneyCountryActive: "Le pays est actif : les dossiers d'entreprise peuvent s'ouvrir.",
  kybPerimeterJourneyCountryNotActive: "Le pays n'est pas actif : aucun dossier ne peut s'ouvrir. Le responsable conformité l'active depuis l'onglet « Régime du pays ».",
  kybPerimeterJourneyFormsNone: "Aucune forme juridique n'est admise.",
  kybPerimeterJourneyDefaultsMissing: "Aucune pièce par défaut n'est active : la publication sera bloquée.",
  kybPerimeterJourneyVersionDraft: "Un brouillon de version est prêt : simulez-le puis publiez-le.",
  kybPerimeterJourneyVersionPublished: "Version publiée : n°",
  kybPerimeterJourneyVersionNone: "Aucune version publiée : créez un brouillon, simulez-le puis publiez-le.",
  kybPerimeterActivateDrafts: "Activer les brouillons",
  kybPerimeterTodoRegime: "Le pays n'est pas ouvert : aucun dossier d'entreprise ne peut s'y ouvrir. Ouvrez-le depuis le régime du pays.",
  kybPerimeterTodoFormsNone: "Aucune forme juridique admise : activez celles que la banque accepte (SARL, SA, GIE...).",
  kybPerimeterTodoFormsDraft: "forme(s) en brouillon. Un brouillon est une proposition pas encore en vigueur : il ne s'applique à aucun dossier. Activez-la pour l'admettre.",
  kybPerimeterTodoPiecesDefault: "Aucune pièce par défaut active : un dossier n'aurait aucune pièce exigée. Activez au moins une pièce par défaut.",
  kybPerimeterTodoPiecesDraft: "pièce(s) en brouillon. Un brouillon est une proposition pas encore en vigueur : il ne s'applique à aucun dossier. Activez-la pour l'exiger aux nouveaux dossiers (à la prochaine version publiée), ou supprimez-la si elle n'a plus lieu d'être.",
  kybPerimeterTodoVersionDraft: "Un brouillon de version est prêt : simulez ce qu'il changerait, puis publiez-le sous signature. C'est cette version que recevront les nouveaux dossiers.",
  kybPerimeterTodoVersionNone: "Aucune version publiée : créez un brouillon de version, simulez-le puis publiez-le. Sans version publiée, un nouveau dossier n'a aucune règle.",
  kybPerimeterDraftsExplainTitle: "pièce(s) en brouillon dans ce pays",
  kybPerimeterDraftsExplain: "Un brouillon est une proposition pas encore en vigueur : il ne s'applique à aucun dossier. Activé sous votre signature, il sera exigé des nouveaux dossiers dès la prochaine version publiée. Vous pouvez aussi le supprimer. Les brouillons de toutes les vues du pays sont comptés ici, même ceux que le tableau ci-dessous n'affiche pas.",
  kybPerimeterDraftSee: "Voir",
  kybPerimeterDraftsDialogList: "Pièces qui seront activées :",
  kybPerimeterActivateFormsTitle: "Activer les formes juridiques en brouillon",
  kybPerimeterActivateFormsEffect: "Votre signature active d'un coup les formes juridiques en brouillon de ce pays, telles que vous les voyez. Elles permettent d'ouvrir des dossiers dès que le pays est actif.",
  kybPerimeterActivateRequirementsTitle: "Activer les pièces exigées en brouillon",
  kybPerimeterActivateRequirementsEffect: "Votre signature active d'un coup les pièces en brouillon de ce pays listées ci-dessous, quelle que soit la vue où elles se trouvent. Elles s'appliqueront aux nouveaux dossiers à la prochaine publication de version, et restent sans effet tant qu'elle n'est pas faite.",
  kybPerimeterDraftsActivated: "Brouillons activés",
  kybPerimeterDeactivateRequirementTitle: "Désactiver cette exigence",
  kybPerimeterDeactivateRequirementEffect: "Votre signature retire cette pièce de la matrice : elle redevient un brouillon que vous pouvez modifier puis réactiver. Les dossiers en cours et les versions déjà publiées ne changent pas ; la matrice change à la prochaine publication.",
  kybPerimeterRequirementDeactivated: "Exigence désactivée",
  kybPerimeterGuideTitle: "Comment activer un pays",
  kybPerimeterHintActive: "Signé par le responsable conformité : cet élément s'applique.",
  kybPerimeterHintDisabled: "Retiré par le responsable conformité : les dossiers déjà ouverts gardent leur version.",
  kybPerimeterHintDraft: "Préparé mais pas encore signé : cet élément ne s'applique pas.",
  kybPerimeterHintSuspended: "Suspendu parce que le pays n'est plus actif dans le référentiel de la banque ; il ne se réactive pas à la main.",
  kybPerimeterJustificationRequired: "La justification est obligatoire.",
  kybPerimeterLoadError: "Le périmètre du KYB n'a pas pu être chargé.",
  kybPerimeterMenu: "Périmètre KYB",
  kybPerimeterNo: "Non",
  kybPerimeterNoCountry: "Aucun pays n'est encore ouvert au KYB.",
  kybPerimeterObligationOptional: "Facultative",
  kybPerimeterObligationRequired: "Obligatoire",
  kybPerimeterOpenCountry: "Ouvrir un pays",
  kybPerimeterOpenCountryTitle: "Ouvrir un pays au KYB",
  kybPerimeterPublishEffect: "Votre signature rend cette version active pour les nouveaux dossiers du pays. La version précédente est archivée.",
  kybPerimeterPublishTitle: "Publier cette version",
  kybPerimeterRequirementActivated: "Exigence activée",
  kybPerimeterRequirementAdd: "Ajouter une pièce",
  kybPerimeterRequirementAddTitle: "Ajouter une pièce exigée",
  kybPerimeterRequirementDeleted: "Brouillon supprimé",
  kybPerimeterRequirementEditTitle: "Modifier l'exigence",
  kybPerimeterRequirementInvalid: "Choisissez une pièce et un nombre d'exemplaires d'au moins 1.",
  kybPerimeterRequirementsDefaultsSubtitle: "Elles valent pour toutes les formes juridiques du pays, sauf exigence propre à une forme.",
  kybPerimeterRequirementsDefaultsTitle: "Pièces exigées par défaut",
  kybPerimeterRequirementsEmpty: "Aucune exigence dans cette portée.",
  kybPerimeterRequirementsFormSubtitle: "Une exigence ajoutée ici remplace le défaut du pays pour cette seule forme. Facultative, la pièce reste acceptée sans bloquer le dossier.",
  kybPerimeterRequirementsFormTitle: "Pièces propres à cette forme",
  kybPerimeterRetry: "Réessayer",
  kybPerimeterSaveDraft: "Enregistrer en brouillon",
  kybPerimeterSaved: "Enregistré en brouillon",
  kybPerimeterScopeDefaults: "Défauts du pays (toutes les formes)",
  kybPerimeterSearch: "Rechercher un pays",
  kybPerimeterSelectCountry: "Choisissez un pays dans la liste pour voir son régime, ses formes juridiques, ses pièces et ses versions.",
  kybPerimeterSignedBy: "Signé par",
  kybPerimeterSimulationAdded: "Ajouté",
  kybPerimeterSimulationBlocking: "La publication est bloquée :",
  kybPerimeterSimulationCurrent: "version en vigueur",
  kybPerimeterSimulationModified: "Modifié",
  kybPerimeterSimulationRemoved: "Retiré",
  kybPerimeterSimulationTitle: "Simulation de la version",
  kybPerimeterVersionCompare: "Voir les changements",
  kybPerimeterVersionDiscard: "Abandonner le brouillon",
  kybPerimeterDiscardTitle: "Abandonner ce brouillon de version",
  kybPerimeterDiscardEffect: "Le brouillon disparaît : il n'a jamais été publié et aucun dossier ne l'utilise, rien d'autre ne change. Vous pourrez en créer un nouveau quand vous voudrez.",
  kybPerimeterVersionDiscarded: "Brouillon de version abandonné",
  kybPerimeterComparisonTitle: "Changements de la version",
  kybPerimeterComparisonSince: "par rapport à la version",
  kybPerimeterComparisonNone: "Aucun changement de règles entre ces deux versions.",
  kybPerimeterComparisonFirst: "Première version : rien à comparer.",
  kybPerimeterSimulationUnchanged: "Aucun changement par rapport à la version en vigueur.",
  kybPerimeterStatusActive: "Actif",
  kybPerimeterStatusDisabled: "Désactivé",
  kybPerimeterStatusDraft: "Brouillon",
  kybPerimeterStatusSuspended: "Suspendu",
  kybPerimeterSubtitle: "Les pays où la banque ouvre des dossiers d'entreprise, les formes juridiques qu'elle admet, les pièces qu'elle exige et les versions de ce référentiel.",
  kybPerimeterTabForms: "Formes juridiques",
  kybPerimeterTabPieces: "Pièces exigées",
  kybPerimeterTabRegime: "Régime du pays",
  kybPerimeterTabVersions: "Versions",
  kybPerimeterTitle: "Périmètre du KYB",
  kybPerimeterVersionActive: "Publiée",
  kybPerimeterVersionArchived: "Archivée",
  kybPerimeterVersionCreateDraft: "Créer un brouillon",
  kybPerimeterVersionDraftCreated: "Brouillon de version créé",
  kybPerimeterVersionHintActive: "Version en vigueur pour les nouveaux dossiers.",
  kybPerimeterVersionHintArchived: "Ancienne version, conservée pour les dossiers qui l'ont utilisée.",
  kybPerimeterVersionHintDraft: "Version en préparation : elle n'est pas encore publiée.",
  kybPerimeterVersionPublish: "Publier",
  kybPerimeterVersionPublished: "Version publiée",
  kybPerimeterVersionSimulate: "Simuler la publication",
  kybPerimeterVersionsEmpty: "Aucune version publiée pour ce pays.",
  kybPerimeterVersionsSubtitle: "Un brouillon se simule puis se publie sous signature. La version publiée est celle des nouveaux dossiers ; les dossiers en cours gardent la leur.",
  kybPerimeterVersionsTitle: "Versions du référentiel",
  kybPerimeterYes: "Oui",
  kybPerimeterSnapshotForm: "Forme",
  kybPerimeterSnapshotPiece: "Pièce",
  kybPerimeterSnapshotDefaults: "défaut du pays",
  kybPerimeterSnapshotUbo: "bénéficiaires effectifs dès",
  kybPerimeterSnapshotCopies: "exemplaire(s)",
};

export default fr;
